/* eslint-disable */
var createModuleSha256 = (function () {
  var _scriptDir = typeof document !== 'undefined' && document.currentScript ? document.currentScript.src : undefined;

  return function (createModuleSha256) {
    createModuleSha256 = createModuleSha256 || {};

    var Module = typeof createModuleSha256 !== 'undefined' ? createModuleSha256 : {};

    var readyPromiseResolve, readyPromiseReject;

    Module['ready'] = new Promise(function (resolve, reject) {
      readyPromiseResolve = resolve;
      readyPromiseReject = reject;
    });

    if (!Object.getOwnPropertyDescriptor(Module['ready'], '_ComputeSHA256')) {
      Object.defineProperty(Module['ready'], '_ComputeSHA256', {
        configurable: true,
        get: function () {
          abort(
            'You are getting _ComputeSHA256 on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js',
          );
        },
      });
      Object.defineProperty(Module['ready'], '_ComputeSHA256', {
        configurable: true,
        set: function () {
          abort(
            'You are setting _ComputeSHA256 on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js',
          );
        },
      });
    }

    if (!Object.getOwnPropertyDescriptor(Module['ready'], '_malloc')) {
      Object.defineProperty(Module['ready'], '_malloc', {
        configurable: true,
        get: function () {
          abort(
            'You are getting _malloc on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js',
          );
        },
      });
      Object.defineProperty(Module['ready'], '_malloc', {
        configurable: true,
        set: function () {
          abort(
            'You are setting _malloc on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js',
          );
        },
      });
    }

    if (!Object.getOwnPropertyDescriptor(Module['ready'], '_free')) {
      Object.defineProperty(Module['ready'], '_free', {
        configurable: true,
        get: function () {
          abort(
            'You are getting _free on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js',
          );
        },
      });
      Object.defineProperty(Module['ready'], '_free', {
        configurable: true,
        set: function () {
          abort(
            'You are setting _free on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js',
          );
        },
      });
    }

    if (!Object.getOwnPropertyDescriptor(Module['ready'], '_sbrk')) {
      Object.defineProperty(Module['ready'], '_sbrk', {
        configurable: true,
        get: function () {
          abort(
            'You are getting _sbrk on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js',
          );
        },
      });
      Object.defineProperty(Module['ready'], '_sbrk', {
        configurable: true,
        set: function () {
          abort(
            'You are setting _sbrk on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js',
          );
        },
      });
    }

    if (!Object.getOwnPropertyDescriptor(Module['ready'], '_emscripten_stack_get_end')) {
      Object.defineProperty(Module['ready'], '_emscripten_stack_get_end', {
        configurable: true,
        get: function () {
          abort(
            'You are getting _emscripten_stack_get_end on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js',
          );
        },
      });
      Object.defineProperty(Module['ready'], '_emscripten_stack_get_end', {
        configurable: true,
        set: function () {
          abort(
            'You are setting _emscripten_stack_get_end on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js',
          );
        },
      });
    }

    if (!Object.getOwnPropertyDescriptor(Module['ready'], '_emscripten_stack_get_free')) {
      Object.defineProperty(Module['ready'], '_emscripten_stack_get_free', {
        configurable: true,
        get: function () {
          abort(
            'You are getting _emscripten_stack_get_free on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js',
          );
        },
      });
      Object.defineProperty(Module['ready'], '_emscripten_stack_get_free', {
        configurable: true,
        set: function () {
          abort(
            'You are setting _emscripten_stack_get_free on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js',
          );
        },
      });
    }

    if (!Object.getOwnPropertyDescriptor(Module['ready'], '_emscripten_stack_init')) {
      Object.defineProperty(Module['ready'], '_emscripten_stack_init', {
        configurable: true,
        get: function () {
          abort(
            'You are getting _emscripten_stack_init on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js',
          );
        },
      });
      Object.defineProperty(Module['ready'], '_emscripten_stack_init', {
        configurable: true,
        set: function () {
          abort(
            'You are setting _emscripten_stack_init on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js',
          );
        },
      });
    }

    if (!Object.getOwnPropertyDescriptor(Module['ready'], '_stackSave')) {
      Object.defineProperty(Module['ready'], '_stackSave', {
        configurable: true,
        get: function () {
          abort(
            'You are getting _stackSave on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js',
          );
        },
      });
      Object.defineProperty(Module['ready'], '_stackSave', {
        configurable: true,
        set: function () {
          abort(
            'You are setting _stackSave on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js',
          );
        },
      });
    }

    if (!Object.getOwnPropertyDescriptor(Module['ready'], '_stackRestore')) {
      Object.defineProperty(Module['ready'], '_stackRestore', {
        configurable: true,
        get: function () {
          abort(
            'You are getting _stackRestore on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js',
          );
        },
      });
      Object.defineProperty(Module['ready'], '_stackRestore', {
        configurable: true,
        set: function () {
          abort(
            'You are setting _stackRestore on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js',
          );
        },
      });
    }

    if (!Object.getOwnPropertyDescriptor(Module['ready'], '_stackAlloc')) {
      Object.defineProperty(Module['ready'], '_stackAlloc', {
        configurable: true,
        get: function () {
          abort(
            'You are getting _stackAlloc on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js',
          );
        },
      });
      Object.defineProperty(Module['ready'], '_stackAlloc', {
        configurable: true,
        set: function () {
          abort(
            'You are setting _stackAlloc on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js',
          );
        },
      });
    }

    if (!Object.getOwnPropertyDescriptor(Module['ready'], '___wasm_call_ctors')) {
      Object.defineProperty(Module['ready'], '___wasm_call_ctors', {
        configurable: true,
        get: function () {
          abort(
            'You are getting ___wasm_call_ctors on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js',
          );
        },
      });
      Object.defineProperty(Module['ready'], '___wasm_call_ctors', {
        configurable: true,
        set: function () {
          abort(
            'You are setting ___wasm_call_ctors on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js',
          );
        },
      });
    }

    if (!Object.getOwnPropertyDescriptor(Module['ready'], '_fflush')) {
      Object.defineProperty(Module['ready'], '_fflush', {
        configurable: true,
        get: function () {
          abort(
            'You are getting _fflush on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js',
          );
        },
      });
      Object.defineProperty(Module['ready'], '_fflush', {
        configurable: true,
        set: function () {
          abort(
            'You are setting _fflush on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js',
          );
        },
      });
    }

    if (!Object.getOwnPropertyDescriptor(Module['ready'], '___errno_location')) {
      Object.defineProperty(Module['ready'], '___errno_location', {
        configurable: true,
        get: function () {
          abort(
            'You are getting ___errno_location on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js',
          );
        },
      });
      Object.defineProperty(Module['ready'], '___errno_location', {
        configurable: true,
        set: function () {
          abort(
            'You are setting ___errno_location on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js',
          );
        },
      });
    }

    if (!Object.getOwnPropertyDescriptor(Module['ready'], '_emscripten_get_sbrk_ptr')) {
      Object.defineProperty(Module['ready'], '_emscripten_get_sbrk_ptr', {
        configurable: true,
        get: function () {
          abort(
            'You are getting _emscripten_get_sbrk_ptr on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js',
          );
        },
      });
      Object.defineProperty(Module['ready'], '_emscripten_get_sbrk_ptr', {
        configurable: true,
        set: function () {
          abort(
            'You are setting _emscripten_get_sbrk_ptr on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js',
          );
        },
      });
    }

    if (!Object.getOwnPropertyDescriptor(Module['ready'], '_emscripten_stack_get_base')) {
      Object.defineProperty(Module['ready'], '_emscripten_stack_get_base', {
        configurable: true,
        get: function () {
          abort(
            'You are getting _emscripten_stack_get_base on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js',
          );
        },
      });
      Object.defineProperty(Module['ready'], '_emscripten_stack_get_base', {
        configurable: true,
        set: function () {
          abort(
            'You are setting _emscripten_stack_get_base on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js',
          );
        },
      });
    }

    if (!Object.getOwnPropertyDescriptor(Module['ready'], 'onRuntimeInitialized')) {
      Object.defineProperty(Module['ready'], 'onRuntimeInitialized', {
        configurable: true,
        get: function () {
          abort(
            'You are getting onRuntimeInitialized on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js',
          );
        },
      });
      Object.defineProperty(Module['ready'], 'onRuntimeInitialized', {
        configurable: true,
        set: function () {
          abort(
            'You are setting onRuntimeInitialized on the Promise object, instead of the instance. Use .then() to get called back with the instance, see the MODULARIZE docs in src/settings.js',
          );
        },
      });
    }

    var moduleOverrides = {};

    var key;

    for (key in Module) {
      if (Module.hasOwnProperty(key)) {
        moduleOverrides[key] = Module[key];
      }
    }

    var arguments_ = [];

    var thisProgram = './this.program';

    var quit_ = function (status, toThrow) {
      throw toThrow;
    };

    var ENVIRONMENT_IS_WEB = true;

    var ENVIRONMENT_IS_WORKER = false;

    var ENVIRONMENT_IS_NODE = false;

    var ENVIRONMENT_IS_SHELL = false;

    if (Module['ENVIRONMENT']) {
      throw new Error(
        'Module.ENVIRONMENT has been deprecated. To force the environment, use the ENVIRONMENT compile-time option (for example, -s ENVIRONMENT=web or -s ENVIRONMENT=node)',
      );
    }

    var scriptDirectory = '';

    function locateFile(path) {
      if (Module['locateFile']) {
        return Module['locateFile'](path, scriptDirectory);
      }
      return scriptDirectory + path;
    }

    var read_, readAsync, readBinary, setWindowTitle;

    function logExceptionOnExit(e) {
      if (e instanceof ExitStatus) return;
      var toLog = e;
      if (e && typeof e === 'object' && e.stack) {
        toLog = [e, e.stack];
      }
      err('exiting due to exception: ' + toLog);
    }

    if (ENVIRONMENT_IS_SHELL) {
      if (
        (typeof process === 'object' && typeof require === 'function') ||
        typeof window === 'object' ||
        typeof importScripts === 'function'
      )
        throw new Error(
          'not compiled for this environment (did you build to HTML and try to run it not on the web, or set ENVIRONMENT to something - like node - and run it someplace else - like on the web?)',
        );
      if (typeof read != 'undefined') {
        read_ = function shell_read(f) {
          var data = tryParseAsDataURI(f);
          if (data) {
            return intArrayToString(data);
          }
          return read(f);
        };
      }
      readBinary = function readBinary(f) {
        var data;
        data = tryParseAsDataURI(f);
        if (data) {
          return data;
        }
        if (typeof readbuffer === 'function') {
          return new Uint8Array(readbuffer(f));
        }
        data = read(f, 'binary');
        assert(typeof data === 'object');
        return data;
      };
      readAsync = function readAsync(f, onload, onerror) {
        setTimeout(function () {
          onload(readBinary(f));
        }, 0);
      };
      if (typeof scriptArgs != 'undefined') {
        arguments_ = scriptArgs;
      } else if (typeof arguments != 'undefined') {
        arguments_ = arguments;
      }
      if (typeof quit === 'function') {
        quit_ = function (status, toThrow) {
          logExceptionOnExit(toThrow);
          quit(status);
        };
      }
      if (typeof print !== 'undefined') {
        if (typeof console === 'undefined') console = {};
        console.log = print;
        console.warn = console.error = typeof printErr !== 'undefined' ? printErr : print;
      }
    } else if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
      if (ENVIRONMENT_IS_WORKER) {
        scriptDirectory = self.location.href;
      } else if (typeof document !== 'undefined' && document.currentScript) {
        scriptDirectory = document.currentScript.src;
      }
      if (_scriptDir) {
        scriptDirectory = _scriptDir;
      }
      if (scriptDirectory.indexOf('blob:') !== 0) {
        scriptDirectory = scriptDirectory.substr(0, scriptDirectory.replace(/[?#].*/, '').lastIndexOf('/') + 1);
      } else {
        scriptDirectory = '';
      }
      if (!(typeof window === 'object' || typeof importScripts === 'function'))
        throw new Error(
          'not compiled for this environment (did you build to HTML and try to run it not on the web, or set ENVIRONMENT to something - like node - and run it someplace else - like on the web?)',
        );
      {
        read_ = function (url) {
          try {
            var xhr = new XMLHttpRequest();
            xhr.open('GET', url, false);
            xhr.send(null);
            return xhr.responseText;
          } catch (err) {
            var data = tryParseAsDataURI(url);
            if (data) {
              return intArrayToString(data);
            }
            throw err;
          }
        };
        if (ENVIRONMENT_IS_WORKER) {
          readBinary = function (url) {
            try {
              var xhr = new XMLHttpRequest();
              xhr.open('GET', url, false);
              xhr.responseType = 'arraybuffer';
              xhr.send(null);
              return new Uint8Array(xhr.response);
            } catch (err) {
              var data = tryParseAsDataURI(url);
              if (data) {
                return data;
              }
              throw err;
            }
          };
        }
        readAsync = function (url, onload, onerror) {
          var xhr = new XMLHttpRequest();
          xhr.open('GET', url, true);
          xhr.responseType = 'arraybuffer';
          xhr.onload = function () {
            if (xhr.status == 200 || (xhr.status == 0 && xhr.response)) {
              onload(xhr.response);
              return;
            }
            var data = tryParseAsDataURI(url);
            if (data) {
              onload(data.buffer);
              return;
            }
            onerror();
          };
          xhr.onerror = onerror;
          xhr.send(null);
        };
      }
      setWindowTitle = function (title) {
        document.title = title;
      };
    } else {
      throw new Error('environment detection error');
    }

    var out = Module['print'] || console.log.bind(console);

    var err = Module['printErr'] || console.warn.bind(console);

    for (key in moduleOverrides) {
      if (moduleOverrides.hasOwnProperty(key)) {
        Module[key] = moduleOverrides[key];
      }
    }

    moduleOverrides = null;

    if (Module['arguments']) arguments_ = Module['arguments'];

    if (!Object.getOwnPropertyDescriptor(Module, 'arguments')) {
      Object.defineProperty(Module, 'arguments', {
        configurable: true,
        get: function () {
          abort(
            'Module.arguments has been replaced with plain arguments_ (the initial value can be provided on Module, but after startup the value is only looked for on a local variable of that name)',
          );
        },
      });
    }

    if (Module['thisProgram']) thisProgram = Module['thisProgram'];

    if (!Object.getOwnPropertyDescriptor(Module, 'thisProgram')) {
      Object.defineProperty(Module, 'thisProgram', {
        configurable: true,
        get: function () {
          abort(
            'Module.thisProgram has been replaced with plain thisProgram (the initial value can be provided on Module, but after startup the value is only looked for on a local variable of that name)',
          );
        },
      });
    }

    if (Module['quit']) quit_ = Module['quit'];

    if (!Object.getOwnPropertyDescriptor(Module, 'quit')) {
      Object.defineProperty(Module, 'quit', {
        configurable: true,
        get: function () {
          abort(
            'Module.quit has been replaced with plain quit_ (the initial value can be provided on Module, but after startup the value is only looked for on a local variable of that name)',
          );
        },
      });
    }

    assert(
      typeof Module['memoryInitializerPrefixURL'] === 'undefined',
      'Module.memoryInitializerPrefixURL option was removed, use Module.locateFile instead',
    );

    assert(
      typeof Module['pthreadMainPrefixURL'] === 'undefined',
      'Module.pthreadMainPrefixURL option was removed, use Module.locateFile instead',
    );

    assert(
      typeof Module['cdInitializerPrefixURL'] === 'undefined',
      'Module.cdInitializerPrefixURL option was removed, use Module.locateFile instead',
    );

    assert(
      typeof Module['filePackagePrefixURL'] === 'undefined',
      'Module.filePackagePrefixURL option was removed, use Module.locateFile instead',
    );

    assert(typeof Module['read'] === 'undefined', 'Module.read option was removed (modify read_ in JS)');

    assert(typeof Module['readAsync'] === 'undefined', 'Module.readAsync option was removed (modify readAsync in JS)');

    assert(
      typeof Module['readBinary'] === 'undefined',
      'Module.readBinary option was removed (modify readBinary in JS)',
    );

    assert(
      typeof Module['setWindowTitle'] === 'undefined',
      'Module.setWindowTitle option was removed (modify setWindowTitle in JS)',
    );

    assert(typeof Module['TOTAL_MEMORY'] === 'undefined', 'Module.TOTAL_MEMORY has been renamed Module.INITIAL_MEMORY');

    if (!Object.getOwnPropertyDescriptor(Module, 'read')) {
      Object.defineProperty(Module, 'read', {
        configurable: true,
        get: function () {
          abort(
            'Module.read has been replaced with plain read_ (the initial value can be provided on Module, but after startup the value is only looked for on a local variable of that name)',
          );
        },
      });
    }

    if (!Object.getOwnPropertyDescriptor(Module, 'readAsync')) {
      Object.defineProperty(Module, 'readAsync', {
        configurable: true,
        get: function () {
          abort(
            'Module.readAsync has been replaced with plain readAsync (the initial value can be provided on Module, but after startup the value is only looked for on a local variable of that name)',
          );
        },
      });
    }

    if (!Object.getOwnPropertyDescriptor(Module, 'readBinary')) {
      Object.defineProperty(Module, 'readBinary', {
        configurable: true,
        get: function () {
          abort(
            'Module.readBinary has been replaced with plain readBinary (the initial value can be provided on Module, but after startup the value is only looked for on a local variable of that name)',
          );
        },
      });
    }

    if (!Object.getOwnPropertyDescriptor(Module, 'setWindowTitle')) {
      Object.defineProperty(Module, 'setWindowTitle', {
        configurable: true,
        get: function () {
          abort(
            'Module.setWindowTitle has been replaced with plain setWindowTitle (the initial value can be provided on Module, but after startup the value is only looked for on a local variable of that name)',
          );
        },
      });
    }

    var IDBFS = 'IDBFS is no longer included by default; build with -lidbfs.js';

    var PROXYFS = 'PROXYFS is no longer included by default; build with -lproxyfs.js';

    var WORKERFS = 'WORKERFS is no longer included by default; build with -lworkerfs.js';

    var NODEFS = 'NODEFS is no longer included by default; build with -lnodefs.js';

    function alignMemory() {
      abort(
        '`alignMemory` is now a library function and not included by default; add it to your library.js __deps or to DEFAULT_LIBRARY_FUNCS_TO_INCLUDE on the command line',
      );
    }

    assert(
      !ENVIRONMENT_IS_WORKER,
      "worker environment detected but not enabled at build time.  Add 'worker' to `-s ENVIRONMENT` to enable.",
    );

    assert(
      !ENVIRONMENT_IS_NODE,
      "node environment detected but not enabled at build time.  Add 'node' to `-s ENVIRONMENT` to enable.",
    );

    assert(
      !ENVIRONMENT_IS_SHELL,
      "shell environment detected but not enabled at build time.  Add 'shell' to `-s ENVIRONMENT` to enable.",
    );

    var STACK_ALIGN = 16;

    var POINTER_SIZE = 4;

    function getNativeTypeSize(type) {
      switch (type) {
        case 'i1':
        case 'i8':
          return 1;

        case 'i16':
          return 2;

        case 'i32':
          return 4;

        case 'i64':
          return 8;

        case 'float':
          return 4;

        case 'double':
          return 8;

        default: {
          if (type[type.length - 1] === '*') {
            return POINTER_SIZE;
          } else if (type[0] === 'i') {
            var bits = Number(type.substr(1));
            assert(bits % 8 === 0, 'getNativeTypeSize invalid bits ' + bits + ', type ' + type);
            return bits / 8;
          } else {
            return 0;
          }
        }
      }
    }

    function warnOnce(text) {
      if (!warnOnce.shown) warnOnce.shown = {};
      if (!warnOnce.shown[text]) {
        warnOnce.shown[text] = 1;
        err(text);
      }
    }

    function convertJsFunctionToWasm(func, sig) {
      return func;
    }

    var freeTableIndexes = [];

    var functionsInTableMap;

    function getEmptyTableSlot() {
      if (freeTableIndexes.length) {
        return freeTableIndexes.pop();
      }
      try {
        wasmTable.grow(1);
      } catch (err) {
        if (!(err instanceof RangeError)) {
          throw err;
        }
        throw 'Unable to grow wasm table. Set ALLOW_TABLE_GROWTH.';
      }
      return wasmTable.length - 1;
    }

    function updateTableMap(offset, count) {
      for (var i = offset; i < offset + count; i++) {
        var item = getWasmTableEntry(i);
        if (item) {
          functionsInTableMap.set(item, i);
        }
      }
    }

    function addFunction(func, sig) {
      assert(typeof func !== 'undefined');
      if (!functionsInTableMap) {
        functionsInTableMap = new WeakMap();
        updateTableMap(0, wasmTable.length);
      }
      if (functionsInTableMap.has(func)) {
        return functionsInTableMap.get(func);
      }
      var ret = getEmptyTableSlot();
      try {
        setWasmTableEntry(ret, func);
      } catch (err) {
        if (!(err instanceof TypeError)) {
          throw err;
        }
        assert(typeof sig !== 'undefined', 'Missing signature argument to addFunction: ' + func);
        var wrapped = convertJsFunctionToWasm(func, sig);
        setWasmTableEntry(ret, wrapped);
      }
      functionsInTableMap.set(func, ret);
      return ret;
    }

    function removeFunction(index) {
      functionsInTableMap.delete(getWasmTableEntry(index));
      freeTableIndexes.push(index);
    }

    var tempRet0 = 0;

    var setTempRet0 = function (value) {
      tempRet0 = value;
    };

    var getTempRet0 = function () {
      return tempRet0;
    };

    var wasmBinary;

    if (Module['wasmBinary']) wasmBinary = Module['wasmBinary'];

    if (!Object.getOwnPropertyDescriptor(Module, 'wasmBinary')) {
      Object.defineProperty(Module, 'wasmBinary', {
        configurable: true,
        get: function () {
          abort(
            'Module.wasmBinary has been replaced with plain wasmBinary (the initial value can be provided on Module, but after startup the value is only looked for on a local variable of that name)',
          );
        },
      });
    }

    var noExitRuntime = Module['noExitRuntime'] || true;

    if (!Object.getOwnPropertyDescriptor(Module, 'noExitRuntime')) {
      Object.defineProperty(Module, 'noExitRuntime', {
        configurable: true,
        get: function () {
          abort(
            'Module.noExitRuntime has been replaced with plain noExitRuntime (the initial value can be provided on Module, but after startup the value is only looked for on a local variable of that name)',
          );
        },
      });
    }

    var WebAssembly = {
      Memory: function (opts) {
        this.buffer = new ArrayBuffer(opts['initial'] * 65536);
      },
      Module: function (binary) {},
      Instance: function (module, info) {
        this.exports = (function instantiate(asmLibraryArg) {
          function Table(ret) {
            // grow method not included; table is not growable
            ret.set = function (i, func) {
              this[i] = func;
            };
            ret.get = function (i) {
              return this[i];
            };
            return ret;
          }

          var bufferView;
          var base64ReverseLookup = new Uint8Array(123 /*'z'+1*/);
          for (var i = 25; i >= 0; --i) {
            base64ReverseLookup[48 + i] = 52 + i; // '0-9'
            base64ReverseLookup[65 + i] = i; // 'A-Z'
            base64ReverseLookup[97 + i] = 26 + i; // 'a-z'
          }
          base64ReverseLookup[43] = 62; // '+'
          base64ReverseLookup[47] = 63; // '/'
          /** @noinline Inlining this function would mean expanding the base64 string 4x times in the source code, which Closure seems to be happy to do. */
          function base64DecodeToExistingUint8Array(uint8Array, offset, b64) {
            var b1,
              b2,
              i = 0,
              j = offset,
              bLength = b64.length,
              end = offset + ((bLength * 3) >> 2) - (b64[bLength - 2] == '=') - (b64[bLength - 1] == '=');
            for (; i < bLength; i += 4) {
              b1 = base64ReverseLookup[b64.charCodeAt(i + 1)];
              b2 = base64ReverseLookup[b64.charCodeAt(i + 2)];
              uint8Array[j++] = (base64ReverseLookup[b64.charCodeAt(i)] << 2) | (b1 >> 4);
              if (j < end) uint8Array[j++] = (b1 << 4) | (b2 >> 2);
              if (j < end) uint8Array[j++] = (b2 << 6) | base64ReverseLookup[b64.charCodeAt(i + 3)];
            }
          }
          function initActiveSegments(imports) {
            base64DecodeToExistingUint8Array(
              bufferView,
              1024,
              'Z+YJaoWuZ7ty8248OvVPpX9SDlGMaAWbq9mDHxnN4FuYL4pCkUQ3cc/7wLWl27XpW8JWOfER8Vmkgj+S1V4cq5iqB9gBW4MSvoUxJMN9DFV0Xb5y/rHegKcG3Jt08ZvBwWmb5IZHvu/GncEPzKEMJG8s6S2qhHRK3KmwXNqI+XZSUT6YbcYxqMgnA7DHf1m/8wvgxkeRp9VRY8oGZykpFIUKtyc4IRsu/G0sTRMNOFNUcwpluwpqdi7JwoGFLHKSoei/oktmGqhwi0vCo1FsxxnoktEkBpnWhTUO9HCgahAWwaQZCGw3Hkx3SCe1vLA0swwcOUqq2E5Pypxb828uaO6Cj3RvY6V4FHjIhAgCx4z6/76Q62xQpPej+b7yeHHGzj4nyse4htHWfdrqf0999apn8AbFfWMKBJg/ETULcRv1d9soe6vKMgq+njzEZx1DvtTFTJwpf1mrb8tfjBlEbICIAAA=',
            );
            base64DecodeToExistingUint8Array(
              bufferView,
              1392,
              'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA==',
            );
          }
          function asmFunc(env) {
            var memory = env.memory;
            var buffer = memory.buffer;
            var HEAP8 = new Int8Array(buffer);
            var HEAP16 = new Int16Array(buffer);
            var HEAP32 = new Int32Array(buffer);
            var HEAPU8 = new Uint8Array(buffer);
            var HEAPU16 = new Uint16Array(buffer);
            var HEAPU32 = new Uint32Array(buffer);
            var HEAPF32 = new Float32Array(buffer);
            var HEAPF64 = new Float64Array(buffer);
            var Math_imul = Math.imul;
            var Math_fround = Math.fround;
            var Math_abs = Math.abs;
            var Math_clz32 = Math.clz32;
            var Math_min = Math.min;
            var Math_max = Math.max;
            var Math_floor = Math.floor;
            var Math_ceil = Math.ceil;
            var Math_trunc = Math.trunc;
            var Math_sqrt = Math.sqrt;
            var abort = env.abort;
            var nan = NaN;
            var infinity = Infinity;
            var fimport$0 = env.emscripten_memcpy_big;
            var fimport$1 = env.emscripten_resize_heap;
            var fimport$2 = env.segfault;
            var fimport$3 = env.alignfault;
            var global$0 = 34944;
            var global$1 = 0;
            var global$2 = 0;
            var i64toi32_i32$HIGH_BITS = 0;
            // EMSCRIPTEN_START_FUNCS
            function $0() {
              $26();
            }

            function $1($0_1, $1_1, $2_1, $3_1, $4_1) {
              $0_1 = $0_1 | 0;
              $1_1 = $1_1 | 0;
              $2_1 = $2_1 | 0;
              $3_1 = $3_1 | 0;
              $4_1 = $4_1 | 0;
              var $7_1 = 0,
                $19_1 = 0,
                $53 = 0,
                $72 = 0,
                $92 = 0,
                $97 = 0,
                $110 = 0,
                $117 = 0,
                $122 = 0,
                $130 = 0,
                $131 = 0,
                $137 = 0,
                $148 = 0,
                $149 = 0,
                $200 = 0,
                $213 = 0,
                $90 = 0,
                $199 = 0,
                $229 = 0;
              $7_1 = (global$0 - 48) | 0;
              global$0 = $7_1;
              $74($7_1 | 0, 44 | 0, $0_1 | 0);
              $71($7_1 | 0, 42 | 0, $1_1 | 0);
              $71($7_1 | 0, 40 | 0, $2_1 | 0);
              $71($7_1 | 0, 38 | 0, $3_1 | 0);
              $74($7_1 | 0, 32 | 0, $4_1 | 0);
              $71($7_1 | 0, 10 | 0, 32 | 0);
              label$1: {
                if (!($45(0 | 0, 1392 | 0) | 0)) {
                  break label$1;
                }
              }
              $71($7_1 | 0, 30 | 0, (((((($42($7_1 | 0, 10 | 0) | 0) & 65535) | 0 | 0) / (8 | 0)) | 0) << 4) | 0 | 0);
              $19_1 = 16;
              $71(
                $7_1 | 0,
                28 | 0,
                (((((((($42($7_1 | 0, 42 | 0) | 0) << $19_1) | 0) >> $19_1) | 0) + 1) | 0) +
                  ((((($42($7_1 | 0, 10 | 0) | 0) & 65535) | 0 | 0) / (4 | 0)) | 0)) |
                  0 |
                  0,
              );
              $71(
                $7_1 | 0,
                26 | 0,
                (((($42($7_1 | 0, 28 | 0) | 0) & 65535) | 0 | 0) / ((($42($7_1 | 0, 30 | 0) | 0) & 65535) | 0 | 0)) |
                  0 |
                  0,
              );
              label$2: {
                if (
                  !(
                    ((($42($7_1 | 0, 28 | 0) | 0) & 65535) | 0 | 0) % ((($42($7_1 | 0, 30 | 0) | 0) & 65535) | 0 | 0) |
                    0
                  )
                ) {
                  break label$2;
                }
                $71($7_1 | 0, 26 | 0, (($42($7_1 | 0, 26 | 0) | 0) + 1) | 0 | 0);
              }
              $2(1024 | 0, 1408 | 0, (8 & 65535) | 0 | 0);
              $53 = 16;
              $74($7_1 | 0, 16 | 0, (((((($42($7_1 | 0, 42 | 0) | 0) << $53) | 0) >> $53) | 0) << 3) | 0 | 0);
              $71($7_1 | 0, 14 | 0, 0 | 0);
              $71($7_1 | 0, 24 | 0, 0 | 0);
              label$3: {
                label$4: while (1) {
                  if (
                    !(
                      ((((($42($7_1 | 0, 24 | 0) | 0) & 65535) | 0 | 0) <
                        ((($42($7_1 | 0, 26 | 0) | 0) & 65535) | 0 | 0)) &
                        1) |
                      0
                    )
                  ) {
                    break label$3;
                  }
                  $72 = 16;
                  label$5: {
                    label$6: {
                      if (
                        !(
                          ((((((($42($7_1 | 0, 42 | 0) | 0) << $72) | 0) >> $72) | 0 | 0) >
                            ((($42($7_1 | 0, 30 | 0) | 0) & 65535) | 0 | 0)) &
                            1) |
                          0
                        )
                      ) {
                        break label$6;
                      }
                      $16(1536 | 0, $45($7_1 | 0, 44 | 0) | 0 | 0, (($42($7_1 | 0, 30 | 0) | 0) & 65535) | 0 | 0) | 0;
                      $90 = (($42($7_1 | 0, 30 | 0) | 0) & 65535) | 0;
                      $92 = 16;
                      $71($7_1 | 0, 42 | 0, (((((($42($7_1 | 0, 42 | 0) | 0) << $92) | 0) >> $92) | 0) - $90) | 0 | 0);
                      break label$5;
                    }
                    $97 = 16;
                    label$7: {
                      label$8: {
                        if (
                          !(
                            ((((((($42($7_1 | 0, 42 | 0) | 0) << $97) | 0) >> $97) | 0 | 0) ==
                              ((($42($7_1 | 0, 30 | 0) | 0) & 65535) | 0 | 0)) &
                              1) |
                            0
                          )
                        ) {
                          break label$8;
                        }
                        $110 = 16;
                        $16(
                          1536 | 0,
                          $45($7_1 | 0, 44 | 0) | 0 | 0,
                          (((($42($7_1 | 0, 42 | 0) | 0) << $110) | 0) >> $110) | 0 | 0,
                        ) | 0;
                        $71($7_1 | 0, 42 | 0, 0 | 0);
                        break label$7;
                      }
                      $117 = 16;
                      $16(
                        1536 | 0,
                        $45($7_1 | 0, 44 | 0) | 0 | 0,
                        (((($42($7_1 | 0, 42 | 0) | 0) << $117) | 0) >> $117) | 0 | 0,
                      ) | 0;
                      $122 = 16;
                      $74(
                        $7_1 | 0,
                        44 | 0,
                        (1536 + ((((($42($7_1 | 0, 42 | 0) | 0) << $122) | 0) >> $122) | 0)) | 0 | 0,
                      );
                      label$9: {
                        if ((($42($7_1 | 0, 14 | 0) | 0) & 65535) | 0) {
                          break label$9;
                        }
                        $130 = $45($7_1 | 0, 44 | 0) | 0;
                        $131 = 1;
                        $74($7_1 | 0, 44 | 0, ($130 + $131) | 0 | 0);
                        $69($130 | 0, 0 | 0, 128 | 0);
                        $71($7_1 | 0, 42 | 0, (($42($7_1 | 0, 42 | 0) | 0) + $131) | 0 | 0);
                      }
                      label$10: {
                        label$11: while (1) {
                          $137 = 16;
                          if (
                            !(
                              ((((((($42($7_1 | 0, 42 | 0) | 0) << $137) | 0) >> $137) | 0 | 0) <
                                ((($42($7_1 | 0, 30 | 0) | 0) & 65535) | 0 | 0)) &
                                1) |
                              0
                            )
                          ) {
                            break label$10;
                          }
                          $148 = $45($7_1 | 0, 44 | 0) | 0;
                          $149 = 1;
                          $74($7_1 | 0, 44 | 0, ($148 + $149) | 0 | 0);
                          $69($148 | 0, 0 | 0, 0 | 0);
                          $71($7_1 | 0, 42 | 0, (($42($7_1 | 0, 42 | 0) | 0) + $149) | 0 | 0);
                          continue label$11;
                        }
                      }
                      $71($7_1 | 0, 42 | 0, 0 | 0);
                      $71($7_1 | 0, 14 | 0, 1 | 0);
                    }
                  }
                  $71(
                    $7_1 | 0,
                    12 | 0,
                    ((((($42($7_1 | 0, 24 | 0) | 0) & 65535) | 0 | 0) ==
                      ((((($42($7_1 | 0, 26 | 0) | 0) & 65535) | 0) - 1) | 0 | 0)) &
                      1) |
                      0 |
                      0,
                  );
                  label$12: {
                    if (!(((((($42($7_1 | 0, 12 | 0) | 0) & 65535) | 0 | 0) != ((0 & 65535) | 0 | 0)) & 1) | 0)) {
                      break label$12;
                    }
                    $74($7_1 | 0, 44 | 0, (((1536 + ((($42($7_1 | 0, 30 | 0) | 0) & 65535) | 0)) | 0) + -1) | 0 | 0);
                    $71($7_1 | 0, 22 | 0, 0 | 0);
                    label$13: {
                      label$14: while (1) {
                        if (
                          !(
                            ((((($42($7_1 | 0, 22 | 0) | 0) & 65535) | 0 | 0) <
                              ((((($42($7_1 | 0, 10 | 0) | 0) & 65535) | 0 | 0) / (4 | 0)) | 0 | 0)) &
                              1) |
                            0
                          )
                        ) {
                          break label$13;
                        }
                        $199 = $45($7_1 | 0, 16 | 0) | 0;
                        $200 = $45($7_1 | 0, 44 | 0) | 0;
                        $74($7_1 | 0, 44 | 0, ($200 + -1) | 0 | 0);
                        $69($200 | 0, 0 | 0, $199 | 0);
                        $74($7_1 | 0, 16 | 0, (($45($7_1 | 0, 16 | 0) | 0) >>> 8) | 0 | 0);
                        $71($7_1 | 0, 22 | 0, (($42($7_1 | 0, 22 | 0) | 0) + 1) | 0 | 0);
                        continue label$14;
                      }
                    }
                  }
                  $213 = 0;
                  label$15: {
                    if (!((($42($7_1 | 0, 12 | 0) | 0) & 65535) | 0)) {
                      break label$15;
                    }
                    $213 = ((($42($7_1 | 0, 40 | 0) | 0) & 65535) | 0 | 0) != (0 | 0);
                  }
                  $3(1536 | 0, ((($213 & 1) | 0) & 65535) | 0 | 0);
                  $229 = (($42($7_1 | 0, 30 | 0) | 0) & 65535) | 0;
                  $74($7_1 | 0, 44 | 0, (($45($7_1 | 0, 44 | 0) | 0) + $229) | 0 | 0);
                  $71($7_1 | 0, 24 | 0, (($42($7_1 | 0, 24 | 0) | 0) + 1) | 0 | 0);
                  continue label$4;
                }
              }
              $4((($42($7_1 | 0, 38 | 0) | 0) & 65535) | 0 | 0, $45($7_1 | 0, 32 | 0) | 0 | 0);
              label$16: {
                if (!($45(0 | 0, 1392 | 0) | 0)) {
                  break label$16;
                }
              }
              global$0 = ($7_1 + 48) | 0;
              return 1 | 0;
            }

            function $2($0_1, $1_1, $2_1) {
              $0_1 = $0_1 | 0;
              $1_1 = $1_1 | 0;
              $2_1 = $2_1 | 0;
              var $5_1 = 0,
                $15_1 = 0,
                $16_1 = 0,
                $19_1 = 0,
                $18_1 = 0;
              $5_1 = (global$0 - 16) | 0;
              $74($5_1 | 0, 12 | 0, $0_1 | 0);
              $74($5_1 | 0, 8 | 0, $1_1 | 0);
              $71($5_1 | 0, 6 | 0, $2_1 | 0);
              label$1: {
                label$2: while (1) {
                  if (!(((((($42($5_1 | 0, 6 | 0) | 0) & 65535) | 0 | 0) > (0 | 0)) & 1) | 0)) {
                    break label$1;
                  }
                  $15_1 = $45($5_1 | 0, 12 | 0) | 0;
                  $16_1 = 4;
                  $74($5_1 | 0, 12 | 0, ($15_1 + $16_1) | 0 | 0);
                  $18_1 = $45($15_1 | 0, 0 | 0) | 0;
                  $19_1 = $45($5_1 | 0, 8 | 0) | 0;
                  $74($5_1 | 0, 8 | 0, ($19_1 + $16_1) | 0 | 0);
                  $74($19_1 | 0, 0 | 0, $18_1 | 0);
                  $71($5_1 | 0, 6 | 0, (($42($5_1 | 0, 6 | 0) | 0) + -1) | 0 | 0);
                  continue label$2;
                }
              }
              return;
            }

            function $3($0_1, $1_1) {
              $0_1 = $0_1 | 0;
              $1_1 = $1_1 | 0;
              var $4_1 = 0,
                $50 = 0,
                $112 = 0,
                $118 = 0,
                $124 = 0,
                $130 = 0,
                $136 = 0,
                $142 = 0,
                $148 = 0,
                $154 = 0;
              $4_1 = (global$0 - 32) | 0;
              global$0 = $4_1;
              $74($4_1 | 0, 28 | 0, $0_1 | 0);
              $71($4_1 | 0, 26 | 0, $1_1 | 0);
              $71($4_1 | 0, 24 | 0, 0 | 0);
              $71($4_1 | 0, 22 | 0, 0 | 0);
              $15($45($4_1 | 0, 28 | 0) | 0 | 0);
              $74(0 | 0, 1504 | 0, $45(0 | 0, 1408 | 0) | 0 | 0);
              $74(0 | 0, 1508 | 0, $45(0 | 0, 1412 | 0) | 0 | 0);
              $74(0 | 0, 1512 | 0, $45(0 | 0, 1416 | 0) | 0 | 0);
              $74(0 | 0, 1516 | 0, $45(0 | 0, 1420 | 0) | 0 | 0);
              $74(0 | 0, 1520 | 0, $45(0 | 0, 1424 | 0) | 0 | 0);
              $74(0 | 0, 1524 | 0, $45(0 | 0, 1428 | 0) | 0 | 0);
              $74(0 | 0, 1528 | 0, $45(0 | 0, 1432 | 0) | 0 | 0);
              $74(0 | 0, 1532 | 0, $45(0 | 0, 1436 | 0) | 0 | 0);
              $71($4_1 | 0, 20 | 0, 0 | 0);
              label$1: {
                label$2: while (1) {
                  if (!(((((($42($4_1 | 0, 20 | 0) | 0) & 65535) | 0 | 0) < (64 | 0)) & 1) | 0)) {
                    break label$1;
                  }
                  $74($4_1 | 0, 8 | 0, $14($42($4_1 | 0, 20 | 0) | 0 | 0) | 0 | 0);
                  $74($4_1 | 0, 4 | 0, $45((1056 + ((($42($4_1 | 0, 20 | 0) | 0) << 2) | 0)) | 0 | 0, 0 | 0) | 0 | 0);
                  $50 = 0;
                  $74(
                    $4_1 | 0,
                    16 | 0,
                    (((((((($45($50 | 0, 1532 | 0) | 0) + ($10($45($50 | 0, 1520 | 0) | 0 | 0) | 0)) | 0) +
                      ($5(
                        $45($50 | 0, 1520 | 0) | 0 | 0,
                        $45($50 | 0, 1524 | 0) | 0 | 0,
                        $45($50 | 0, 1528 | 0) | 0 | 0,
                      ) |
                        0)) |
                      0) +
                      ($45($4_1 | 0, 4 | 0) | 0)) |
                      0) +
                      ($45($4_1 | 0, 8 | 0) | 0)) |
                      0 |
                      0,
                  );
                  $74(
                    $4_1 | 0,
                    12 | 0,
                    (($9($45($50 | 0, 1504 | 0) | 0 | 0) | 0) +
                      ($6(
                        $45($50 | 0, 1504 | 0) | 0 | 0,
                        $45($50 | 0, 1508 | 0) | 0 | 0,
                        $45($50 | 0, 1512 | 0) | 0 | 0,
                      ) |
                        0)) |
                      0 |
                      0,
                  );
                  $74($50 | 0, 1532 | 0, $45($50 | 0, 1528 | 0) | 0 | 0);
                  $74($50 | 0, 1528 | 0, $45($50 | 0, 1524 | 0) | 0 | 0);
                  $74($50 | 0, 1524 | 0, $45($50 | 0, 1520 | 0) | 0 | 0);
                  $74($50 | 0, 1520 | 0, (($45($50 | 0, 1516 | 0) | 0) + ($45($4_1 | 0, 16 | 0) | 0)) | 0 | 0);
                  $74($50 | 0, 1516 | 0, $45($50 | 0, 1512 | 0) | 0 | 0);
                  $74($50 | 0, 1512 | 0, $45($50 | 0, 1508 | 0) | 0 | 0);
                  $74($50 | 0, 1508 | 0, $45($50 | 0, 1504 | 0) | 0 | 0);
                  $74($50 | 0, 1504 | 0, (($45($4_1 | 0, 16 | 0) | 0) + ($45($4_1 | 0, 12 | 0) | 0)) | 0 | 0);
                  $71($4_1 | 0, 24 | 0, (($42($4_1 | 0, 24 | 0) | 0) + 1) | 0 | 0);
                  label$3: {
                    if (!(((((($42($4_1 | 0, 24 | 0) | 0) & 65535) | 0 | 0) == (20 | 0)) & 1) | 0)) {
                      break label$3;
                    }
                    $71($4_1 | 0, 22 | 0, (($42($4_1 | 0, 22 | 0) | 0) + 1) | 0 | 0);
                    $71($4_1 | 0, 24 | 0, 0 | 0);
                  }
                  $71($4_1 | 0, 20 | 0, (($42($4_1 | 0, 20 | 0) | 0) + 1) | 0 | 0);
                  continue label$2;
                }
              }
              label$4: {
                label$5: {
                  if (((((($42($4_1 | 0, 26 | 0) | 0) & 65535) | 0 | 0) != ((0 & 65535) | 0 | 0)) & 1) | 0) {
                    break label$5;
                  }
                  $112 = $45(0 | 0, 1504 | 0) | 0;
                  $74(0 | 0, 1408 | 0, (($45(0 | 0, 1408 | 0) | 0) + $112) | 0 | 0);
                  $118 = $45(0 | 0, 1508 | 0) | 0;
                  $74(0 | 0, 1412 | 0, (($45(0 | 0, 1412 | 0) | 0) + $118) | 0 | 0);
                  $124 = $45(0 | 0, 1512 | 0) | 0;
                  $74(0 | 0, 1416 | 0, (($45(0 | 0, 1416 | 0) | 0) + $124) | 0 | 0);
                  $130 = $45(0 | 0, 1516 | 0) | 0;
                  $74(0 | 0, 1420 | 0, (($45(0 | 0, 1420 | 0) | 0) + $130) | 0 | 0);
                  $136 = $45(0 | 0, 1520 | 0) | 0;
                  $74(0 | 0, 1424 | 0, (($45(0 | 0, 1424 | 0) | 0) + $136) | 0 | 0);
                  $142 = $45(0 | 0, 1524 | 0) | 0;
                  $74(0 | 0, 1428 | 0, (($45(0 | 0, 1428 | 0) | 0) + $142) | 0 | 0);
                  $148 = $45(0 | 0, 1528 | 0) | 0;
                  $74(0 | 0, 1432 | 0, (($45(0 | 0, 1432 | 0) | 0) + $148) | 0 | 0);
                  $154 = $45(0 | 0, 1532 | 0) | 0;
                  $74(0 | 0, 1436 | 0, (($45(0 | 0, 1436 | 0) | 0) + $154) | 0 | 0);
                  break label$4;
                }
                $74(0 | 0, 1408 | 0, $45(0 | 0, 1504 | 0) | 0 | 0);
                $74(0 | 0, 1412 | 0, $45(0 | 0, 1508 | 0) | 0 | 0);
                $74(0 | 0, 1416 | 0, $45(0 | 0, 1512 | 0) | 0 | 0);
                $74(0 | 0, 1420 | 0, $45(0 | 0, 1516 | 0) | 0 | 0);
                $74(0 | 0, 1424 | 0, $45(0 | 0, 1520 | 0) | 0 | 0);
                $74(0 | 0, 1428 | 0, $45(0 | 0, 1524 | 0) | 0 | 0);
                $74(0 | 0, 1432 | 0, $45(0 | 0, 1528 | 0) | 0 | 0);
                $74(0 | 0, 1436 | 0, $45(0 | 0, 1532 | 0) | 0 | 0);
              }
              global$0 = ($4_1 + 32) | 0;
              return;
            }

            function $4($0_1, $1_1) {
              $0_1 = $0_1 | 0;
              $1_1 = $1_1 | 0;
              var $4_1 = 0,
                $36_1 = 0,
                $40 = 0;
              $4_1 = (global$0 - 16) | 0;
              global$0 = $4_1;
              $71($4_1 | 0, 14 | 0, $0_1 | 0);
              $74($4_1 | 0, 8 | 0, $1_1 | 0);
              $13(1408 | 0, $45($4_1 | 0, 8 | 0) | 0 | 0, (8 & 65535) | 0 | 0);
              label$1: {
                if (!(((((($42($4_1 | 0, 14 | 0) | 0) & 65535) | 0 | 0) != ((0 & 65535) | 0 | 0)) & 1) | 0)) {
                  break label$1;
                }
                $74($4_1 | 0, 4 | 0, 0 | 0);
                label$2: {
                  label$3: while (1) {
                    if (!(((($45($4_1 | 0, 4 | 0) | 0 | 0) < (16 | 0)) & 1) | 0)) {
                      break label$2;
                    }
                    $69(
                      $4_1 | 0,
                      3 | 0,
                      $38((($45($4_1 | 0, 8 | 0) | 0) + ($45($4_1 | 0, 4 | 0) | 0)) | 0 | 0, 0 | 0) | 0 | 0,
                    );
                    $36_1 =
                      $38((($45($4_1 | 0, 8 | 0) | 0) + ((31 - ($45($4_1 | 0, 4 | 0) | 0)) | 0)) | 0 | 0, 0 | 0) | 0;
                    $69((($45($4_1 | 0, 8 | 0) | 0) + ($45($4_1 | 0, 4 | 0) | 0)) | 0 | 0, 0 | 0, $36_1 | 0);
                    $40 = $38($4_1 | 0, 3 | 0) | 0;
                    $69((($45($4_1 | 0, 8 | 0) | 0) + ((31 - ($45($4_1 | 0, 4 | 0) | 0)) | 0)) | 0 | 0, 0 | 0, $40 | 0);
                    $74($4_1 | 0, 4 | 0, (($45($4_1 | 0, 4 | 0) | 0) + 1) | 0 | 0);
                    continue label$3;
                  }
                }
              }
              global$0 = ($4_1 + 16) | 0;
              return;
            }

            function $5($0_1, $1_1, $2_1) {
              $0_1 = $0_1 | 0;
              $1_1 = $1_1 | 0;
              $2_1 = $2_1 | 0;
              var $5_1 = 0;
              $5_1 = (global$0 - 16) | 0;
              $74($5_1 | 0, 12 | 0, $0_1 | 0);
              $74($5_1 | 0, 8 | 0, $1_1 | 0);
              $74($5_1 | 0, 4 | 0, $2_1 | 0);
              return (
                (((($45($5_1 | 0, 12 | 0) | 0) & ($45($5_1 | 0, 8 | 0) | 0)) | 0) ^
                  ((((($45($5_1 | 0, 12 | 0) | 0) ^ -1) | 0) & ($45($5_1 | 0, 4 | 0) | 0)) | 0)) |
                0 |
                0
              );
            }

            function $6($0_1, $1_1, $2_1) {
              $0_1 = $0_1 | 0;
              $1_1 = $1_1 | 0;
              $2_1 = $2_1 | 0;
              var $5_1 = 0,
                $11_1 = 0,
                $16_1 = 0;
              $5_1 = (global$0 - 16) | 0;
              $74($5_1 | 0, 12 | 0, $0_1 | 0);
              $74($5_1 | 0, 8 | 0, $1_1 | 0);
              $74($5_1 | 0, 4 | 0, $2_1 | 0);
              $74($5_1 | 0, 0 | 0, (($45($5_1 | 0, 12 | 0) | 0) & ($45($5_1 | 0, 8 | 0) | 0)) | 0 | 0);
              $11_1 = (($45($5_1 | 0, 12 | 0) | 0) & ($45($5_1 | 0, 4 | 0) | 0)) | 0;
              $74($5_1 | 0, 0 | 0, (($45($5_1 | 0, 0 | 0) | 0) ^ $11_1) | 0 | 0);
              $16_1 = (($45($5_1 | 0, 8 | 0) | 0) & ($45($5_1 | 0, 4 | 0) | 0)) | 0;
              $74($5_1 | 0, 0 | 0, (($45($5_1 | 0, 0 | 0) | 0) ^ $16_1) | 0 | 0);
              return $45($5_1 | 0, 0 | 0) | 0 | 0;
            }

            function $7($0_1, $1_1) {
              $0_1 = $0_1 | 0;
              $1_1 = $1_1 | 0;
              var $4_1 = 0;
              $4_1 = (global$0 - 16) | 0;
              $74($4_1 | 0, 12 | 0, $0_1 | 0);
              $71($4_1 | 0, 10 | 0, $1_1 | 0);
              $74($4_1 | 0, 12 | 0, $45($4_1 | 0, 12 | 0) | 0 | 0);
              return (
                (($45($4_1 | 0, 12 | 0) | 0) >>> ((($42($4_1 | 0, 10 | 0) | 0) & 65535) | 0)) |
                0 |
                ((($45($4_1 | 0, 12 | 0) | 0) << ((32 - ((($42($4_1 | 0, 10 | 0) | 0) & 65535) | 0)) | 0)) | 0) |
                0 |
                0
              );
            }

            function $8($0_1, $1_1) {
              $0_1 = $0_1 | 0;
              $1_1 = $1_1 | 0;
              var $4_1 = 0;
              $4_1 = (global$0 - 16) | 0;
              $74($4_1 | 0, 12 | 0, $0_1 | 0);
              $71($4_1 | 0, 10 | 0, $1_1 | 0);
              $74($4_1 | 0, 12 | 0, $45($4_1 | 0, 12 | 0) | 0 | 0);
              return (($45($4_1 | 0, 12 | 0) | 0) >>> ((($42($4_1 | 0, 10 | 0) | 0) & 65535) | 0)) | 0 | 0;
            }

            function $9($0_1) {
              $0_1 = $0_1 | 0;
              var $3_1 = 0,
                $20_1 = 0;
              $3_1 = (global$0 - 16) | 0;
              global$0 = $3_1;
              $74($3_1 | 0, 12 | 0, $0_1 | 0);
              $20_1 =
                (((($7($45($3_1 | 0, 12 | 0) | 0 | 0, (2 & 65535) | 0 | 0) | 0) ^
                  ($7($45($3_1 | 0, 12 | 0) | 0 | 0, (13 & 65535) | 0 | 0) | 0)) |
                  0) ^
                  ($7($45($3_1 | 0, 12 | 0) | 0 | 0, (22 & 65535) | 0 | 0) | 0)) |
                0;
              global$0 = ($3_1 + 16) | 0;
              return $20_1 | 0;
            }

            function $10($0_1) {
              $0_1 = $0_1 | 0;
              var $3_1 = 0,
                $20_1 = 0;
              $3_1 = (global$0 - 16) | 0;
              global$0 = $3_1;
              $74($3_1 | 0, 12 | 0, $0_1 | 0);
              $20_1 =
                (((($7($45($3_1 | 0, 12 | 0) | 0 | 0, (6 & 65535) | 0 | 0) | 0) ^
                  ($7($45($3_1 | 0, 12 | 0) | 0 | 0, (11 & 65535) | 0 | 0) | 0)) |
                  0) ^
                  ($7($45($3_1 | 0, 12 | 0) | 0 | 0, (25 & 65535) | 0 | 0) | 0)) |
                0;
              global$0 = ($3_1 + 16) | 0;
              return $20_1 | 0;
            }

            function $11($0_1) {
              $0_1 = $0_1 | 0;
              var $3_1 = 0,
                $20_1 = 0;
              $3_1 = (global$0 - 16) | 0;
              global$0 = $3_1;
              $74($3_1 | 0, 12 | 0, $0_1 | 0);
              $20_1 =
                (((($7($45($3_1 | 0, 12 | 0) | 0 | 0, (7 & 65535) | 0 | 0) | 0) ^
                  ($7($45($3_1 | 0, 12 | 0) | 0 | 0, (18 & 65535) | 0 | 0) | 0)) |
                  0) ^
                  ($8($45($3_1 | 0, 12 | 0) | 0 | 0, (3 & 65535) | 0 | 0) | 0)) |
                0;
              global$0 = ($3_1 + 16) | 0;
              return $20_1 | 0;
            }

            function $12($0_1) {
              $0_1 = $0_1 | 0;
              var $3_1 = 0,
                $20_1 = 0;
              $3_1 = (global$0 - 16) | 0;
              global$0 = $3_1;
              $74($3_1 | 0, 12 | 0, $0_1 | 0);
              $20_1 =
                (((($7($45($3_1 | 0, 12 | 0) | 0 | 0, (17 & 65535) | 0 | 0) | 0) ^
                  ($7($45($3_1 | 0, 12 | 0) | 0 | 0, (19 & 65535) | 0 | 0) | 0)) |
                  0) ^
                  ($8($45($3_1 | 0, 12 | 0) | 0 | 0, (10 & 65535) | 0 | 0) | 0)) |
                0;
              global$0 = ($3_1 + 16) | 0;
              return $20_1 | 0;
            }

            function $13($0_1, $1_1, $2_1) {
              $0_1 = $0_1 | 0;
              $1_1 = $1_1 | 0;
              $2_1 = $2_1 | 0;
              var $5_1 = 0,
                $18_1 = 0,
                $25_1 = 0,
                $31_1 = 0,
                $37 = 0,
                $41 = 0,
                $24_1 = 0,
                $30_1 = 0,
                $36_1 = 0,
                $40 = 0;
              $5_1 = (global$0 - 32) | 0;
              $74($5_1 | 0, 28 | 0, $0_1 | 0);
              $74($5_1 | 0, 24 | 0, $1_1 | 0);
              $71($5_1 | 0, 22 | 0, $2_1 | 0);
              $71($5_1 | 0, 14 | 0, 0 | 0);
              label$1: {
                label$2: while (1) {
                  if (
                    !(
                      ((((($42($5_1 | 0, 14 | 0) | 0) & 65535) | 0 | 0) <
                        ((($42($5_1 | 0, 22 | 0) | 0) & 65535) | 0 | 0)) &
                        1) |
                      0
                    )
                  ) {
                    break label$1;
                  }
                  $18_1 = $45($5_1 | 0, 28 | 0) | 0;
                  $74($5_1 | 0, 28 | 0, ($18_1 + 4) | 0 | 0);
                  $74($5_1 | 0, 16 | 0, $45($18_1 | 0, 0 | 0) | 0 | 0);
                  $24_1 = (($45($5_1 | 0, 16 | 0) | 0) >>> 24) | 0;
                  $25_1 = $45($5_1 | 0, 24 | 0) | 0;
                  $74($5_1 | 0, 24 | 0, ($25_1 + 1) | 0 | 0);
                  $69($25_1 | 0, 0 | 0, $24_1 | 0);
                  $30_1 = (($45($5_1 | 0, 16 | 0) | 0) >>> 16) | 0;
                  $31_1 = $45($5_1 | 0, 24 | 0) | 0;
                  $74($5_1 | 0, 24 | 0, ($31_1 + 1) | 0 | 0);
                  $69($31_1 | 0, 0 | 0, $30_1 | 0);
                  $36_1 = (($45($5_1 | 0, 16 | 0) | 0) >>> 8) | 0;
                  $37 = $45($5_1 | 0, 24 | 0) | 0;
                  $74($5_1 | 0, 24 | 0, ($37 + 1) | 0 | 0);
                  $69($37 | 0, 0 | 0, $36_1 | 0);
                  $40 = $45($5_1 | 0, 16 | 0) | 0;
                  $41 = $45($5_1 | 0, 24 | 0) | 0;
                  $74($5_1 | 0, 24 | 0, ($41 + 1) | 0 | 0);
                  $69($41 | 0, 0 | 0, $40 | 0);
                  $71($5_1 | 0, 14 | 0, (($42($5_1 | 0, 14 | 0) | 0) + 1) | 0 | 0);
                  continue label$2;
                }
              }
              return;
            }

            function $14($0_1) {
              $0_1 = $0_1 | 0;
              var $3_1 = 0,
                $62 = 0,
                $71_1 = 0;
              $3_1 = (global$0 - 16) | 0;
              global$0 = $3_1;
              $74($3_1 | 0, 8 | 0, $0_1 | 0);
              label$1: {
                label$2: {
                  if (!(((($45($3_1 | 0, 8 | 0) | 0 | 0) < (16 | 0)) & 1) | 0)) {
                    break label$2;
                  }
                  $74($3_1 | 0, 12 | 0, $45((1440 + ((($45($3_1 | 0, 8 | 0) | 0) << 2) | 0)) | 0 | 0, 0 | 0) | 0 | 0);
                  break label$1;
                }
                $74(
                  $3_1 | 0,
                  4 | 0,
                  (((((($12(
                    $45((1440 + ((((((($45($3_1 | 0, 8 | 0) | 0) - 2) | 0) & 15) | 0) << 2) | 0)) | 0 | 0, 0 | 0) |
                      0 |
                      0,
                  ) |
                    0) +
                    ($45((1440 + ((((((($45($3_1 | 0, 8 | 0) | 0) - 7) | 0) & 15) | 0) << 2) | 0)) | 0 | 0, 0 | 0) |
                      0)) |
                    0) +
                    ($11(
                      $45((1440 + ((((((($45($3_1 | 0, 8 | 0) | 0) - 15) | 0) & 15) | 0) << 2) | 0)) | 0 | 0, 0 | 0) |
                        0 |
                        0,
                    ) |
                      0)) |
                    0) +
                    ($45((1440 + ((((((($45($3_1 | 0, 8 | 0) | 0) - 16) | 0) & 15) | 0) << 2) | 0)) | 0 | 0, 0 | 0) |
                      0)) |
                    0 |
                    0,
                );
                $62 = $45($3_1 | 0, 4 | 0) | 0;
                $74((1440 + ((((($45($3_1 | 0, 8 | 0) | 0) & 15) | 0) << 2) | 0)) | 0 | 0, 0 | 0, $62 | 0);
                $74($3_1 | 0, 12 | 0, $45($3_1 | 0, 4 | 0) | 0 | 0);
              }
              $71_1 = $45($3_1 | 0, 12 | 0) | 0;
              global$0 = ($3_1 + 16) | 0;
              return $71_1 | 0;
            }

            function $15($0_1) {
              $0_1 = $0_1 | 0;
              var $3_1 = 0,
                $42_1 = 0;
              $3_1 = (global$0 - 16) | 0;
              $74($3_1 | 0, 12 | 0, $0_1 | 0);
              $71($3_1 | 0, 10 | 0, 0 | 0);
              label$1: {
                label$2: while (1) {
                  if (!(((((($42($3_1 | 0, 10 | 0) | 0) & 65535) | 0 | 0) < (16 | 0)) & 1) | 0)) {
                    break label$1;
                  }
                  $74($3_1 | 0, 4 | 0, 0 | 0);
                  $71($3_1 | 0, 8 | 0, 0 | 0);
                  label$3: {
                    label$4: while (1) {
                      if (!(((((($42($3_1 | 0, 8 | 0) | 0) & 65535) | 0 | 0) < (4 | 0)) & 1) | 0)) {
                        break label$3;
                      }
                      $74($3_1 | 0, 4 | 0, (($45($3_1 | 0, 4 | 0) | 0) << 8) | 0 | 0);
                      $74(
                        $3_1 | 0,
                        4 | 0,
                        $45($3_1 | 0, 4 | 0) |
                          0 |
                          ((((($38($45($3_1 | 0, 12 | 0) | 0 | 0, 0 | 0) | 0) & 255) | 0) & 255) | 0) |
                          0 |
                          0,
                      );
                      $74($3_1 | 0, 12 | 0, (($45($3_1 | 0, 12 | 0) | 0) + 1) | 0 | 0);
                      $71($3_1 | 0, 8 | 0, (($42($3_1 | 0, 8 | 0) | 0) + 1) | 0 | 0);
                      continue label$4;
                    }
                  }
                  $42_1 = $45($3_1 | 0, 4 | 0) | 0;
                  $74((1440 + ((((($42($3_1 | 0, 10 | 0) | 0) & 65535) | 0) << 2) | 0)) | 0 | 0, 0 | 0, $42_1 | 0);
                  $71($3_1 | 0, 10 | 0, (($42($3_1 | 0, 10 | 0) | 0) + 1) | 0 | 0);
                  continue label$2;
                }
              }
              return;
            }

            function $16($0_1, $1_1, $2_1) {
              $0_1 = $0_1 | 0;
              $1_1 = $1_1 | 0;
              $2_1 = $2_1 | 0;
              var $4_1 = 0,
                $3_1 = 0,
                $5_1 = 0;
              label$1: {
                if ($2_1 >>> 0 < 512 >>> 0) {
                  break label$1;
                }
                fimport$0($0_1 | 0, $1_1 | 0, $2_1 | 0) | 0;
                return $0_1 | 0;
              }
              $3_1 = ($0_1 + $2_1) | 0;
              label$2: {
                label$3: {
                  if (((($1_1 ^ $0_1) | 0) & 3) | 0) {
                    break label$3;
                  }
                  label$4: {
                    label$5: {
                      if (($0_1 & 3) | 0) {
                        break label$5;
                      }
                      $2_1 = $0_1;
                      break label$4;
                    }
                    label$6: {
                      if ($2_1) {
                        break label$6;
                      }
                      $2_1 = $0_1;
                      break label$4;
                    }
                    $2_1 = $0_1;
                    label$7: while (1) {
                      $69($2_1 | 0, 0 | 0, $38($1_1 | 0, 0 | 0) | 0 | 0);
                      $1_1 = ($1_1 + 1) | 0;
                      $2_1 = ($2_1 + 1) | 0;
                      if (!(($2_1 & 3) | 0)) {
                        break label$4;
                      }
                      if ($2_1 >>> 0 < $3_1 >>> 0) {
                        continue label$7;
                      }
                      break label$7;
                    }
                  }
                  label$8: {
                    $4_1 = ($3_1 & -4) | 0;
                    if ($4_1 >>> 0 < 64 >>> 0) {
                      break label$8;
                    }
                    $5_1 = ($4_1 + -64) | 0;
                    if ($2_1 >>> 0 > $5_1 >>> 0) {
                      break label$8;
                    }
                    label$9: while (1) {
                      $74($2_1 | 0, 0 | 0, $45($1_1 | 0, 0 | 0) | 0 | 0);
                      $74($2_1 | 0, 4 | 0, $45($1_1 | 0, 4 | 0) | 0 | 0);
                      $74($2_1 | 0, 8 | 0, $45($1_1 | 0, 8 | 0) | 0 | 0);
                      $74($2_1 | 0, 12 | 0, $45($1_1 | 0, 12 | 0) | 0 | 0);
                      $74($2_1 | 0, 16 | 0, $45($1_1 | 0, 16 | 0) | 0 | 0);
                      $74($2_1 | 0, 20 | 0, $45($1_1 | 0, 20 | 0) | 0 | 0);
                      $74($2_1 | 0, 24 | 0, $45($1_1 | 0, 24 | 0) | 0 | 0);
                      $74($2_1 | 0, 28 | 0, $45($1_1 | 0, 28 | 0) | 0 | 0);
                      $74($2_1 | 0, 32 | 0, $45($1_1 | 0, 32 | 0) | 0 | 0);
                      $74($2_1 | 0, 36 | 0, $45($1_1 | 0, 36 | 0) | 0 | 0);
                      $74($2_1 | 0, 40 | 0, $45($1_1 | 0, 40 | 0) | 0 | 0);
                      $74($2_1 | 0, 44 | 0, $45($1_1 | 0, 44 | 0) | 0 | 0);
                      $74($2_1 | 0, 48 | 0, $45($1_1 | 0, 48 | 0) | 0 | 0);
                      $74($2_1 | 0, 52 | 0, $45($1_1 | 0, 52 | 0) | 0 | 0);
                      $74($2_1 | 0, 56 | 0, $45($1_1 | 0, 56 | 0) | 0 | 0);
                      $74($2_1 | 0, 60 | 0, $45($1_1 | 0, 60 | 0) | 0 | 0);
                      $1_1 = ($1_1 + 64) | 0;
                      $2_1 = ($2_1 + 64) | 0;
                      if ($2_1 >>> 0 <= $5_1 >>> 0) {
                        continue label$9;
                      }
                      break label$9;
                    }
                  }
                  if ($2_1 >>> 0 >= $4_1 >>> 0) {
                    break label$2;
                  }
                  label$10: while (1) {
                    $74($2_1 | 0, 0 | 0, $45($1_1 | 0, 0 | 0) | 0 | 0);
                    $1_1 = ($1_1 + 4) | 0;
                    $2_1 = ($2_1 + 4) | 0;
                    if ($2_1 >>> 0 < $4_1 >>> 0) {
                      continue label$10;
                    }
                    break label$2;
                  }
                }
                label$11: {
                  if ($3_1 >>> 0 >= 4 >>> 0) {
                    break label$11;
                  }
                  $2_1 = $0_1;
                  break label$2;
                }
                label$12: {
                  $4_1 = ($3_1 + -4) | 0;
                  if ($4_1 >>> 0 >= $0_1 >>> 0) {
                    break label$12;
                  }
                  $2_1 = $0_1;
                  break label$2;
                }
                $2_1 = $0_1;
                label$13: while (1) {
                  $69($2_1 | 0, 0 | 0, $38($1_1 | 0, 0 | 0) | 0 | 0);
                  $69($2_1 | 0, 1 | 0, $38($1_1 | 0, 1 | 0) | 0 | 0);
                  $69($2_1 | 0, 2 | 0, $38($1_1 | 0, 2 | 0) | 0 | 0);
                  $69($2_1 | 0, 3 | 0, $38($1_1 | 0, 3 | 0) | 0 | 0);
                  $1_1 = ($1_1 + 4) | 0;
                  $2_1 = ($2_1 + 4) | 0;
                  if ($2_1 >>> 0 <= $4_1 >>> 0) {
                    continue label$13;
                  }
                  break label$13;
                }
              }
              label$14: {
                if ($2_1 >>> 0 >= $3_1 >>> 0) {
                  break label$14;
                }
                label$15: while (1) {
                  $69($2_1 | 0, 0 | 0, $38($1_1 | 0, 0 | 0) | 0 | 0);
                  $1_1 = ($1_1 + 1) | 0;
                  $2_1 = ($2_1 + 1) | 0;
                  if (($2_1 | 0) != ($3_1 | 0)) {
                    continue label$15;
                  }
                  break label$15;
                }
              }
              return $0_1 | 0;
            }

            function $17() {
              return global$0 | 0;
            }

            function $18($0_1) {
              $0_1 = $0_1 | 0;
              global$0 = $0_1;
            }

            function $19($0_1) {
              $0_1 = $0_1 | 0;
              var $1_1 = 0;
              $1_1 = (((global$0 - $0_1) | 0) & -16) | 0;
              global$0 = $1_1;
              return $1_1 | 0;
            }

            function $20() {
              return (__wasm_memory_size() << 16) | 0 | 0;
            }

            function $21() {
              return 1664 | 0;
            }

            function $22() {
              return 1376 | 0;
            }

            function $23($0_1) {
              $0_1 = $0_1 | 0;
              var $1_1 = 0,
                $2_1 = 0;
              $1_1 = $45(0 | 0, 1376 | 0) | 0;
              $2_1 = ((($0_1 + 3) | 0) & -4) | 0;
              $0_1 = ($1_1 + $2_1) | 0;
              label$1: {
                label$2: {
                  if (!$2_1) {
                    break label$2;
                  }
                  if ($0_1 >>> 0 <= $1_1 >>> 0) {
                    break label$1;
                  }
                }
                label$3: {
                  if ($0_1 >>> 0 <= ($20() | 0) >>> 0) {
                    break label$3;
                  }
                  if (!(fimport$1($0_1 | 0) | 0)) {
                    break label$1;
                  }
                }
                $74(0 | 0, 1376 | 0, $0_1 | 0);
                return $1_1 | 0;
              }
              $74($21() | 0 | 0, 0 | 0, 48 | 0);
              return -1 | 0;
            }

            function $24($0_1) {
              $0_1 = $0_1 | 0;
              var $4_1 = 0,
                $5_1 = 0,
                $6_1 = 0,
                $8_1 = 0,
                $3_1 = 0,
                $2_1 = 0,
                $11_1 = 0,
                $7_1 = 0,
                i64toi32_i32$0 = 0,
                $9_1 = 0,
                $10_1 = 0,
                $1_1 = 0,
                i64toi32_i32$1 = 0,
                $79 = 0,
                $92 = 0,
                $103 = 0,
                $111 = 0,
                $119 = 0,
                $210 = 0,
                $221 = 0,
                $229 = 0,
                $237 = 0,
                $272 = 0,
                $291 = 0,
                $339 = 0,
                $346 = 0,
                $353 = 0,
                $444 = 0,
                $455 = 0,
                $463 = 0,
                $471 = 0,
                $527 = 0,
                $1157 = 0,
                $1164 = 0,
                $1171 = 0,
                $1356 = 0,
                $1363 = 0,
                $1370 = 0,
                $1606 = 0,
                $1613 = 0,
                $1620 = 0;
              $1_1 = (global$0 - 16) | 0;
              global$0 = $1_1;
              label$1: {
                label$2: {
                  label$3: {
                    label$4: {
                      label$5: {
                        label$6: {
                          label$7: {
                            label$8: {
                              label$9: {
                                label$10: {
                                  label$11: {
                                    label$12: {
                                      if ($0_1 >>> 0 > 244 >>> 0) {
                                        break label$12;
                                      }
                                      label$13: {
                                        $2_1 = $45(0 | 0, 1668 | 0) | 0;
                                        $3_1 = $0_1 >>> 0 < 11 >>> 0 ? 16 : ((($0_1 + 11) | 0) & -8) | 0;
                                        $4_1 = ($3_1 >>> 3) | 0;
                                        $0_1 = ($2_1 >>> $4_1) | 0;
                                        if (!(($0_1 & 3) | 0)) {
                                          break label$13;
                                        }
                                        $5_1 = ((((($0_1 ^ -1) | 0) & 1) | 0) + $4_1) | 0;
                                        $6_1 = ($5_1 << 3) | 0;
                                        $4_1 = $45(($6_1 + 1716) | 0 | 0, 0 | 0) | 0;
                                        $0_1 = ($4_1 + 8) | 0;
                                        label$14: {
                                          label$15: {
                                            $3_1 = $45($4_1 | 0, 8 | 0) | 0;
                                            $6_1 = ($6_1 + 1708) | 0;
                                            if (($3_1 | 0) != ($6_1 | 0)) {
                                              break label$15;
                                            }
                                            $74(
                                              0 | 0,
                                              1668 | 0,
                                              ($2_1 & (__wasm_rotl_i32(-2 | 0, $5_1 | 0) | 0)) | 0 | 0,
                                            );
                                            break label$14;
                                          }
                                          $74($3_1 | 0, 12 | 0, $6_1 | 0);
                                          $74($6_1 | 0, 8 | 0, $3_1 | 0);
                                        }
                                        $5_1 = ($5_1 << 3) | 0;
                                        $74($4_1 | 0, 4 | 0, $5_1 | 3 | 0 | 0);
                                        $4_1 = ($4_1 + $5_1) | 0;
                                        $74($4_1 | 0, 4 | 0, $45($4_1 | 0, 4 | 0) | 0 | 1 | 0 | 0);
                                        break label$1;
                                      }
                                      $7_1 = $45(0 | 0, 1676 | 0) | 0;
                                      if ($3_1 >>> 0 <= $7_1 >>> 0) {
                                        break label$11;
                                      }
                                      label$16: {
                                        if (!$0_1) {
                                          break label$16;
                                        }
                                        label$17: {
                                          label$18: {
                                            $79 = ($0_1 << $4_1) | 0;
                                            $0_1 = (2 << $4_1) | 0;
                                            $0_1 = ($79 & ($0_1 | ((0 - $0_1) | 0) | 0)) | 0;
                                            $0_1 = ((($0_1 & ((0 - $0_1) | 0)) | 0) + -1) | 0;
                                            $92 = $0_1;
                                            $0_1 = ((($0_1 >>> 12) | 0) & 16) | 0;
                                            $4_1 = ($92 >>> $0_1) | 0;
                                            $5_1 = ((($4_1 >>> 5) | 0) & 8) | 0;
                                            $103 = $5_1 | $0_1 | 0;
                                            $0_1 = ($4_1 >>> $5_1) | 0;
                                            $4_1 = ((($0_1 >>> 2) | 0) & 4) | 0;
                                            $111 = $103 | $4_1 | 0;
                                            $0_1 = ($0_1 >>> $4_1) | 0;
                                            $4_1 = ((($0_1 >>> 1) | 0) & 2) | 0;
                                            $119 = $111 | $4_1 | 0;
                                            $0_1 = ($0_1 >>> $4_1) | 0;
                                            $4_1 = ((($0_1 >>> 1) | 0) & 1) | 0;
                                            $5_1 = (($119 | $4_1 | 0) + (($0_1 >>> $4_1) | 0)) | 0;
                                            $6_1 = ($5_1 << 3) | 0;
                                            $4_1 = $45(($6_1 + 1716) | 0 | 0, 0 | 0) | 0;
                                            $0_1 = $45($4_1 | 0, 8 | 0) | 0;
                                            $6_1 = ($6_1 + 1708) | 0;
                                            if (($0_1 | 0) != ($6_1 | 0)) {
                                              break label$18;
                                            }
                                            $2_1 = ($2_1 & (__wasm_rotl_i32(-2 | 0, $5_1 | 0) | 0)) | 0;
                                            $74(0 | 0, 1668 | 0, $2_1 | 0);
                                            break label$17;
                                          }
                                          $74($0_1 | 0, 12 | 0, $6_1 | 0);
                                          $74($6_1 | 0, 8 | 0, $0_1 | 0);
                                        }
                                        $0_1 = ($4_1 + 8) | 0;
                                        $74($4_1 | 0, 4 | 0, $3_1 | 3 | 0 | 0);
                                        $6_1 = ($4_1 + $3_1) | 0;
                                        $8_1 = ($5_1 << 3) | 0;
                                        $5_1 = ($8_1 - $3_1) | 0;
                                        $74($6_1 | 0, 4 | 0, $5_1 | 1 | 0 | 0);
                                        $74(($4_1 + $8_1) | 0 | 0, 0 | 0, $5_1 | 0);
                                        label$19: {
                                          if (!$7_1) {
                                            break label$19;
                                          }
                                          $8_1 = ($7_1 >>> 3) | 0;
                                          $3_1 = ((($8_1 << 3) | 0) + 1708) | 0;
                                          $4_1 = $45(0 | 0, 1688 | 0) | 0;
                                          label$20: {
                                            label$21: {
                                              $8_1 = (1 << $8_1) | 0;
                                              if (($2_1 & $8_1) | 0) {
                                                break label$21;
                                              }
                                              $74(0 | 0, 1668 | 0, $2_1 | $8_1 | 0 | 0);
                                              $8_1 = $3_1;
                                              break label$20;
                                            }
                                            $8_1 = $45($3_1 | 0, 8 | 0) | 0;
                                          }
                                          $74($3_1 | 0, 8 | 0, $4_1 | 0);
                                          $74($8_1 | 0, 12 | 0, $4_1 | 0);
                                          $74($4_1 | 0, 12 | 0, $3_1 | 0);
                                          $74($4_1 | 0, 8 | 0, $8_1 | 0);
                                        }
                                        $74(0 | 0, 1688 | 0, $6_1 | 0);
                                        $74(0 | 0, 1676 | 0, $5_1 | 0);
                                        break label$1;
                                      }
                                      $9_1 = $45(0 | 0, 1672 | 0) | 0;
                                      if (!$9_1) {
                                        break label$11;
                                      }
                                      $0_1 = ((($9_1 & ((0 - $9_1) | 0)) | 0) + -1) | 0;
                                      $210 = $0_1;
                                      $0_1 = ((($0_1 >>> 12) | 0) & 16) | 0;
                                      $4_1 = ($210 >>> $0_1) | 0;
                                      $5_1 = ((($4_1 >>> 5) | 0) & 8) | 0;
                                      $221 = $5_1 | $0_1 | 0;
                                      $0_1 = ($4_1 >>> $5_1) | 0;
                                      $4_1 = ((($0_1 >>> 2) | 0) & 4) | 0;
                                      $229 = $221 | $4_1 | 0;
                                      $0_1 = ($0_1 >>> $4_1) | 0;
                                      $4_1 = ((($0_1 >>> 1) | 0) & 2) | 0;
                                      $237 = $229 | $4_1 | 0;
                                      $0_1 = ($0_1 >>> $4_1) | 0;
                                      $4_1 = ((($0_1 >>> 1) | 0) & 1) | 0;
                                      $6_1 =
                                        $45(
                                          (((((($237 | $4_1 | 0) + (($0_1 >>> $4_1) | 0)) | 0) << 2) | 0) + 1972) |
                                            0 |
                                            0,
                                          0 | 0,
                                        ) | 0;
                                      $4_1 = (((($45($6_1 | 0, 4 | 0) | 0) & -8) | 0) - $3_1) | 0;
                                      $5_1 = $6_1;
                                      label$22: {
                                        label$23: while (1) {
                                          label$24: {
                                            $0_1 = $45($5_1 | 0, 16 | 0) | 0;
                                            if ($0_1) {
                                              break label$24;
                                            }
                                            $0_1 = $45(($5_1 + 20) | 0 | 0, 0 | 0) | 0;
                                            if (!$0_1) {
                                              break label$22;
                                            }
                                          }
                                          $5_1 = (((($45($0_1 | 0, 4 | 0) | 0) & -8) | 0) - $3_1) | 0;
                                          $272 = $5_1;
                                          $5_1 = $5_1 >>> 0 < $4_1 >>> 0;
                                          $4_1 = $5_1 ? $272 : $4_1;
                                          $6_1 = $5_1 ? $0_1 : $6_1;
                                          $5_1 = $0_1;
                                          continue label$23;
                                        }
                                      }
                                      $10_1 = $45($6_1 | 0, 24 | 0) | 0;
                                      label$25: {
                                        $8_1 = $45($6_1 | 0, 12 | 0) | 0;
                                        if (($8_1 | 0) == ($6_1 | 0)) {
                                          break label$25;
                                        }
                                        $291 = $45(0 | 0, 1684 | 0) | 0;
                                        $0_1 = $45($6_1 | 0, 8 | 0) | 0;
                                        $74($0_1 | 0, 12 | 0, $8_1 | 0);
                                        $74($8_1 | 0, 8 | 0, $0_1 | 0);
                                        break label$2;
                                      }
                                      label$26: {
                                        $5_1 = ($6_1 + 20) | 0;
                                        $0_1 = $45($5_1 | 0, 0 | 0) | 0;
                                        if ($0_1) {
                                          break label$26;
                                        }
                                        $0_1 = $45($6_1 | 0, 16 | 0) | 0;
                                        if (!$0_1) {
                                          break label$10;
                                        }
                                        $5_1 = ($6_1 + 16) | 0;
                                      }
                                      label$27: while (1) {
                                        $11_1 = $5_1;
                                        $8_1 = $0_1;
                                        $5_1 = ($0_1 + 20) | 0;
                                        $0_1 = $45($5_1 | 0, 0 | 0) | 0;
                                        if ($0_1) {
                                          continue label$27;
                                        }
                                        $5_1 = ($8_1 + 16) | 0;
                                        $0_1 = $45($8_1 | 0, 16 | 0) | 0;
                                        if ($0_1) {
                                          continue label$27;
                                        }
                                        break label$27;
                                      }
                                      $74($11_1 | 0, 0 | 0, 0 | 0);
                                      break label$2;
                                    }
                                    $3_1 = -1;
                                    if ($0_1 >>> 0 > -65 >>> 0) {
                                      break label$11;
                                    }
                                    $0_1 = ($0_1 + 11) | 0;
                                    $3_1 = ($0_1 & -8) | 0;
                                    $7_1 = $45(0 | 0, 1672 | 0) | 0;
                                    if (!$7_1) {
                                      break label$11;
                                    }
                                    $11_1 = 0;
                                    label$28: {
                                      if ($3_1 >>> 0 < 256 >>> 0) {
                                        break label$28;
                                      }
                                      $11_1 = 31;
                                      if ($3_1 >>> 0 > 16777215 >>> 0) {
                                        break label$28;
                                      }
                                      $0_1 = ($0_1 >>> 8) | 0;
                                      $339 = $0_1;
                                      $0_1 = ((((($0_1 + 1048320) | 0) >>> 16) | 0) & 8) | 0;
                                      $4_1 = ($339 << $0_1) | 0;
                                      $346 = $4_1;
                                      $4_1 = ((((($4_1 + 520192) | 0) >>> 16) | 0) & 4) | 0;
                                      $5_1 = ($346 << $4_1) | 0;
                                      $353 = $5_1;
                                      $5_1 = ((((($5_1 + 245760) | 0) >>> 16) | 0) & 2) | 0;
                                      $0_1 = ((((($353 << $5_1) | 0) >>> 15) | 0) - ($0_1 | $4_1 | 0 | $5_1 | 0)) | 0;
                                      $11_1 =
                                        ((($0_1 << 1) | 0 | (((($3_1 >>> (($0_1 + 21) | 0)) | 0) & 1) | 0) | 0) + 28) |
                                        0;
                                    }
                                    $4_1 = (0 - $3_1) | 0;
                                    label$29: {
                                      label$30: {
                                        label$31: {
                                          label$32: {
                                            $5_1 = $45(((($11_1 << 2) | 0) + 1972) | 0 | 0, 0 | 0) | 0;
                                            if ($5_1) {
                                              break label$32;
                                            }
                                            $0_1 = 0;
                                            $8_1 = 0;
                                            break label$31;
                                          }
                                          $0_1 = 0;
                                          $6_1 =
                                            ($3_1 << (($11_1 | 0) == (31 | 0) ? 0 : (25 - (($11_1 >>> 1) | 0)) | 0)) |
                                            0;
                                          $8_1 = 0;
                                          label$33: while (1) {
                                            label$34: {
                                              $2_1 = (((($45($5_1 | 0, 4 | 0) | 0) & -8) | 0) - $3_1) | 0;
                                              if ($2_1 >>> 0 >= $4_1 >>> 0) {
                                                break label$34;
                                              }
                                              $4_1 = $2_1;
                                              $8_1 = $5_1;
                                              if ($4_1) {
                                                break label$34;
                                              }
                                              $4_1 = 0;
                                              $8_1 = $5_1;
                                              $0_1 = $5_1;
                                              break label$30;
                                            }
                                            $2_1 = $45(($5_1 + 20) | 0 | 0, 0 | 0) | 0;
                                            $5_1 =
                                              $45(
                                                ((($5_1 + (((($6_1 >>> 29) | 0) & 4) | 0)) | 0) + 16) | 0 | 0,
                                                0 | 0,
                                              ) | 0;
                                            $0_1 = $2_1 ? (($2_1 | 0) == ($5_1 | 0) ? $0_1 : $2_1) : $0_1;
                                            $6_1 = ($6_1 << 1) | 0;
                                            if ($5_1) {
                                              continue label$33;
                                            }
                                            break label$33;
                                          }
                                        }
                                        label$35: {
                                          if ($0_1 | $8_1 | 0) {
                                            break label$35;
                                          }
                                          $8_1 = 0;
                                          $0_1 = (2 << $11_1) | 0;
                                          $0_1 = (($0_1 | ((0 - $0_1) | 0) | 0) & $7_1) | 0;
                                          if (!$0_1) {
                                            break label$11;
                                          }
                                          $0_1 = ((($0_1 & ((0 - $0_1) | 0)) | 0) + -1) | 0;
                                          $444 = $0_1;
                                          $0_1 = ((($0_1 >>> 12) | 0) & 16) | 0;
                                          $5_1 = ($444 >>> $0_1) | 0;
                                          $6_1 = ((($5_1 >>> 5) | 0) & 8) | 0;
                                          $455 = $6_1 | $0_1 | 0;
                                          $0_1 = ($5_1 >>> $6_1) | 0;
                                          $5_1 = ((($0_1 >>> 2) | 0) & 4) | 0;
                                          $463 = $455 | $5_1 | 0;
                                          $0_1 = ($0_1 >>> $5_1) | 0;
                                          $5_1 = ((($0_1 >>> 1) | 0) & 2) | 0;
                                          $471 = $463 | $5_1 | 0;
                                          $0_1 = ($0_1 >>> $5_1) | 0;
                                          $5_1 = ((($0_1 >>> 1) | 0) & 1) | 0;
                                          $0_1 =
                                            $45(
                                              (((((($471 | $5_1 | 0) + (($0_1 >>> $5_1) | 0)) | 0) << 2) | 0) + 1972) |
                                                0 |
                                                0,
                                              0 | 0,
                                            ) | 0;
                                        }
                                        if (!$0_1) {
                                          break label$29;
                                        }
                                      }
                                      label$36: while (1) {
                                        $2_1 = (((($45($0_1 | 0, 4 | 0) | 0) & -8) | 0) - $3_1) | 0;
                                        $6_1 = $2_1 >>> 0 < $4_1 >>> 0;
                                        label$37: {
                                          $5_1 = $45($0_1 | 0, 16 | 0) | 0;
                                          if ($5_1) {
                                            break label$37;
                                          }
                                          $5_1 = $45(($0_1 + 20) | 0 | 0, 0 | 0) | 0;
                                        }
                                        $4_1 = $6_1 ? $2_1 : $4_1;
                                        $8_1 = $6_1 ? $0_1 : $8_1;
                                        $0_1 = $5_1;
                                        if ($0_1) {
                                          continue label$36;
                                        }
                                        break label$36;
                                      }
                                    }
                                    if (!$8_1) {
                                      break label$11;
                                    }
                                    if ($4_1 >>> 0 >= ((($45(0 | 0, 1676 | 0) | 0) - $3_1) | 0) >>> 0) {
                                      break label$11;
                                    }
                                    $11_1 = $45($8_1 | 0, 24 | 0) | 0;
                                    label$38: {
                                      $6_1 = $45($8_1 | 0, 12 | 0) | 0;
                                      if (($6_1 | 0) == ($8_1 | 0)) {
                                        break label$38;
                                      }
                                      $527 = $45(0 | 0, 1684 | 0) | 0;
                                      $0_1 = $45($8_1 | 0, 8 | 0) | 0;
                                      $74($0_1 | 0, 12 | 0, $6_1 | 0);
                                      $74($6_1 | 0, 8 | 0, $0_1 | 0);
                                      break label$3;
                                    }
                                    label$39: {
                                      $5_1 = ($8_1 + 20) | 0;
                                      $0_1 = $45($5_1 | 0, 0 | 0) | 0;
                                      if ($0_1) {
                                        break label$39;
                                      }
                                      $0_1 = $45($8_1 | 0, 16 | 0) | 0;
                                      if (!$0_1) {
                                        break label$9;
                                      }
                                      $5_1 = ($8_1 + 16) | 0;
                                    }
                                    label$40: while (1) {
                                      $2_1 = $5_1;
                                      $6_1 = $0_1;
                                      $5_1 = ($0_1 + 20) | 0;
                                      $0_1 = $45($5_1 | 0, 0 | 0) | 0;
                                      if ($0_1) {
                                        continue label$40;
                                      }
                                      $5_1 = ($6_1 + 16) | 0;
                                      $0_1 = $45($6_1 | 0, 16 | 0) | 0;
                                      if ($0_1) {
                                        continue label$40;
                                      }
                                      break label$40;
                                    }
                                    $74($2_1 | 0, 0 | 0, 0 | 0);
                                    break label$3;
                                  }
                                  label$41: {
                                    $0_1 = $45(0 | 0, 1676 | 0) | 0;
                                    if ($0_1 >>> 0 < $3_1 >>> 0) {
                                      break label$41;
                                    }
                                    $4_1 = $45(0 | 0, 1688 | 0) | 0;
                                    label$42: {
                                      label$43: {
                                        $5_1 = ($0_1 - $3_1) | 0;
                                        if ($5_1 >>> 0 < 16 >>> 0) {
                                          break label$43;
                                        }
                                        $74(0 | 0, 1676 | 0, $5_1 | 0);
                                        $6_1 = ($4_1 + $3_1) | 0;
                                        $74(0 | 0, 1688 | 0, $6_1 | 0);
                                        $74($6_1 | 0, 4 | 0, $5_1 | 1 | 0 | 0);
                                        $74(($4_1 + $0_1) | 0 | 0, 0 | 0, $5_1 | 0);
                                        $74($4_1 | 0, 4 | 0, $3_1 | 3 | 0 | 0);
                                        break label$42;
                                      }
                                      $74(0 | 0, 1688 | 0, 0 | 0);
                                      $74(0 | 0, 1676 | 0, 0 | 0);
                                      $74($4_1 | 0, 4 | 0, $0_1 | 3 | 0 | 0);
                                      $0_1 = ($4_1 + $0_1) | 0;
                                      $74($0_1 | 0, 4 | 0, $45($0_1 | 0, 4 | 0) | 0 | 1 | 0 | 0);
                                    }
                                    $0_1 = ($4_1 + 8) | 0;
                                    break label$1;
                                  }
                                  label$44: {
                                    $6_1 = $45(0 | 0, 1680 | 0) | 0;
                                    if ($6_1 >>> 0 <= $3_1 >>> 0) {
                                      break label$44;
                                    }
                                    $4_1 = ($6_1 - $3_1) | 0;
                                    $74(0 | 0, 1680 | 0, $4_1 | 0);
                                    $0_1 = $45(0 | 0, 1692 | 0) | 0;
                                    $5_1 = ($0_1 + $3_1) | 0;
                                    $74(0 | 0, 1692 | 0, $5_1 | 0);
                                    $74($5_1 | 0, 4 | 0, $4_1 | 1 | 0 | 0);
                                    $74($0_1 | 0, 4 | 0, $3_1 | 3 | 0 | 0);
                                    $0_1 = ($0_1 + 8) | 0;
                                    break label$1;
                                  }
                                  label$45: {
                                    label$46: {
                                      if (!($45(0 | 0, 2140 | 0) | 0)) {
                                        break label$46;
                                      }
                                      $4_1 = $45(0 | 0, 2148 | 0) | 0;
                                      break label$45;
                                    }
                                    i64toi32_i32$0 = -1;
                                    $83(0 | 0, 2152 | 0, -1 | 0, i64toi32_i32$0 | 0);
                                    i64toi32_i32$0 = 4096;
                                    $83(0 | 0, 2144 | 0, 4096 | 0, i64toi32_i32$0 | 0);
                                    $74(0 | 0, 2140 | 0, ((((($1_1 + 12) | 0) & -16) | 0) ^ 1431655768) | 0 | 0);
                                    $74(0 | 0, 2160 | 0, 0 | 0);
                                    $74(0 | 0, 2112 | 0, 0 | 0);
                                    $4_1 = 4096;
                                  }
                                  $0_1 = 0;
                                  $7_1 = ($3_1 + 47) | 0;
                                  $2_1 = ($4_1 + $7_1) | 0;
                                  $11_1 = (0 - $4_1) | 0;
                                  $8_1 = ($2_1 & $11_1) | 0;
                                  if ($8_1 >>> 0 <= $3_1 >>> 0) {
                                    break label$1;
                                  }
                                  $0_1 = 0;
                                  label$47: {
                                    $4_1 = $45(0 | 0, 2108 | 0) | 0;
                                    if (!$4_1) {
                                      break label$47;
                                    }
                                    $5_1 = $45(0 | 0, 2100 | 0) | 0;
                                    $9_1 = ($5_1 + $8_1) | 0;
                                    if ($9_1 >>> 0 <= $5_1 >>> 0) {
                                      break label$1;
                                    }
                                    if ($9_1 >>> 0 > $4_1 >>> 0) {
                                      break label$1;
                                    }
                                  }
                                  if ((($38(0 | 0, 2112 | 0) | 0) & 4) | 0) {
                                    break label$6;
                                  }
                                  label$48: {
                                    label$49: {
                                      label$50: {
                                        $4_1 = $45(0 | 0, 1692 | 0) | 0;
                                        if (!$4_1) {
                                          break label$50;
                                        }
                                        $0_1 = 2116;
                                        label$51: while (1) {
                                          label$52: {
                                            $5_1 = $45($0_1 | 0, 0 | 0) | 0;
                                            if ($5_1 >>> 0 > $4_1 >>> 0) {
                                              break label$52;
                                            }
                                            if ((($5_1 + ($45($0_1 | 0, 4 | 0) | 0)) | 0) >>> 0 > $4_1 >>> 0) {
                                              break label$49;
                                            }
                                          }
                                          $0_1 = $45($0_1 | 0, 8 | 0) | 0;
                                          if ($0_1) {
                                            continue label$51;
                                          }
                                          break label$51;
                                        }
                                      }
                                      $6_1 = $23(0 | 0) | 0;
                                      if (($6_1 | 0) == (-1 | 0)) {
                                        break label$7;
                                      }
                                      $2_1 = $8_1;
                                      label$53: {
                                        $0_1 = $45(0 | 0, 2144 | 0) | 0;
                                        $4_1 = ($0_1 + -1) | 0;
                                        if (!(($4_1 & $6_1) | 0)) {
                                          break label$53;
                                        }
                                        $2_1 =
                                          ((($8_1 - $6_1) | 0) + (((($4_1 + $6_1) | 0) & ((0 - $0_1) | 0)) | 0)) | 0;
                                      }
                                      if ($2_1 >>> 0 <= $3_1 >>> 0) {
                                        break label$7;
                                      }
                                      if ($2_1 >>> 0 > 2147483646 >>> 0) {
                                        break label$7;
                                      }
                                      label$54: {
                                        $0_1 = $45(0 | 0, 2108 | 0) | 0;
                                        if (!$0_1) {
                                          break label$54;
                                        }
                                        $4_1 = $45(0 | 0, 2100 | 0) | 0;
                                        $5_1 = ($4_1 + $2_1) | 0;
                                        if ($5_1 >>> 0 <= $4_1 >>> 0) {
                                          break label$7;
                                        }
                                        if ($5_1 >>> 0 > $0_1 >>> 0) {
                                          break label$7;
                                        }
                                      }
                                      $0_1 = $23($2_1 | 0) | 0;
                                      if (($0_1 | 0) != ($6_1 | 0)) {
                                        break label$48;
                                      }
                                      break label$5;
                                    }
                                    $2_1 = ((($2_1 - $6_1) | 0) & $11_1) | 0;
                                    if ($2_1 >>> 0 > 2147483646 >>> 0) {
                                      break label$7;
                                    }
                                    $6_1 = $23($2_1 | 0) | 0;
                                    if (
                                      ($6_1 | 0) ==
                                      ((($45($0_1 | 0, 0 | 0) | 0) + ($45($0_1 | 0, 4 | 0) | 0)) | 0 | 0)
                                    ) {
                                      break label$8;
                                    }
                                    $0_1 = $6_1;
                                  }
                                  label$55: {
                                    if (($0_1 | 0) == (-1 | 0)) {
                                      break label$55;
                                    }
                                    if ((($3_1 + 48) | 0) >>> 0 <= $2_1 >>> 0) {
                                      break label$55;
                                    }
                                    label$56: {
                                      $4_1 = $45(0 | 0, 2148 | 0) | 0;
                                      $4_1 = ((((($7_1 - $2_1) | 0) + $4_1) | 0) & ((0 - $4_1) | 0)) | 0;
                                      if ($4_1 >>> 0 <= 2147483646 >>> 0) {
                                        break label$56;
                                      }
                                      $6_1 = $0_1;
                                      break label$5;
                                    }
                                    label$57: {
                                      if (($23($4_1 | 0) | 0 | 0) == (-1 | 0)) {
                                        break label$57;
                                      }
                                      $2_1 = ($4_1 + $2_1) | 0;
                                      $6_1 = $0_1;
                                      break label$5;
                                    }
                                    $23((0 - $2_1) | 0 | 0) | 0;
                                    break label$7;
                                  }
                                  $6_1 = $0_1;
                                  if (($0_1 | 0) != (-1 | 0)) {
                                    break label$5;
                                  }
                                  break label$7;
                                }
                                $8_1 = 0;
                                break label$2;
                              }
                              $6_1 = 0;
                              break label$3;
                            }
                            if (($6_1 | 0) != (-1 | 0)) {
                              break label$5;
                            }
                          }
                          $74(0 | 0, 2112 | 0, $45(0 | 0, 2112 | 0) | 0 | 4 | 0 | 0);
                        }
                        if ($8_1 >>> 0 > 2147483646 >>> 0) {
                          break label$4;
                        }
                        $6_1 = $23($8_1 | 0) | 0;
                        $0_1 = $23(0 | 0) | 0;
                        if (($6_1 | 0) == (-1 | 0)) {
                          break label$4;
                        }
                        if (($0_1 | 0) == (-1 | 0)) {
                          break label$4;
                        }
                        if ($6_1 >>> 0 >= $0_1 >>> 0) {
                          break label$4;
                        }
                        $2_1 = ($0_1 - $6_1) | 0;
                        if ($2_1 >>> 0 <= (($3_1 + 40) | 0) >>> 0) {
                          break label$4;
                        }
                      }
                      $0_1 = (($45(0 | 0, 2100 | 0) | 0) + $2_1) | 0;
                      $74(0 | 0, 2100 | 0, $0_1 | 0);
                      label$58: {
                        if ($0_1 >>> 0 <= ($45(0 | 0, 2104 | 0) | 0) >>> 0) {
                          break label$58;
                        }
                        $74(0 | 0, 2104 | 0, $0_1 | 0);
                      }
                      label$59: {
                        label$60: {
                          label$61: {
                            label$62: {
                              $4_1 = $45(0 | 0, 1692 | 0) | 0;
                              if (!$4_1) {
                                break label$62;
                              }
                              $0_1 = 2116;
                              label$63: while (1) {
                                $5_1 = $45($0_1 | 0, 0 | 0) | 0;
                                $8_1 = $45($0_1 | 0, 4 | 0) | 0;
                                if (($6_1 | 0) == (($5_1 + $8_1) | 0 | 0)) {
                                  break label$61;
                                }
                                $0_1 = $45($0_1 | 0, 8 | 0) | 0;
                                if ($0_1) {
                                  continue label$63;
                                }
                                break label$60;
                              }
                            }
                            label$64: {
                              label$65: {
                                $0_1 = $45(0 | 0, 1684 | 0) | 0;
                                if (!$0_1) {
                                  break label$65;
                                }
                                if ($6_1 >>> 0 >= $0_1 >>> 0) {
                                  break label$64;
                                }
                              }
                              $74(0 | 0, 1684 | 0, $6_1 | 0);
                            }
                            $0_1 = 0;
                            $74(0 | 0, 2120 | 0, $2_1 | 0);
                            $74(0 | 0, 2116 | 0, $6_1 | 0);
                            $74(0 | 0, 1700 | 0, -1 | 0);
                            $74(0 | 0, 1704 | 0, $45(0 | 0, 2140 | 0) | 0 | 0);
                            $74(0 | 0, 2128 | 0, 0 | 0);
                            label$66: while (1) {
                              $4_1 = ($0_1 << 3) | 0;
                              $5_1 = ($4_1 + 1708) | 0;
                              $74(($4_1 + 1716) | 0 | 0, 0 | 0, $5_1 | 0);
                              $74(($4_1 + 1720) | 0 | 0, 0 | 0, $5_1 | 0);
                              $0_1 = ($0_1 + 1) | 0;
                              if (($0_1 | 0) != (32 | 0)) {
                                continue label$66;
                              }
                              break label$66;
                            }
                            $0_1 = ($2_1 + -40) | 0;
                            $4_1 = ((($6_1 + 8) | 0) & 7) | 0 ? (((-8 - $6_1) | 0) & 7) | 0 : 0;
                            $5_1 = ($0_1 - $4_1) | 0;
                            $74(0 | 0, 1680 | 0, $5_1 | 0);
                            $4_1 = ($6_1 + $4_1) | 0;
                            $74(0 | 0, 1692 | 0, $4_1 | 0);
                            $74($4_1 | 0, 4 | 0, $5_1 | 1 | 0 | 0);
                            $74(($6_1 + $0_1) | 0 | 0, 4 | 0, 40 | 0);
                            $74(0 | 0, 1696 | 0, $45(0 | 0, 2156 | 0) | 0 | 0);
                            break label$59;
                          }
                          if ((($38($0_1 | 0, 12 | 0) | 0) & 8) | 0) {
                            break label$60;
                          }
                          if ($5_1 >>> 0 > $4_1 >>> 0) {
                            break label$60;
                          }
                          if ($6_1 >>> 0 <= $4_1 >>> 0) {
                            break label$60;
                          }
                          $74($0_1 | 0, 4 | 0, ($8_1 + $2_1) | 0 | 0);
                          $0_1 = ((($4_1 + 8) | 0) & 7) | 0 ? (((-8 - $4_1) | 0) & 7) | 0 : 0;
                          $5_1 = ($4_1 + $0_1) | 0;
                          $74(0 | 0, 1692 | 0, $5_1 | 0);
                          $6_1 = (($45(0 | 0, 1680 | 0) | 0) + $2_1) | 0;
                          $0_1 = ($6_1 - $0_1) | 0;
                          $74(0 | 0, 1680 | 0, $0_1 | 0);
                          $74($5_1 | 0, 4 | 0, $0_1 | 1 | 0 | 0);
                          $74(($4_1 + $6_1) | 0 | 0, 4 | 0, 40 | 0);
                          $74(0 | 0, 1696 | 0, $45(0 | 0, 2156 | 0) | 0 | 0);
                          break label$59;
                        }
                        label$67: {
                          $8_1 = $45(0 | 0, 1684 | 0) | 0;
                          if ($6_1 >>> 0 >= $8_1 >>> 0) {
                            break label$67;
                          }
                          $74(0 | 0, 1684 | 0, $6_1 | 0);
                          $8_1 = $6_1;
                        }
                        $5_1 = ($6_1 + $2_1) | 0;
                        $0_1 = 2116;
                        label$68: {
                          label$69: {
                            label$70: {
                              label$71: {
                                label$72: {
                                  label$73: {
                                    label$74: {
                                      label$75: while (1) {
                                        if (($45($0_1 | 0, 0 | 0) | 0 | 0) == ($5_1 | 0)) {
                                          break label$74;
                                        }
                                        $0_1 = $45($0_1 | 0, 8 | 0) | 0;
                                        if ($0_1) {
                                          continue label$75;
                                        }
                                        break label$73;
                                      }
                                    }
                                    if (!((($38($0_1 | 0, 12 | 0) | 0) & 8) | 0)) {
                                      break label$72;
                                    }
                                  }
                                  $0_1 = 2116;
                                  label$76: while (1) {
                                    label$77: {
                                      $5_1 = $45($0_1 | 0, 0 | 0) | 0;
                                      if ($5_1 >>> 0 > $4_1 >>> 0) {
                                        break label$77;
                                      }
                                      $5_1 = ($5_1 + ($45($0_1 | 0, 4 | 0) | 0)) | 0;
                                      if ($5_1 >>> 0 > $4_1 >>> 0) {
                                        break label$71;
                                      }
                                    }
                                    $0_1 = $45($0_1 | 0, 8 | 0) | 0;
                                    continue label$76;
                                  }
                                }
                                $74($0_1 | 0, 0 | 0, $6_1 | 0);
                                $74($0_1 | 0, 4 | 0, (($45($0_1 | 0, 4 | 0) | 0) + $2_1) | 0 | 0);
                                $11_1 = ($6_1 + (((($6_1 + 8) | 0) & 7) | 0 ? (((-8 - $6_1) | 0) & 7) | 0 : 0)) | 0;
                                $74($11_1 | 0, 4 | 0, $3_1 | 3 | 0 | 0);
                                $2_1 = ($5_1 + (((($5_1 + 8) | 0) & 7) | 0 ? (((-8 - $5_1) | 0) & 7) | 0 : 0)) | 0;
                                $3_1 = ($11_1 + $3_1) | 0;
                                $5_1 = ($2_1 - $3_1) | 0;
                                label$78: {
                                  if (($4_1 | 0) != ($2_1 | 0)) {
                                    break label$78;
                                  }
                                  $74(0 | 0, 1692 | 0, $3_1 | 0);
                                  $0_1 = (($45(0 | 0, 1680 | 0) | 0) + $5_1) | 0;
                                  $74(0 | 0, 1680 | 0, $0_1 | 0);
                                  $74($3_1 | 0, 4 | 0, $0_1 | 1 | 0 | 0);
                                  break label$69;
                                }
                                label$79: {
                                  if (($45(0 | 0, 1688 | 0) | 0 | 0) != ($2_1 | 0)) {
                                    break label$79;
                                  }
                                  $74(0 | 0, 1688 | 0, $3_1 | 0);
                                  $0_1 = (($45(0 | 0, 1676 | 0) | 0) + $5_1) | 0;
                                  $74(0 | 0, 1676 | 0, $0_1 | 0);
                                  $74($3_1 | 0, 4 | 0, $0_1 | 1 | 0 | 0);
                                  $74(($3_1 + $0_1) | 0 | 0, 0 | 0, $0_1 | 0);
                                  break label$69;
                                }
                                label$80: {
                                  $0_1 = $45($2_1 | 0, 4 | 0) | 0;
                                  if ((($0_1 & 3) | 0 | 0) != (1 | 0)) {
                                    break label$80;
                                  }
                                  $7_1 = ($0_1 & -8) | 0;
                                  label$81: {
                                    label$82: {
                                      if ($0_1 >>> 0 > 255 >>> 0) {
                                        break label$82;
                                      }
                                      $4_1 = $45($2_1 | 0, 8 | 0) | 0;
                                      $8_1 = ($0_1 >>> 3) | 0;
                                      $6_1 = ((($8_1 << 3) | 0) + 1708) | 0;
                                      label$83: {
                                        $0_1 = $45($2_1 | 0, 12 | 0) | 0;
                                        if (($0_1 | 0) != ($4_1 | 0)) {
                                          break label$83;
                                        }
                                        $74(
                                          0 | 0,
                                          1668 | 0,
                                          (($45(0 | 0, 1668 | 0) | 0) & (__wasm_rotl_i32(-2 | 0, $8_1 | 0) | 0)) |
                                            0 |
                                            0,
                                        );
                                        break label$81;
                                      }
                                      $74($4_1 | 0, 12 | 0, $0_1 | 0);
                                      $74($0_1 | 0, 8 | 0, $4_1 | 0);
                                      break label$81;
                                    }
                                    $9_1 = $45($2_1 | 0, 24 | 0) | 0;
                                    label$84: {
                                      label$85: {
                                        $6_1 = $45($2_1 | 0, 12 | 0) | 0;
                                        if (($6_1 | 0) == ($2_1 | 0)) {
                                          break label$85;
                                        }
                                        $0_1 = $45($2_1 | 0, 8 | 0) | 0;
                                        $74($0_1 | 0, 12 | 0, $6_1 | 0);
                                        $74($6_1 | 0, 8 | 0, $0_1 | 0);
                                        break label$84;
                                      }
                                      label$86: {
                                        $0_1 = ($2_1 + 20) | 0;
                                        $4_1 = $45($0_1 | 0, 0 | 0) | 0;
                                        if ($4_1) {
                                          break label$86;
                                        }
                                        $0_1 = ($2_1 + 16) | 0;
                                        $4_1 = $45($0_1 | 0, 0 | 0) | 0;
                                        if ($4_1) {
                                          break label$86;
                                        }
                                        $6_1 = 0;
                                        break label$84;
                                      }
                                      label$87: while (1) {
                                        $8_1 = $0_1;
                                        $6_1 = $4_1;
                                        $0_1 = ($4_1 + 20) | 0;
                                        $4_1 = $45($0_1 | 0, 0 | 0) | 0;
                                        if ($4_1) {
                                          continue label$87;
                                        }
                                        $0_1 = ($6_1 + 16) | 0;
                                        $4_1 = $45($6_1 | 0, 16 | 0) | 0;
                                        if ($4_1) {
                                          continue label$87;
                                        }
                                        break label$87;
                                      }
                                      $74($8_1 | 0, 0 | 0, 0 | 0);
                                    }
                                    if (!$9_1) {
                                      break label$81;
                                    }
                                    label$88: {
                                      label$89: {
                                        $4_1 = $45($2_1 | 0, 28 | 0) | 0;
                                        $0_1 = ((($4_1 << 2) | 0) + 1972) | 0;
                                        if (($45($0_1 | 0, 0 | 0) | 0 | 0) != ($2_1 | 0)) {
                                          break label$89;
                                        }
                                        $74($0_1 | 0, 0 | 0, $6_1 | 0);
                                        if ($6_1) {
                                          break label$88;
                                        }
                                        $74(
                                          0 | 0,
                                          1672 | 0,
                                          (($45(0 | 0, 1672 | 0) | 0) & (__wasm_rotl_i32(-2 | 0, $4_1 | 0) | 0)) |
                                            0 |
                                            0,
                                        );
                                        break label$81;
                                      }
                                      $74(
                                        ($9_1 + (($45($9_1 | 0, 16 | 0) | 0 | 0) == ($2_1 | 0) ? 16 : 20)) | 0 | 0,
                                        0 | 0,
                                        $6_1 | 0,
                                      );
                                      if (!$6_1) {
                                        break label$81;
                                      }
                                    }
                                    $74($6_1 | 0, 24 | 0, $9_1 | 0);
                                    label$90: {
                                      $0_1 = $45($2_1 | 0, 16 | 0) | 0;
                                      if (!$0_1) {
                                        break label$90;
                                      }
                                      $74($6_1 | 0, 16 | 0, $0_1 | 0);
                                      $74($0_1 | 0, 24 | 0, $6_1 | 0);
                                    }
                                    $0_1 = $45($2_1 | 0, 20 | 0) | 0;
                                    if (!$0_1) {
                                      break label$81;
                                    }
                                    $74(($6_1 + 20) | 0 | 0, 0 | 0, $0_1 | 0);
                                    $74($0_1 | 0, 24 | 0, $6_1 | 0);
                                  }
                                  $5_1 = ($7_1 + $5_1) | 0;
                                  $2_1 = ($2_1 + $7_1) | 0;
                                }
                                $74($2_1 | 0, 4 | 0, (($45($2_1 | 0, 4 | 0) | 0) & -2) | 0 | 0);
                                $74($3_1 | 0, 4 | 0, $5_1 | 1 | 0 | 0);
                                $74(($3_1 + $5_1) | 0 | 0, 0 | 0, $5_1 | 0);
                                label$91: {
                                  if ($5_1 >>> 0 > 255 >>> 0) {
                                    break label$91;
                                  }
                                  $4_1 = ($5_1 >>> 3) | 0;
                                  $0_1 = ((($4_1 << 3) | 0) + 1708) | 0;
                                  label$92: {
                                    label$93: {
                                      $5_1 = $45(0 | 0, 1668 | 0) | 0;
                                      $4_1 = (1 << $4_1) | 0;
                                      if (($5_1 & $4_1) | 0) {
                                        break label$93;
                                      }
                                      $74(0 | 0, 1668 | 0, $5_1 | $4_1 | 0 | 0);
                                      $4_1 = $0_1;
                                      break label$92;
                                    }
                                    $4_1 = $45($0_1 | 0, 8 | 0) | 0;
                                  }
                                  $74($0_1 | 0, 8 | 0, $3_1 | 0);
                                  $74($4_1 | 0, 12 | 0, $3_1 | 0);
                                  $74($3_1 | 0, 12 | 0, $0_1 | 0);
                                  $74($3_1 | 0, 8 | 0, $4_1 | 0);
                                  break label$69;
                                }
                                $0_1 = 31;
                                label$94: {
                                  if ($5_1 >>> 0 > 16777215 >>> 0) {
                                    break label$94;
                                  }
                                  $0_1 = ($5_1 >>> 8) | 0;
                                  $1157 = $0_1;
                                  $0_1 = ((((($0_1 + 1048320) | 0) >>> 16) | 0) & 8) | 0;
                                  $4_1 = ($1157 << $0_1) | 0;
                                  $1164 = $4_1;
                                  $4_1 = ((((($4_1 + 520192) | 0) >>> 16) | 0) & 4) | 0;
                                  $6_1 = ($1164 << $4_1) | 0;
                                  $1171 = $6_1;
                                  $6_1 = ((((($6_1 + 245760) | 0) >>> 16) | 0) & 2) | 0;
                                  $0_1 = ((((($1171 << $6_1) | 0) >>> 15) | 0) - ($0_1 | $4_1 | 0 | $6_1 | 0)) | 0;
                                  $0_1 =
                                    ((($0_1 << 1) | 0 | (((($5_1 >>> (($0_1 + 21) | 0)) | 0) & 1) | 0) | 0) + 28) | 0;
                                }
                                $74($3_1 | 0, 28 | 0, $0_1 | 0);
                                i64toi32_i32$0 = 0;
                                $83($3_1 | 0, 16 | 0, 0 | 0, i64toi32_i32$0 | 0);
                                $4_1 = ((($0_1 << 2) | 0) + 1972) | 0;
                                label$95: {
                                  label$96: {
                                    $6_1 = $45(0 | 0, 1672 | 0) | 0;
                                    $8_1 = (1 << $0_1) | 0;
                                    if (($6_1 & $8_1) | 0) {
                                      break label$96;
                                    }
                                    $74(0 | 0, 1672 | 0, $6_1 | $8_1 | 0 | 0);
                                    $74($4_1 | 0, 0 | 0, $3_1 | 0);
                                    $74($3_1 | 0, 24 | 0, $4_1 | 0);
                                    break label$95;
                                  }
                                  $0_1 = ($5_1 << (($0_1 | 0) == (31 | 0) ? 0 : (25 - (($0_1 >>> 1) | 0)) | 0)) | 0;
                                  $6_1 = $45($4_1 | 0, 0 | 0) | 0;
                                  label$97: while (1) {
                                    $4_1 = $6_1;
                                    if (((($45($4_1 | 0, 4 | 0) | 0) & -8) | 0 | 0) == ($5_1 | 0)) {
                                      break label$70;
                                    }
                                    $6_1 = ($0_1 >>> 29) | 0;
                                    $0_1 = ($0_1 << 1) | 0;
                                    $8_1 = ((($4_1 + (($6_1 & 4) | 0)) | 0) + 16) | 0;
                                    $6_1 = $45($8_1 | 0, 0 | 0) | 0;
                                    if ($6_1) {
                                      continue label$97;
                                    }
                                    break label$97;
                                  }
                                  $74($8_1 | 0, 0 | 0, $3_1 | 0);
                                  $74($3_1 | 0, 24 | 0, $4_1 | 0);
                                }
                                $74($3_1 | 0, 12 | 0, $3_1 | 0);
                                $74($3_1 | 0, 8 | 0, $3_1 | 0);
                                break label$69;
                              }
                              $0_1 = ($2_1 + -40) | 0;
                              $8_1 = ((($6_1 + 8) | 0) & 7) | 0 ? (((-8 - $6_1) | 0) & 7) | 0 : 0;
                              $11_1 = ($0_1 - $8_1) | 0;
                              $74(0 | 0, 1680 | 0, $11_1 | 0);
                              $8_1 = ($6_1 + $8_1) | 0;
                              $74(0 | 0, 1692 | 0, $8_1 | 0);
                              $74($8_1 | 0, 4 | 0, $11_1 | 1 | 0 | 0);
                              $74(($6_1 + $0_1) | 0 | 0, 4 | 0, 40 | 0);
                              $74(0 | 0, 1696 | 0, $45(0 | 0, 2156 | 0) | 0 | 0);
                              $0_1 =
                                ((($5_1 + (((($5_1 + -39) | 0) & 7) | 0 ? (((39 - $5_1) | 0) & 7) | 0 : 0)) | 0) +
                                  -47) |
                                0;
                              $8_1 = $0_1 >>> 0 < (($4_1 + 16) | 0) >>> 0 ? $4_1 : $0_1;
                              $74($8_1 | 0, 4 | 0, 27 | 0);
                              i64toi32_i32$0 = $60(0 | 0, 2124 | 0) | 0;
                              i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
                              $83(($8_1 + 16) | 0 | 0, 0 | 0, i64toi32_i32$0 | 0, i64toi32_i32$1 | 0);
                              i64toi32_i32$1 = $60(0 | 0, 2116 | 0) | 0;
                              i64toi32_i32$0 = i64toi32_i32$HIGH_BITS;
                              $83($8_1 | 0, 8 | 0, i64toi32_i32$1 | 0, i64toi32_i32$0 | 0);
                              $74(0 | 0, 2124 | 0, ($8_1 + 8) | 0 | 0);
                              $74(0 | 0, 2120 | 0, $2_1 | 0);
                              $74(0 | 0, 2116 | 0, $6_1 | 0);
                              $74(0 | 0, 2128 | 0, 0 | 0);
                              $0_1 = ($8_1 + 24) | 0;
                              label$98: while (1) {
                                $74($0_1 | 0, 4 | 0, 7 | 0);
                                $6_1 = ($0_1 + 8) | 0;
                                $0_1 = ($0_1 + 4) | 0;
                                if ($5_1 >>> 0 > $6_1 >>> 0) {
                                  continue label$98;
                                }
                                break label$98;
                              }
                              if (($8_1 | 0) == ($4_1 | 0)) {
                                break label$59;
                              }
                              $74($8_1 | 0, 4 | 0, (($45($8_1 | 0, 4 | 0) | 0) & -2) | 0 | 0);
                              $2_1 = ($8_1 - $4_1) | 0;
                              $74($4_1 | 0, 4 | 0, $2_1 | 1 | 0 | 0);
                              $74($8_1 | 0, 0 | 0, $2_1 | 0);
                              label$99: {
                                if ($2_1 >>> 0 > 255 >>> 0) {
                                  break label$99;
                                }
                                $5_1 = ($2_1 >>> 3) | 0;
                                $0_1 = ((($5_1 << 3) | 0) + 1708) | 0;
                                label$100: {
                                  label$101: {
                                    $6_1 = $45(0 | 0, 1668 | 0) | 0;
                                    $5_1 = (1 << $5_1) | 0;
                                    if (($6_1 & $5_1) | 0) {
                                      break label$101;
                                    }
                                    $74(0 | 0, 1668 | 0, $6_1 | $5_1 | 0 | 0);
                                    $5_1 = $0_1;
                                    break label$100;
                                  }
                                  $5_1 = $45($0_1 | 0, 8 | 0) | 0;
                                }
                                $74($0_1 | 0, 8 | 0, $4_1 | 0);
                                $74($5_1 | 0, 12 | 0, $4_1 | 0);
                                $74($4_1 | 0, 12 | 0, $0_1 | 0);
                                $74($4_1 | 0, 8 | 0, $5_1 | 0);
                                break label$59;
                              }
                              $0_1 = 31;
                              label$102: {
                                if ($2_1 >>> 0 > 16777215 >>> 0) {
                                  break label$102;
                                }
                                $0_1 = ($2_1 >>> 8) | 0;
                                $1356 = $0_1;
                                $0_1 = ((((($0_1 + 1048320) | 0) >>> 16) | 0) & 8) | 0;
                                $5_1 = ($1356 << $0_1) | 0;
                                $1363 = $5_1;
                                $5_1 = ((((($5_1 + 520192) | 0) >>> 16) | 0) & 4) | 0;
                                $6_1 = ($1363 << $5_1) | 0;
                                $1370 = $6_1;
                                $6_1 = ((((($6_1 + 245760) | 0) >>> 16) | 0) & 2) | 0;
                                $0_1 = ((((($1370 << $6_1) | 0) >>> 15) | 0) - ($0_1 | $5_1 | 0 | $6_1 | 0)) | 0;
                                $0_1 =
                                  ((($0_1 << 1) | 0 | (((($2_1 >>> (($0_1 + 21) | 0)) | 0) & 1) | 0) | 0) + 28) | 0;
                              }
                              i64toi32_i32$0 = 0;
                              $83($4_1 | 0, 16 | 0, 0 | 0, i64toi32_i32$0 | 0);
                              $74(($4_1 + 28) | 0 | 0, 0 | 0, $0_1 | 0);
                              $5_1 = ((($0_1 << 2) | 0) + 1972) | 0;
                              label$103: {
                                label$104: {
                                  $6_1 = $45(0 | 0, 1672 | 0) | 0;
                                  $8_1 = (1 << $0_1) | 0;
                                  if (($6_1 & $8_1) | 0) {
                                    break label$104;
                                  }
                                  $74(0 | 0, 1672 | 0, $6_1 | $8_1 | 0 | 0);
                                  $74($5_1 | 0, 0 | 0, $4_1 | 0);
                                  $74(($4_1 + 24) | 0 | 0, 0 | 0, $5_1 | 0);
                                  break label$103;
                                }
                                $0_1 = ($2_1 << (($0_1 | 0) == (31 | 0) ? 0 : (25 - (($0_1 >>> 1) | 0)) | 0)) | 0;
                                $6_1 = $45($5_1 | 0, 0 | 0) | 0;
                                label$105: while (1) {
                                  $5_1 = $6_1;
                                  if (((($45($6_1 | 0, 4 | 0) | 0) & -8) | 0 | 0) == ($2_1 | 0)) {
                                    break label$68;
                                  }
                                  $6_1 = ($0_1 >>> 29) | 0;
                                  $0_1 = ($0_1 << 1) | 0;
                                  $8_1 = ((($5_1 + (($6_1 & 4) | 0)) | 0) + 16) | 0;
                                  $6_1 = $45($8_1 | 0, 0 | 0) | 0;
                                  if ($6_1) {
                                    continue label$105;
                                  }
                                  break label$105;
                                }
                                $74($8_1 | 0, 0 | 0, $4_1 | 0);
                                $74(($4_1 + 24) | 0 | 0, 0 | 0, $5_1 | 0);
                              }
                              $74($4_1 | 0, 12 | 0, $4_1 | 0);
                              $74($4_1 | 0, 8 | 0, $4_1 | 0);
                              break label$59;
                            }
                            $0_1 = $45($4_1 | 0, 8 | 0) | 0;
                            $74($0_1 | 0, 12 | 0, $3_1 | 0);
                            $74($4_1 | 0, 8 | 0, $3_1 | 0);
                            $74($3_1 | 0, 24 | 0, 0 | 0);
                            $74($3_1 | 0, 12 | 0, $4_1 | 0);
                            $74($3_1 | 0, 8 | 0, $0_1 | 0);
                          }
                          $0_1 = ($11_1 + 8) | 0;
                          break label$1;
                        }
                        $0_1 = $45($5_1 | 0, 8 | 0) | 0;
                        $74($0_1 | 0, 12 | 0, $4_1 | 0);
                        $74($5_1 | 0, 8 | 0, $4_1 | 0);
                        $74(($4_1 + 24) | 0 | 0, 0 | 0, 0 | 0);
                        $74($4_1 | 0, 12 | 0, $5_1 | 0);
                        $74($4_1 | 0, 8 | 0, $0_1 | 0);
                      }
                      $0_1 = $45(0 | 0, 1680 | 0) | 0;
                      if ($0_1 >>> 0 <= $3_1 >>> 0) {
                        break label$4;
                      }
                      $4_1 = ($0_1 - $3_1) | 0;
                      $74(0 | 0, 1680 | 0, $4_1 | 0);
                      $0_1 = $45(0 | 0, 1692 | 0) | 0;
                      $5_1 = ($0_1 + $3_1) | 0;
                      $74(0 | 0, 1692 | 0, $5_1 | 0);
                      $74($5_1 | 0, 4 | 0, $4_1 | 1 | 0 | 0);
                      $74($0_1 | 0, 4 | 0, $3_1 | 3 | 0 | 0);
                      $0_1 = ($0_1 + 8) | 0;
                      break label$1;
                    }
                    $74($21() | 0 | 0, 0 | 0, 48 | 0);
                    $0_1 = 0;
                    break label$1;
                  }
                  label$106: {
                    if (!$11_1) {
                      break label$106;
                    }
                    label$107: {
                      label$108: {
                        $5_1 = $45($8_1 | 0, 28 | 0) | 0;
                        $0_1 = ((($5_1 << 2) | 0) + 1972) | 0;
                        if (($8_1 | 0) != ($45($0_1 | 0, 0 | 0) | 0 | 0)) {
                          break label$108;
                        }
                        $74($0_1 | 0, 0 | 0, $6_1 | 0);
                        if ($6_1) {
                          break label$107;
                        }
                        $7_1 = ($7_1 & (__wasm_rotl_i32(-2 | 0, $5_1 | 0) | 0)) | 0;
                        $74(0 | 0, 1672 | 0, $7_1 | 0);
                        break label$106;
                      }
                      $74(
                        ($11_1 + (($45($11_1 | 0, 16 | 0) | 0 | 0) == ($8_1 | 0) ? 16 : 20)) | 0 | 0,
                        0 | 0,
                        $6_1 | 0,
                      );
                      if (!$6_1) {
                        break label$106;
                      }
                    }
                    $74($6_1 | 0, 24 | 0, $11_1 | 0);
                    label$109: {
                      $0_1 = $45($8_1 | 0, 16 | 0) | 0;
                      if (!$0_1) {
                        break label$109;
                      }
                      $74($6_1 | 0, 16 | 0, $0_1 | 0);
                      $74($0_1 | 0, 24 | 0, $6_1 | 0);
                    }
                    $0_1 = $45(($8_1 + 20) | 0 | 0, 0 | 0) | 0;
                    if (!$0_1) {
                      break label$106;
                    }
                    $74(($6_1 + 20) | 0 | 0, 0 | 0, $0_1 | 0);
                    $74($0_1 | 0, 24 | 0, $6_1 | 0);
                  }
                  label$110: {
                    label$111: {
                      if ($4_1 >>> 0 > 15 >>> 0) {
                        break label$111;
                      }
                      $0_1 = ($4_1 + $3_1) | 0;
                      $74($8_1 | 0, 4 | 0, $0_1 | 3 | 0 | 0);
                      $0_1 = ($8_1 + $0_1) | 0;
                      $74($0_1 | 0, 4 | 0, $45($0_1 | 0, 4 | 0) | 0 | 1 | 0 | 0);
                      break label$110;
                    }
                    $74($8_1 | 0, 4 | 0, $3_1 | 3 | 0 | 0);
                    $6_1 = ($8_1 + $3_1) | 0;
                    $74($6_1 | 0, 4 | 0, $4_1 | 1 | 0 | 0);
                    $74(($6_1 + $4_1) | 0 | 0, 0 | 0, $4_1 | 0);
                    label$112: {
                      if ($4_1 >>> 0 > 255 >>> 0) {
                        break label$112;
                      }
                      $4_1 = ($4_1 >>> 3) | 0;
                      $0_1 = ((($4_1 << 3) | 0) + 1708) | 0;
                      label$113: {
                        label$114: {
                          $5_1 = $45(0 | 0, 1668 | 0) | 0;
                          $4_1 = (1 << $4_1) | 0;
                          if (($5_1 & $4_1) | 0) {
                            break label$114;
                          }
                          $74(0 | 0, 1668 | 0, $5_1 | $4_1 | 0 | 0);
                          $4_1 = $0_1;
                          break label$113;
                        }
                        $4_1 = $45($0_1 | 0, 8 | 0) | 0;
                      }
                      $74($0_1 | 0, 8 | 0, $6_1 | 0);
                      $74($4_1 | 0, 12 | 0, $6_1 | 0);
                      $74($6_1 | 0, 12 | 0, $0_1 | 0);
                      $74($6_1 | 0, 8 | 0, $4_1 | 0);
                      break label$110;
                    }
                    $0_1 = 31;
                    label$115: {
                      if ($4_1 >>> 0 > 16777215 >>> 0) {
                        break label$115;
                      }
                      $0_1 = ($4_1 >>> 8) | 0;
                      $1606 = $0_1;
                      $0_1 = ((((($0_1 + 1048320) | 0) >>> 16) | 0) & 8) | 0;
                      $5_1 = ($1606 << $0_1) | 0;
                      $1613 = $5_1;
                      $5_1 = ((((($5_1 + 520192) | 0) >>> 16) | 0) & 4) | 0;
                      $3_1 = ($1613 << $5_1) | 0;
                      $1620 = $3_1;
                      $3_1 = ((((($3_1 + 245760) | 0) >>> 16) | 0) & 2) | 0;
                      $0_1 = ((((($1620 << $3_1) | 0) >>> 15) | 0) - ($0_1 | $5_1 | 0 | $3_1 | 0)) | 0;
                      $0_1 = ((($0_1 << 1) | 0 | (((($4_1 >>> (($0_1 + 21) | 0)) | 0) & 1) | 0) | 0) + 28) | 0;
                    }
                    $74($6_1 | 0, 28 | 0, $0_1 | 0);
                    i64toi32_i32$0 = 0;
                    $83($6_1 | 0, 16 | 0, 0 | 0, i64toi32_i32$0 | 0);
                    $5_1 = ((($0_1 << 2) | 0) + 1972) | 0;
                    label$116: {
                      label$117: {
                        label$118: {
                          $3_1 = (1 << $0_1) | 0;
                          if (($7_1 & $3_1) | 0) {
                            break label$118;
                          }
                          $74(0 | 0, 1672 | 0, $7_1 | $3_1 | 0 | 0);
                          $74($5_1 | 0, 0 | 0, $6_1 | 0);
                          $74($6_1 | 0, 24 | 0, $5_1 | 0);
                          break label$117;
                        }
                        $0_1 = ($4_1 << (($0_1 | 0) == (31 | 0) ? 0 : (25 - (($0_1 >>> 1) | 0)) | 0)) | 0;
                        $3_1 = $45($5_1 | 0, 0 | 0) | 0;
                        label$119: while (1) {
                          $5_1 = $3_1;
                          if (((($45($5_1 | 0, 4 | 0) | 0) & -8) | 0 | 0) == ($4_1 | 0)) {
                            break label$116;
                          }
                          $3_1 = ($0_1 >>> 29) | 0;
                          $0_1 = ($0_1 << 1) | 0;
                          $2_1 = ((($5_1 + (($3_1 & 4) | 0)) | 0) + 16) | 0;
                          $3_1 = $45($2_1 | 0, 0 | 0) | 0;
                          if ($3_1) {
                            continue label$119;
                          }
                          break label$119;
                        }
                        $74($2_1 | 0, 0 | 0, $6_1 | 0);
                        $74($6_1 | 0, 24 | 0, $5_1 | 0);
                      }
                      $74($6_1 | 0, 12 | 0, $6_1 | 0);
                      $74($6_1 | 0, 8 | 0, $6_1 | 0);
                      break label$110;
                    }
                    $0_1 = $45($5_1 | 0, 8 | 0) | 0;
                    $74($0_1 | 0, 12 | 0, $6_1 | 0);
                    $74($5_1 | 0, 8 | 0, $6_1 | 0);
                    $74($6_1 | 0, 24 | 0, 0 | 0);
                    $74($6_1 | 0, 12 | 0, $5_1 | 0);
                    $74($6_1 | 0, 8 | 0, $0_1 | 0);
                  }
                  $0_1 = ($8_1 + 8) | 0;
                  break label$1;
                }
                label$120: {
                  if (!$10_1) {
                    break label$120;
                  }
                  label$121: {
                    label$122: {
                      $5_1 = $45($6_1 | 0, 28 | 0) | 0;
                      $0_1 = ((($5_1 << 2) | 0) + 1972) | 0;
                      if (($6_1 | 0) != ($45($0_1 | 0, 0 | 0) | 0 | 0)) {
                        break label$122;
                      }
                      $74($0_1 | 0, 0 | 0, $8_1 | 0);
                      if ($8_1) {
                        break label$121;
                      }
                      $74(0 | 0, 1672 | 0, ($9_1 & (__wasm_rotl_i32(-2 | 0, $5_1 | 0) | 0)) | 0 | 0);
                      break label$120;
                    }
                    $74(($10_1 + (($45($10_1 | 0, 16 | 0) | 0 | 0) == ($6_1 | 0) ? 16 : 20)) | 0 | 0, 0 | 0, $8_1 | 0);
                    if (!$8_1) {
                      break label$120;
                    }
                  }
                  $74($8_1 | 0, 24 | 0, $10_1 | 0);
                  label$123: {
                    $0_1 = $45($6_1 | 0, 16 | 0) | 0;
                    if (!$0_1) {
                      break label$123;
                    }
                    $74($8_1 | 0, 16 | 0, $0_1 | 0);
                    $74($0_1 | 0, 24 | 0, $8_1 | 0);
                  }
                  $0_1 = $45(($6_1 + 20) | 0 | 0, 0 | 0) | 0;
                  if (!$0_1) {
                    break label$120;
                  }
                  $74(($8_1 + 20) | 0 | 0, 0 | 0, $0_1 | 0);
                  $74($0_1 | 0, 24 | 0, $8_1 | 0);
                }
                label$124: {
                  label$125: {
                    if ($4_1 >>> 0 > 15 >>> 0) {
                      break label$125;
                    }
                    $0_1 = ($4_1 + $3_1) | 0;
                    $74($6_1 | 0, 4 | 0, $0_1 | 3 | 0 | 0);
                    $0_1 = ($6_1 + $0_1) | 0;
                    $74($0_1 | 0, 4 | 0, $45($0_1 | 0, 4 | 0) | 0 | 1 | 0 | 0);
                    break label$124;
                  }
                  $74($6_1 | 0, 4 | 0, $3_1 | 3 | 0 | 0);
                  $5_1 = ($6_1 + $3_1) | 0;
                  $74($5_1 | 0, 4 | 0, $4_1 | 1 | 0 | 0);
                  $74(($5_1 + $4_1) | 0 | 0, 0 | 0, $4_1 | 0);
                  label$126: {
                    if (!$7_1) {
                      break label$126;
                    }
                    $8_1 = ($7_1 >>> 3) | 0;
                    $3_1 = ((($8_1 << 3) | 0) + 1708) | 0;
                    $0_1 = $45(0 | 0, 1688 | 0) | 0;
                    label$127: {
                      label$128: {
                        $8_1 = (1 << $8_1) | 0;
                        if (($8_1 & $2_1) | 0) {
                          break label$128;
                        }
                        $74(0 | 0, 1668 | 0, $8_1 | $2_1 | 0 | 0);
                        $8_1 = $3_1;
                        break label$127;
                      }
                      $8_1 = $45($3_1 | 0, 8 | 0) | 0;
                    }
                    $74($3_1 | 0, 8 | 0, $0_1 | 0);
                    $74($8_1 | 0, 12 | 0, $0_1 | 0);
                    $74($0_1 | 0, 12 | 0, $3_1 | 0);
                    $74($0_1 | 0, 8 | 0, $8_1 | 0);
                  }
                  $74(0 | 0, 1688 | 0, $5_1 | 0);
                  $74(0 | 0, 1676 | 0, $4_1 | 0);
                }
                $0_1 = ($6_1 + 8) | 0;
              }
              global$0 = ($1_1 + 16) | 0;
              return $0_1 | 0;
            }

            function $25($0_1) {
              $0_1 = $0_1 | 0;
              var $2_1 = 0,
                $6_1 = 0,
                $1_1 = 0,
                $4_1 = 0,
                $3_1 = 0,
                $5_1 = 0,
                $7_1 = 0,
                $248 = 0,
                $379 = 0,
                $386 = 0,
                $393 = 0;
              label$1: {
                if (!$0_1) {
                  break label$1;
                }
                $1_1 = ($0_1 + -8) | 0;
                $2_1 = $45(($0_1 + -4) | 0 | 0, 0 | 0) | 0;
                $0_1 = ($2_1 & -8) | 0;
                $3_1 = ($1_1 + $0_1) | 0;
                label$2: {
                  if (($2_1 & 1) | 0) {
                    break label$2;
                  }
                  if (!(($2_1 & 3) | 0)) {
                    break label$1;
                  }
                  $2_1 = $45($1_1 | 0, 0 | 0) | 0;
                  $1_1 = ($1_1 - $2_1) | 0;
                  $4_1 = $45(0 | 0, 1684 | 0) | 0;
                  if ($1_1 >>> 0 < $4_1 >>> 0) {
                    break label$1;
                  }
                  $0_1 = ($2_1 + $0_1) | 0;
                  label$3: {
                    if (($45(0 | 0, 1688 | 0) | 0 | 0) == ($1_1 | 0)) {
                      break label$3;
                    }
                    label$4: {
                      if ($2_1 >>> 0 > 255 >>> 0) {
                        break label$4;
                      }
                      $4_1 = $45($1_1 | 0, 8 | 0) | 0;
                      $5_1 = ($2_1 >>> 3) | 0;
                      $6_1 = ((($5_1 << 3) | 0) + 1708) | 0;
                      label$5: {
                        $2_1 = $45($1_1 | 0, 12 | 0) | 0;
                        if (($2_1 | 0) != ($4_1 | 0)) {
                          break label$5;
                        }
                        $74(
                          0 | 0,
                          1668 | 0,
                          (($45(0 | 0, 1668 | 0) | 0) & (__wasm_rotl_i32(-2 | 0, $5_1 | 0) | 0)) | 0 | 0,
                        );
                        break label$2;
                      }
                      $74($4_1 | 0, 12 | 0, $2_1 | 0);
                      $74($2_1 | 0, 8 | 0, $4_1 | 0);
                      break label$2;
                    }
                    $7_1 = $45($1_1 | 0, 24 | 0) | 0;
                    label$6: {
                      label$7: {
                        $6_1 = $45($1_1 | 0, 12 | 0) | 0;
                        if (($6_1 | 0) == ($1_1 | 0)) {
                          break label$7;
                        }
                        $2_1 = $45($1_1 | 0, 8 | 0) | 0;
                        $74($2_1 | 0, 12 | 0, $6_1 | 0);
                        $74($6_1 | 0, 8 | 0, $2_1 | 0);
                        break label$6;
                      }
                      label$8: {
                        $2_1 = ($1_1 + 20) | 0;
                        $4_1 = $45($2_1 | 0, 0 | 0) | 0;
                        if ($4_1) {
                          break label$8;
                        }
                        $2_1 = ($1_1 + 16) | 0;
                        $4_1 = $45($2_1 | 0, 0 | 0) | 0;
                        if ($4_1) {
                          break label$8;
                        }
                        $6_1 = 0;
                        break label$6;
                      }
                      label$9: while (1) {
                        $5_1 = $2_1;
                        $6_1 = $4_1;
                        $2_1 = ($6_1 + 20) | 0;
                        $4_1 = $45($2_1 | 0, 0 | 0) | 0;
                        if ($4_1) {
                          continue label$9;
                        }
                        $2_1 = ($6_1 + 16) | 0;
                        $4_1 = $45($6_1 | 0, 16 | 0) | 0;
                        if ($4_1) {
                          continue label$9;
                        }
                        break label$9;
                      }
                      $74($5_1 | 0, 0 | 0, 0 | 0);
                    }
                    if (!$7_1) {
                      break label$2;
                    }
                    label$10: {
                      label$11: {
                        $4_1 = $45($1_1 | 0, 28 | 0) | 0;
                        $2_1 = ((($4_1 << 2) | 0) + 1972) | 0;
                        if (($45($2_1 | 0, 0 | 0) | 0 | 0) != ($1_1 | 0)) {
                          break label$11;
                        }
                        $74($2_1 | 0, 0 | 0, $6_1 | 0);
                        if ($6_1) {
                          break label$10;
                        }
                        $74(
                          0 | 0,
                          1672 | 0,
                          (($45(0 | 0, 1672 | 0) | 0) & (__wasm_rotl_i32(-2 | 0, $4_1 | 0) | 0)) | 0 | 0,
                        );
                        break label$2;
                      }
                      $74(($7_1 + (($45($7_1 | 0, 16 | 0) | 0 | 0) == ($1_1 | 0) ? 16 : 20)) | 0 | 0, 0 | 0, $6_1 | 0);
                      if (!$6_1) {
                        break label$2;
                      }
                    }
                    $74($6_1 | 0, 24 | 0, $7_1 | 0);
                    label$12: {
                      $2_1 = $45($1_1 | 0, 16 | 0) | 0;
                      if (!$2_1) {
                        break label$12;
                      }
                      $74($6_1 | 0, 16 | 0, $2_1 | 0);
                      $74($2_1 | 0, 24 | 0, $6_1 | 0);
                    }
                    $2_1 = $45($1_1 | 0, 20 | 0) | 0;
                    if (!$2_1) {
                      break label$2;
                    }
                    $74(($6_1 + 20) | 0 | 0, 0 | 0, $2_1 | 0);
                    $74($2_1 | 0, 24 | 0, $6_1 | 0);
                    break label$2;
                  }
                  $2_1 = $45($3_1 | 0, 4 | 0) | 0;
                  if ((($2_1 & 3) | 0 | 0) != (3 | 0)) {
                    break label$2;
                  }
                  $74(0 | 0, 1676 | 0, $0_1 | 0);
                  $74($3_1 | 0, 4 | 0, ($2_1 & -2) | 0 | 0);
                  $74($1_1 | 0, 4 | 0, $0_1 | 1 | 0 | 0);
                  $74(($1_1 + $0_1) | 0 | 0, 0 | 0, $0_1 | 0);
                  return;
                }
                if ($3_1 >>> 0 <= $1_1 >>> 0) {
                  break label$1;
                }
                $2_1 = $45($3_1 | 0, 4 | 0) | 0;
                if (!(($2_1 & 1) | 0)) {
                  break label$1;
                }
                label$13: {
                  label$14: {
                    if (($2_1 & 2) | 0) {
                      break label$14;
                    }
                    label$15: {
                      if (($45(0 | 0, 1692 | 0) | 0 | 0) != ($3_1 | 0)) {
                        break label$15;
                      }
                      $74(0 | 0, 1692 | 0, $1_1 | 0);
                      $0_1 = (($45(0 | 0, 1680 | 0) | 0) + $0_1) | 0;
                      $74(0 | 0, 1680 | 0, $0_1 | 0);
                      $74($1_1 | 0, 4 | 0, $0_1 | 1 | 0 | 0);
                      if (($1_1 | 0) != ($45(0 | 0, 1688 | 0) | 0 | 0)) {
                        break label$1;
                      }
                      $74(0 | 0, 1676 | 0, 0 | 0);
                      $74(0 | 0, 1688 | 0, 0 | 0);
                      return;
                    }
                    label$16: {
                      if (($45(0 | 0, 1688 | 0) | 0 | 0) != ($3_1 | 0)) {
                        break label$16;
                      }
                      $74(0 | 0, 1688 | 0, $1_1 | 0);
                      $0_1 = (($45(0 | 0, 1676 | 0) | 0) + $0_1) | 0;
                      $74(0 | 0, 1676 | 0, $0_1 | 0);
                      $74($1_1 | 0, 4 | 0, $0_1 | 1 | 0 | 0);
                      $74(($1_1 + $0_1) | 0 | 0, 0 | 0, $0_1 | 0);
                      return;
                    }
                    $0_1 = ((($2_1 & -8) | 0) + $0_1) | 0;
                    label$17: {
                      label$18: {
                        if ($2_1 >>> 0 > 255 >>> 0) {
                          break label$18;
                        }
                        $4_1 = $45($3_1 | 0, 8 | 0) | 0;
                        $5_1 = ($2_1 >>> 3) | 0;
                        $6_1 = ((($5_1 << 3) | 0) + 1708) | 0;
                        label$19: {
                          $2_1 = $45($3_1 | 0, 12 | 0) | 0;
                          if (($2_1 | 0) != ($4_1 | 0)) {
                            break label$19;
                          }
                          $74(
                            0 | 0,
                            1668 | 0,
                            (($45(0 | 0, 1668 | 0) | 0) & (__wasm_rotl_i32(-2 | 0, $5_1 | 0) | 0)) | 0 | 0,
                          );
                          break label$17;
                        }
                        $74($4_1 | 0, 12 | 0, $2_1 | 0);
                        $74($2_1 | 0, 8 | 0, $4_1 | 0);
                        break label$17;
                      }
                      $7_1 = $45($3_1 | 0, 24 | 0) | 0;
                      label$20: {
                        label$21: {
                          $6_1 = $45($3_1 | 0, 12 | 0) | 0;
                          if (($6_1 | 0) == ($3_1 | 0)) {
                            break label$21;
                          }
                          $248 = $45(0 | 0, 1684 | 0) | 0;
                          $2_1 = $45($3_1 | 0, 8 | 0) | 0;
                          $74($2_1 | 0, 12 | 0, $6_1 | 0);
                          $74($6_1 | 0, 8 | 0, $2_1 | 0);
                          break label$20;
                        }
                        label$22: {
                          $2_1 = ($3_1 + 20) | 0;
                          $4_1 = $45($2_1 | 0, 0 | 0) | 0;
                          if ($4_1) {
                            break label$22;
                          }
                          $2_1 = ($3_1 + 16) | 0;
                          $4_1 = $45($2_1 | 0, 0 | 0) | 0;
                          if ($4_1) {
                            break label$22;
                          }
                          $6_1 = 0;
                          break label$20;
                        }
                        label$23: while (1) {
                          $5_1 = $2_1;
                          $6_1 = $4_1;
                          $2_1 = ($6_1 + 20) | 0;
                          $4_1 = $45($2_1 | 0, 0 | 0) | 0;
                          if ($4_1) {
                            continue label$23;
                          }
                          $2_1 = ($6_1 + 16) | 0;
                          $4_1 = $45($6_1 | 0, 16 | 0) | 0;
                          if ($4_1) {
                            continue label$23;
                          }
                          break label$23;
                        }
                        $74($5_1 | 0, 0 | 0, 0 | 0);
                      }
                      if (!$7_1) {
                        break label$17;
                      }
                      label$24: {
                        label$25: {
                          $4_1 = $45($3_1 | 0, 28 | 0) | 0;
                          $2_1 = ((($4_1 << 2) | 0) + 1972) | 0;
                          if (($45($2_1 | 0, 0 | 0) | 0 | 0) != ($3_1 | 0)) {
                            break label$25;
                          }
                          $74($2_1 | 0, 0 | 0, $6_1 | 0);
                          if ($6_1) {
                            break label$24;
                          }
                          $74(
                            0 | 0,
                            1672 | 0,
                            (($45(0 | 0, 1672 | 0) | 0) & (__wasm_rotl_i32(-2 | 0, $4_1 | 0) | 0)) | 0 | 0,
                          );
                          break label$17;
                        }
                        $74(
                          ($7_1 + (($45($7_1 | 0, 16 | 0) | 0 | 0) == ($3_1 | 0) ? 16 : 20)) | 0 | 0,
                          0 | 0,
                          $6_1 | 0,
                        );
                        if (!$6_1) {
                          break label$17;
                        }
                      }
                      $74($6_1 | 0, 24 | 0, $7_1 | 0);
                      label$26: {
                        $2_1 = $45($3_1 | 0, 16 | 0) | 0;
                        if (!$2_1) {
                          break label$26;
                        }
                        $74($6_1 | 0, 16 | 0, $2_1 | 0);
                        $74($2_1 | 0, 24 | 0, $6_1 | 0);
                      }
                      $2_1 = $45($3_1 | 0, 20 | 0) | 0;
                      if (!$2_1) {
                        break label$17;
                      }
                      $74(($6_1 + 20) | 0 | 0, 0 | 0, $2_1 | 0);
                      $74($2_1 | 0, 24 | 0, $6_1 | 0);
                    }
                    $74($1_1 | 0, 4 | 0, $0_1 | 1 | 0 | 0);
                    $74(($1_1 + $0_1) | 0 | 0, 0 | 0, $0_1 | 0);
                    if (($1_1 | 0) != ($45(0 | 0, 1688 | 0) | 0 | 0)) {
                      break label$13;
                    }
                    $74(0 | 0, 1676 | 0, $0_1 | 0);
                    return;
                  }
                  $74($3_1 | 0, 4 | 0, ($2_1 & -2) | 0 | 0);
                  $74($1_1 | 0, 4 | 0, $0_1 | 1 | 0 | 0);
                  $74(($1_1 + $0_1) | 0 | 0, 0 | 0, $0_1 | 0);
                }
                label$27: {
                  if ($0_1 >>> 0 > 255 >>> 0) {
                    break label$27;
                  }
                  $2_1 = ($0_1 >>> 3) | 0;
                  $0_1 = ((($2_1 << 3) | 0) + 1708) | 0;
                  label$28: {
                    label$29: {
                      $4_1 = $45(0 | 0, 1668 | 0) | 0;
                      $2_1 = (1 << $2_1) | 0;
                      if (($4_1 & $2_1) | 0) {
                        break label$29;
                      }
                      $74(0 | 0, 1668 | 0, $4_1 | $2_1 | 0 | 0);
                      $2_1 = $0_1;
                      break label$28;
                    }
                    $2_1 = $45($0_1 | 0, 8 | 0) | 0;
                  }
                  $74($0_1 | 0, 8 | 0, $1_1 | 0);
                  $74($2_1 | 0, 12 | 0, $1_1 | 0);
                  $74($1_1 | 0, 12 | 0, $0_1 | 0);
                  $74($1_1 | 0, 8 | 0, $2_1 | 0);
                  return;
                }
                $2_1 = 31;
                label$30: {
                  if ($0_1 >>> 0 > 16777215 >>> 0) {
                    break label$30;
                  }
                  $2_1 = ($0_1 >>> 8) | 0;
                  $379 = $2_1;
                  $2_1 = ((((($2_1 + 1048320) | 0) >>> 16) | 0) & 8) | 0;
                  $4_1 = ($379 << $2_1) | 0;
                  $386 = $4_1;
                  $4_1 = ((((($4_1 + 520192) | 0) >>> 16) | 0) & 4) | 0;
                  $6_1 = ($386 << $4_1) | 0;
                  $393 = $6_1;
                  $6_1 = ((((($6_1 + 245760) | 0) >>> 16) | 0) & 2) | 0;
                  $2_1 = ((((($393 << $6_1) | 0) >>> 15) | 0) - ($2_1 | $4_1 | 0 | $6_1 | 0)) | 0;
                  $2_1 = ((($2_1 << 1) | 0 | (((($0_1 >>> (($2_1 + 21) | 0)) | 0) & 1) | 0) | 0) + 28) | 0;
                }
                $83($1_1 | 0, 16 | 0, 0 | 0, 0 | 0);
                $74(($1_1 + 28) | 0 | 0, 0 | 0, $2_1 | 0);
                $4_1 = ((($2_1 << 2) | 0) + 1972) | 0;
                label$31: {
                  label$32: {
                    label$33: {
                      label$34: {
                        $6_1 = $45(0 | 0, 1672 | 0) | 0;
                        $3_1 = (1 << $2_1) | 0;
                        if (($6_1 & $3_1) | 0) {
                          break label$34;
                        }
                        $74(0 | 0, 1672 | 0, $6_1 | $3_1 | 0 | 0);
                        $74($4_1 | 0, 0 | 0, $1_1 | 0);
                        $74(($1_1 + 24) | 0 | 0, 0 | 0, $4_1 | 0);
                        break label$33;
                      }
                      $2_1 = ($0_1 << (($2_1 | 0) == (31 | 0) ? 0 : (25 - (($2_1 >>> 1) | 0)) | 0)) | 0;
                      $6_1 = $45($4_1 | 0, 0 | 0) | 0;
                      label$35: while (1) {
                        $4_1 = $6_1;
                        if (((($45($6_1 | 0, 4 | 0) | 0) & -8) | 0 | 0) == ($0_1 | 0)) {
                          break label$32;
                        }
                        $6_1 = ($2_1 >>> 29) | 0;
                        $2_1 = ($2_1 << 1) | 0;
                        $3_1 = ((($4_1 + (($6_1 & 4) | 0)) | 0) + 16) | 0;
                        $6_1 = $45($3_1 | 0, 0 | 0) | 0;
                        if ($6_1) {
                          continue label$35;
                        }
                        break label$35;
                      }
                      $74($3_1 | 0, 0 | 0, $1_1 | 0);
                      $74(($1_1 + 24) | 0 | 0, 0 | 0, $4_1 | 0);
                    }
                    $74($1_1 | 0, 12 | 0, $1_1 | 0);
                    $74($1_1 | 0, 8 | 0, $1_1 | 0);
                    break label$31;
                  }
                  $0_1 = $45($4_1 | 0, 8 | 0) | 0;
                  $74($0_1 | 0, 12 | 0, $1_1 | 0);
                  $74($4_1 | 0, 8 | 0, $1_1 | 0);
                  $74(($1_1 + 24) | 0 | 0, 0 | 0, 0 | 0);
                  $74($1_1 | 0, 12 | 0, $4_1 | 0);
                  $74($1_1 | 0, 8 | 0, $0_1 | 0);
                }
                $1_1 = (($45(0 | 0, 1700 | 0) | 0) + -1) | 0;
                $74(0 | 0, 1700 | 0, ($1_1 ? $1_1 : -1) | 0);
              }
            }

            function $26() {
              global$2 = 34944;
              global$1 = (((2176 + 15) | 0) & -16) | 0;
            }

            function $27() {
              return (global$0 - global$1) | 0 | 0;
            }

            function $28() {
              return global$2 | 0;
            }

            function $29() {
              return global$1 | 0;
            }

            function $30($0_1) {
              $0_1 = $0_1 | 0;
            }

            function $31($0_1) {
              $0_1 = $0_1 | 0;
            }

            function $32() {
              $30(2164 | 0);
              return 2168 | 0;
            }

            function $33() {
              $31(2164 | 0);
            }

            function $34($0_1) {
              $0_1 = $0_1 | 0;
              return 1 | 0;
            }

            function $35($0_1) {
              $0_1 = $0_1 | 0;
            }

            function $36($0_1) {
              $0_1 = $0_1 | 0;
              var $1_1 = 0,
                i64toi32_i32$1 = 0,
                $2_1 = 0,
                i64toi32_i32$0 = 0,
                $3_1 = 0;
              label$1: {
                if ($0_1) {
                  break label$1;
                }
                $1_1 = 0;
                label$2: {
                  if (!($45(0 | 0, 2172 | 0) | 0)) {
                    break label$2;
                  }
                  $1_1 = $36($45(0 | 0, 2172 | 0) | 0 | 0) | 0;
                }
                label$3: {
                  if (!($45(0 | 0, 2172 | 0) | 0)) {
                    break label$3;
                  }
                  $1_1 = $36($45(0 | 0, 2172 | 0) | 0 | 0) | 0 | $1_1 | 0;
                }
                label$4: {
                  $0_1 = $45($32() | 0 | 0, 0 | 0) | 0;
                  if (!$0_1) {
                    break label$4;
                  }
                  label$5: while (1) {
                    $2_1 = 0;
                    label$6: {
                      if (($45($0_1 | 0, 76 | 0) | 0 | 0) < (0 | 0)) {
                        break label$6;
                      }
                      $2_1 = $34($0_1 | 0) | 0;
                    }
                    label$7: {
                      if (($45($0_1 | 0, 20 | 0) | 0 | 0) == ($45($0_1 | 0, 28 | 0) | 0 | 0)) {
                        break label$7;
                      }
                      $1_1 = $36($0_1 | 0) | 0 | $1_1 | 0;
                    }
                    label$8: {
                      if (!$2_1) {
                        break label$8;
                      }
                      $35($0_1 | 0);
                    }
                    $0_1 = $45($0_1 | 0, 56 | 0) | 0;
                    if ($0_1) {
                      continue label$5;
                    }
                    break label$5;
                  }
                }
                $33();
                return $1_1 | 0;
              }
              $2_1 = 0;
              label$9: {
                if (($45($0_1 | 0, 76 | 0) | 0 | 0) < (0 | 0)) {
                  break label$9;
                }
                $2_1 = $34($0_1 | 0) | 0;
              }
              label$10: {
                label$11: {
                  label$12: {
                    if (($45($0_1 | 0, 20 | 0) | 0 | 0) == ($45($0_1 | 0, 28 | 0) | 0 | 0)) {
                      break label$12;
                    }
                    FUNCTION_TABLE[$45($0_1 | 0, 36 | 0) | 0 | 0]($0_1, 0, 0) | 0;
                    if ($45($0_1 | 0, 20 | 0) | 0) {
                      break label$12;
                    }
                    $1_1 = -1;
                    if ($2_1) {
                      break label$11;
                    }
                    break label$10;
                  }
                  label$13: {
                    $1_1 = $45($0_1 | 0, 4 | 0) | 0;
                    $3_1 = $45($0_1 | 0, 8 | 0) | 0;
                    if (($1_1 | 0) == ($3_1 | 0)) {
                      break label$13;
                    }
                    i64toi32_i32$1 = ($1_1 - $3_1) | 0;
                    i64toi32_i32$0 = (i64toi32_i32$1 >> 31) | 0;
                    i64toi32_i32$0 =
                      FUNCTION_TABLE[$45($0_1 | 0, 40 | 0) | 0 | 0]($0_1, i64toi32_i32$1, i64toi32_i32$0, 1) | 0;
                    i64toi32_i32$1 = i64toi32_i32$HIGH_BITS;
                  }
                  $1_1 = 0;
                  $74($0_1 | 0, 28 | 0, 0 | 0);
                  i64toi32_i32$1 = 0;
                  $84($0_1 | 0, 16 | 0, 0 | 0, i64toi32_i32$1 | 0);
                  i64toi32_i32$1 = 0;
                  $83($0_1 | 0, 4 | 0, 0 | 0, i64toi32_i32$1 | 0);
                  if (!$2_1) {
                    break label$10;
                  }
                }
                $35($0_1 | 0);
              }
              return $1_1 | 0;
            }

            function $38($0_1, $1_1) {
              $0_1 = $0_1 | 0;
              $1_1 = $1_1 | 0;
              var $2_1 = 0;
              $2_1 = ($0_1 + $1_1) | 0;
              if ((($2_1 | 0) == (0 | 0)) | ((($2_1 + 1) | 0) >>> 0 > (HEAP32[($22() | 0) >> 2] | 0) >>> 0) | 0) {
                fimport$2();
              }
              return HEAPU8[$2_1 >> 0] | 0 | 0;
            }

            function $42($0_1, $1_1) {
              $0_1 = $0_1 | 0;
              $1_1 = $1_1 | 0;
              var $2_1 = 0;
              $2_1 = ($0_1 + $1_1) | 0;
              if ((($2_1 | 0) == (0 | 0)) | ((($2_1 + 2) | 0) >>> 0 > (HEAP32[($22() | 0) >> 2] | 0) >>> 0) | 0) {
                fimport$2();
              }
              if (($2_1 & 1) | 0) {
                fimport$3();
              }
              return HEAPU16[$2_1 >> 1] | 0 | 0;
            }

            function $45($0_1, $1_1) {
              $0_1 = $0_1 | 0;
              $1_1 = $1_1 | 0;
              var $2_1 = 0;
              $2_1 = ($0_1 + $1_1) | 0;
              if ((($2_1 | 0) == (0 | 0)) | ((($2_1 + 4) | 0) >>> 0 > (HEAP32[($22() | 0) >> 2] | 0) >>> 0) | 0) {
                fimport$2();
              }
              if (($2_1 & 3) | 0) {
                fimport$3();
              }
              return HEAP32[$2_1 >> 2] | 0 | 0;
            }

            function $60($0_1, $1_1) {
              $0_1 = $0_1 | 0;
              $1_1 = $1_1 | 0;
              var $2_1 = 0,
                i64toi32_i32$0 = 0,
                i64toi32_i32$1 = 0;
              $2_1 = ($0_1 + $1_1) | 0;
              if ((($2_1 | 0) == (0 | 0)) | ((($2_1 + 8) | 0) >>> 0 > (HEAP32[($22() | 0) >> 2] | 0) >>> 0) | 0) {
                fimport$2();
              }
              if (($2_1 & 3) | 0) {
                fimport$3();
              }
              i64toi32_i32$0 = HEAP32[$2_1 >> 2] | 0;
              i64toi32_i32$1 = HEAP32[(($2_1 + 4) | 0) >> 2] | 0;
              i64toi32_i32$HIGH_BITS = i64toi32_i32$1;
              return i64toi32_i32$0 | 0;
            }

            function $69($0_1, $1_1, $2_1) {
              $0_1 = $0_1 | 0;
              $1_1 = $1_1 | 0;
              $2_1 = $2_1 | 0;
              var $3_1 = 0;
              $3_1 = ($0_1 + $1_1) | 0;
              if ((($3_1 | 0) == (0 | 0)) | ((($3_1 + 1) | 0) >>> 0 > (HEAP32[($22() | 0) >> 2] | 0) >>> 0) | 0) {
                fimport$2();
              }
              HEAP8[$3_1 >> 0] = $2_1;
            }

            function $71($0_1, $1_1, $2_1) {
              $0_1 = $0_1 | 0;
              $1_1 = $1_1 | 0;
              $2_1 = $2_1 | 0;
              var $3_1 = 0;
              $3_1 = ($0_1 + $1_1) | 0;
              if ((($3_1 | 0) == (0 | 0)) | ((($3_1 + 2) | 0) >>> 0 > (HEAP32[($22() | 0) >> 2] | 0) >>> 0) | 0) {
                fimport$2();
              }
              if (($3_1 & 1) | 0) {
                fimport$3();
              }
              HEAP16[$3_1 >> 1] = $2_1;
            }

            function $74($0_1, $1_1, $2_1) {
              $0_1 = $0_1 | 0;
              $1_1 = $1_1 | 0;
              $2_1 = $2_1 | 0;
              var $3_1 = 0;
              $3_1 = ($0_1 + $1_1) | 0;
              if ((($3_1 | 0) == (0 | 0)) | ((($3_1 + 4) | 0) >>> 0 > (HEAP32[($22() | 0) >> 2] | 0) >>> 0) | 0) {
                fimport$2();
              }
              if (($3_1 & 3) | 0) {
                fimport$3();
              }
              HEAP32[$3_1 >> 2] = $2_1;
            }

            function $83($0_1, $1_1, $2_1, $2$hi) {
              $0_1 = $0_1 | 0;
              $1_1 = $1_1 | 0;
              $2_1 = $2_1 | 0;
              $2$hi = $2$hi | 0;
              var $3_1 = 0,
                i64toi32_i32$0 = 0;
              $3_1 = ($0_1 + $1_1) | 0;
              if ((($3_1 | 0) == (0 | 0)) | ((($3_1 + 8) | 0) >>> 0 > (HEAP32[($22() | 0) >> 2] | 0) >>> 0) | 0) {
                fimport$2();
              }
              if (($3_1 & 3) | 0) {
                fimport$3();
              }
              i64toi32_i32$0 = $2$hi;
              HEAP32[$3_1 >> 2] = $2_1;
              HEAP32[(($3_1 + 4) | 0) >> 2] = i64toi32_i32$0;
            }

            function $84($0_1, $1_1, $2_1, $2$hi) {
              $0_1 = $0_1 | 0;
              $1_1 = $1_1 | 0;
              $2_1 = $2_1 | 0;
              $2$hi = $2$hi | 0;
              var $3_1 = 0,
                i64toi32_i32$0 = 0;
              $3_1 = ($0_1 + $1_1) | 0;
              if ((($3_1 | 0) == (0 | 0)) | ((($3_1 + 8) | 0) >>> 0 > (HEAP32[($22() | 0) >> 2] | 0) >>> 0) | 0) {
                fimport$2();
              }
              if (($3_1 & 7) | 0) {
                fimport$3();
              }
              i64toi32_i32$0 = $2$hi;
              HEAP32[$3_1 >> 2] = $2_1;
              HEAP32[(($3_1 + 4) | 0) >> 2] = i64toi32_i32$0;
            }

            function __wasm_rotl_i32(var$0, var$1) {
              var$0 = var$0 | 0;
              var$1 = var$1 | 0;
              var var$2 = 0;
              var$2 = (var$1 & 31) | 0;
              var$1 = (((0 - var$1) | 0) & 31) | 0;
              return (
                (((((-1 >>> var$2) | 0) & var$0) | 0) << var$2) |
                0 |
                ((((((-1 << var$1) | 0) & var$0) | 0) >>> var$1) | 0) |
                0 |
                0
              );
            }

            // EMSCRIPTEN_END_FUNCS
            bufferView = HEAPU8;
            initActiveSegments(env);
            var FUNCTION_TABLE = Table([]);
            function __wasm_memory_size() {
              return (buffer.byteLength / 65536) | 0;
            }

            return {
              __wasm_call_ctors: $0,
              ComputeSHA256: $1,
              fflush: $36,
              __errno_location: $21,
              stackSave: $17,
              stackRestore: $18,
              stackAlloc: $19,
              emscripten_stack_init: $26,
              emscripten_stack_get_free: $27,
              emscripten_stack_get_base: $28,
              emscripten_stack_get_end: $29,
              malloc: $24,
              free: $25,
              emscripten_get_sbrk_ptr: $22,
              sbrk: $23,
              __indirect_function_table: FUNCTION_TABLE,
            };
          }

          return asmFunc(asmLibraryArg);
        })(asmLibraryArg);
      },
      instantiate: function (binary, info) {
        return {
          then: function (ok) {
            var module = new WebAssembly.Module(binary);
            ok({
              instance: new WebAssembly.Instance(module),
            });
            return {
              catch: function () {},
            };
          },
        };
      },
      RuntimeError: Error,
    };

    wasmBinary = [];

    if (typeof WebAssembly !== 'object') {
      abort('no native wasm support detected');
    }

    function setValue(ptr, value, type, noSafe) {
      type = type || 'i8';
      if (type.charAt(type.length - 1) === '*') type = 'i32';
      if (noSafe) {
        switch (type) {
          case 'i1':
            HEAP8[ptr >> 0] = value;
            break;

          case 'i8':
            HEAP8[ptr >> 0] = value;
            break;

          case 'i16':
            HEAP16[ptr >> 1] = value;
            break;

          case 'i32':
            HEAP32[ptr >> 2] = value;
            break;

          case 'i64':
            (tempI64 = [
              value >>> 0,
              ((tempDouble = value),
              +Math.abs(tempDouble) >= 1
                ? tempDouble > 0
                  ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0
                  : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0
                : 0),
            ]),
              (HEAP32[ptr >> 2] = tempI64[0]),
              (HEAP32[(ptr + 4) >> 2] = tempI64[1]);
            break;

          case 'float':
            HEAPF32[ptr >> 2] = value;
            break;

          case 'double':
            HEAPF64[ptr >> 3] = value;
            break;

          default:
            abort('invalid type for setValue: ' + type);
        }
      } else {
        switch (type) {
          case 'i1':
            SAFE_HEAP_STORE(ptr | 0, value | 0, 1);
            break;

          case 'i8':
            SAFE_HEAP_STORE(ptr | 0, value | 0, 1);
            break;

          case 'i16':
            SAFE_HEAP_STORE(ptr | 0, value | 0, 2);
            break;

          case 'i32':
            SAFE_HEAP_STORE(ptr | 0, value | 0, 4);
            break;

          case 'i64':
            (tempI64 = [
              value >>> 0,
              ((tempDouble = value),
              +Math.abs(tempDouble) >= 1
                ? tempDouble > 0
                  ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0
                  : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0
                : 0),
            ]),
              SAFE_HEAP_STORE(ptr | 0, tempI64[0] | 0, 4),
              SAFE_HEAP_STORE((ptr + 4) | 0, tempI64[1] | 0, 4);
            break;

          case 'float':
            SAFE_HEAP_STORE_D(ptr | 0, Math.fround(value), 4);
            break;

          case 'double':
            SAFE_HEAP_STORE_D(ptr | 0, +value, 8);
            break;

          default:
            abort('invalid type for setValue: ' + type);
        }
      }
    }

    function getValue(ptr, type, noSafe) {
      type = type || 'i8';
      if (type.charAt(type.length - 1) === '*') type = 'i32';
      if (noSafe) {
        switch (type) {
          case 'i1':
            return HEAP8[ptr >> 0];

          case 'i8':
            return HEAP8[ptr >> 0];

          case 'i16':
            return HEAP16[ptr >> 1];

          case 'i32':
            return HEAP32[ptr >> 2];

          case 'i64':
            return HEAP32[ptr >> 2];

          case 'float':
            return HEAPF32[ptr >> 2];

          case 'double':
            return Number(HEAPF64[ptr >> 3]);

          default:
            abort('invalid type for getValue: ' + type);
        }
      } else {
        switch (type) {
          case 'i1':
            return SAFE_HEAP_LOAD(ptr | 0, 1, 0) | 0;

          case 'i8':
            return SAFE_HEAP_LOAD(ptr | 0, 1, 0) | 0;

          case 'i16':
            return SAFE_HEAP_LOAD(ptr | 0, 2, 0) | 0;

          case 'i32':
            return SAFE_HEAP_LOAD(ptr | 0, 4, 0) | 0;

          case 'i64':
            return SAFE_HEAP_LOAD(ptr | 0, 8, 0) | 0;

          case 'float':
            return Math.fround(SAFE_HEAP_LOAD_D(ptr | 0, 4, 0));

          case 'double':
            return +SAFE_HEAP_LOAD_D(ptr | 0, 8, 0);

          default:
            abort('invalid type for getValue: ' + type);
        }
      }
      return null;
    }

    function getSafeHeapType(bytes, isFloat) {
      switch (bytes) {
        case 1:
          return 'i8';

        case 2:
          return 'i16';

        case 4:
          return isFloat ? 'float' : 'i32';

        case 8:
          return isFloat ? 'double' : 'i64';

        default:
          assert(0);
      }
    }

    function SAFE_HEAP_STORE(dest, value, bytes, isFloat) {
      if (dest <= 0) abort('segmentation fault storing ' + bytes + ' bytes to address ' + dest);
      if (dest % bytes !== 0)
        abort(
          'alignment error storing to address ' + dest + ', which was expected to be aligned to a multiple of ' + bytes,
        );
      if (runtimeInitialized) {
        var brk = _sbrk() >>> 0;
        if (dest + bytes > brk)
          abort(
            'segmentation fault, exceeded the top of the available dynamic heap when storing ' +
              bytes +
              ' bytes to address ' +
              dest +
              '. DYNAMICTOP=' +
              brk,
          );
        assert(brk >= _emscripten_stack_get_base());
        assert(brk <= HEAP8.length);
      }
      setValue(dest, value, getSafeHeapType(bytes, isFloat), 1);
      return value;
    }

    function SAFE_HEAP_STORE_D(dest, value, bytes) {
      return SAFE_HEAP_STORE(dest, value, bytes, true);
    }

    function SAFE_HEAP_LOAD(dest, bytes, unsigned, isFloat) {
      if (dest <= 0) abort('segmentation fault loading ' + bytes + ' bytes from address ' + dest);
      if (dest % bytes !== 0)
        abort(
          'alignment error loading from address ' +
            dest +
            ', which was expected to be aligned to a multiple of ' +
            bytes,
        );
      if (runtimeInitialized) {
        var brk = _sbrk() >>> 0;
        if (dest + bytes > brk)
          abort(
            'segmentation fault, exceeded the top of the available dynamic heap when loading ' +
              bytes +
              ' bytes from address ' +
              dest +
              '. DYNAMICTOP=' +
              brk,
          );
        assert(brk >= _emscripten_stack_get_base());
        assert(brk <= HEAP8.length);
      }
      var type = getSafeHeapType(bytes, isFloat);
      var ret = getValue(dest, type, 1);
      if (unsigned) ret = unSign(ret, parseInt(type.substr(1), 10));
      return ret;
    }

    function SAFE_HEAP_LOAD_D(dest, bytes, unsigned) {
      return SAFE_HEAP_LOAD(dest, bytes, unsigned, true);
    }

    function SAFE_FT_MASK(value, mask) {
      var ret = value & mask;
      if (ret !== value) {
        abort(
          'Function table mask error: function pointer is ' +
            value +
            ' which is masked by ' +
            mask +
            ', the likely cause of this is that the function pointer is being called by the wrong type.',
        );
      }
      return ret;
    }

    function segfault() {
      abort('segmentation fault');
    }

    function alignfault() {
      abort('alignment fault');
    }

    var wasmMemory;

    var ABORT = false;

    var EXITSTATUS;

    function assert(condition, text) {
      if (!condition) {
        abort('Assertion failed: ' + text);
      }
    }

    function getCFunc(ident) {
      var func = Module['_' + ident];
      assert(func, 'Cannot call unknown function ' + ident + ', make sure it is exported');
      return func;
    }

    function ccall(ident, returnType, argTypes, args, opts) {
      var toC = {
        string: function (str) {
          var ret = 0;
          if (str !== null && str !== undefined && str !== 0) {
            var len = (str.length << 2) + 1;
            ret = stackAlloc(len);
            stringToUTF8(str, ret, len);
          }
          return ret;
        },
        array: function (arr) {
          var ret = stackAlloc(arr.length);
          writeArrayToMemory(arr, ret);
          return ret;
        },
      };
      function convertReturnValue(ret) {
        if (returnType === 'string') return UTF8ToString(ret);
        if (returnType === 'boolean') return Boolean(ret);
        return ret;
      }
      var func = getCFunc(ident);
      var cArgs = [];
      var stack = 0;
      assert(returnType !== 'array', 'Return type should not be "array".');
      if (args) {
        for (var i = 0; i < args.length; i++) {
          var converter = toC[argTypes[i]];
          if (converter) {
            if (stack === 0) stack = stackSave();
            cArgs[i] = converter(args[i]);
          } else {
            cArgs[i] = args[i];
          }
        }
      }
      var ret = func.apply(null, cArgs);
      function onDone(ret) {
        if (stack !== 0) stackRestore(stack);
        return convertReturnValue(ret);
      }
      ret = onDone(ret);
      return ret;
    }

    function cwrap(ident, returnType, argTypes, opts) {
      return function () {
        return ccall(ident, returnType, argTypes, arguments, opts);
      };
    }

    var ALLOC_NORMAL = 0;

    var ALLOC_STACK = 1;

    function allocate(slab, allocator) {
      var ret;
      assert(typeof allocator === 'number', 'allocate no longer takes a type argument');
      assert(typeof slab !== 'number', 'allocate no longer takes a number as arg0');
      if (allocator == ALLOC_STACK) {
        ret = stackAlloc(slab.length);
      } else {
        ret = _malloc(slab.length);
      }
      if (slab.subarray || slab.slice) {
        HEAPU8.set(slab, ret);
      } else {
        HEAPU8.set(new Uint8Array(slab), ret);
      }
      return ret;
    }

    var UTF8Decoder = typeof TextDecoder !== 'undefined' ? new TextDecoder('utf8') : undefined;

    function UTF8ArrayToString(heap, idx, maxBytesToRead) {
      var endIdx = idx + maxBytesToRead;
      var endPtr = idx;
      while (heap[endPtr] && !(endPtr >= endIdx)) ++endPtr;
      if (endPtr - idx > 16 && heap.subarray && UTF8Decoder) {
        return UTF8Decoder.decode(heap.subarray(idx, endPtr));
      } else {
        var str = '';
        while (idx < endPtr) {
          var u0 = heap[idx++];
          if (!(u0 & 128)) {
            str += String.fromCharCode(u0);
            continue;
          }
          var u1 = heap[idx++] & 63;
          if ((u0 & 224) == 192) {
            str += String.fromCharCode(((u0 & 31) << 6) | u1);
            continue;
          }
          var u2 = heap[idx++] & 63;
          if ((u0 & 240) == 224) {
            u0 = ((u0 & 15) << 12) | (u1 << 6) | u2;
          } else {
            if ((u0 & 248) != 240)
              warnOnce(
                'Invalid UTF-8 leading byte 0x' +
                  u0.toString(16) +
                  ' encountered when deserializing a UTF-8 string in wasm memory to a JS string!',
              );
            u0 = ((u0 & 7) << 18) | (u1 << 12) | (u2 << 6) | (heap[idx++] & 63);
          }
          if (u0 < 65536) {
            str += String.fromCharCode(u0);
          } else {
            var ch = u0 - 65536;
            str += String.fromCharCode(55296 | (ch >> 10), 56320 | (ch & 1023));
          }
        }
      }
      return str;
    }

    function UTF8ToString(ptr, maxBytesToRead) {
      return ptr ? UTF8ArrayToString(HEAPU8, ptr, maxBytesToRead) : '';
    }

    function stringToUTF8Array(str, heap, outIdx, maxBytesToWrite) {
      if (!(maxBytesToWrite > 0)) return 0;
      var startIdx = outIdx;
      var endIdx = outIdx + maxBytesToWrite - 1;
      for (var i = 0; i < str.length; ++i) {
        var u = str.charCodeAt(i);
        if (u >= 55296 && u <= 57343) {
          var u1 = str.charCodeAt(++i);
          u = (65536 + ((u & 1023) << 10)) | (u1 & 1023);
        }
        if (u <= 127) {
          if (outIdx >= endIdx) break;
          heap[outIdx++] = u;
        } else if (u <= 2047) {
          if (outIdx + 1 >= endIdx) break;
          heap[outIdx++] = 192 | (u >> 6);
          heap[outIdx++] = 128 | (u & 63);
        } else if (u <= 65535) {
          if (outIdx + 2 >= endIdx) break;
          heap[outIdx++] = 224 | (u >> 12);
          heap[outIdx++] = 128 | ((u >> 6) & 63);
          heap[outIdx++] = 128 | (u & 63);
        } else {
          if (outIdx + 3 >= endIdx) break;
          if (u > 1114111)
            warnOnce(
              'Invalid Unicode code point 0x' +
                u.toString(16) +
                ' encountered when serializing a JS string to a UTF-8 string in wasm memory! (Valid unicode code points should be in range 0-0x10FFFF).',
            );
          heap[outIdx++] = 240 | (u >> 18);
          heap[outIdx++] = 128 | ((u >> 12) & 63);
          heap[outIdx++] = 128 | ((u >> 6) & 63);
          heap[outIdx++] = 128 | (u & 63);
        }
      }
      heap[outIdx] = 0;
      return outIdx - startIdx;
    }

    function stringToUTF8(str, outPtr, maxBytesToWrite) {
      assert(
        typeof maxBytesToWrite == 'number',
        'stringToUTF8(str, outPtr, maxBytesToWrite) is missing the third parameter that specifies the length of the output buffer!',
      );
      return stringToUTF8Array(str, HEAPU8, outPtr, maxBytesToWrite);
    }

    function lengthBytesUTF8(str) {
      var len = 0;
      for (var i = 0; i < str.length; ++i) {
        var u = str.charCodeAt(i);
        if (u >= 55296 && u <= 57343) u = (65536 + ((u & 1023) << 10)) | (str.charCodeAt(++i) & 1023);
        if (u <= 127) ++len;
        else if (u <= 2047) len += 2;
        else if (u <= 65535) len += 3;
        else len += 4;
      }
      return len;
    }

    function AsciiToString(ptr) {
      var str = '';
      while (1) {
        var ch = SAFE_HEAP_LOAD(ptr++ | 0, 1, 1) >>> 0;
        if (!ch) return str;
        str += String.fromCharCode(ch);
      }
    }

    function stringToAscii(str, outPtr) {
      return writeAsciiToMemory(str, outPtr, false);
    }

    var UTF16Decoder = typeof TextDecoder !== 'undefined' ? new TextDecoder('utf-16le') : undefined;

    function UTF16ToString(ptr, maxBytesToRead) {
      assert(ptr % 2 == 0, 'Pointer passed to UTF16ToString must be aligned to two bytes!');
      var endPtr = ptr;
      var idx = endPtr >> 1;
      var maxIdx = idx + maxBytesToRead / 2;
      while (!(idx >= maxIdx) && SAFE_HEAP_LOAD(idx * 2, 2, 1)) ++idx;
      endPtr = idx << 1;
      if (endPtr - ptr > 32 && UTF16Decoder) {
        return UTF16Decoder.decode(HEAPU8.subarray(ptr, endPtr));
      } else {
        var str = '';
        for (var i = 0; !(i >= maxBytesToRead / 2); ++i) {
          var codeUnit = SAFE_HEAP_LOAD((ptr + i * 2) | 0, 2, 0) | 0;
          if (codeUnit == 0) break;
          str += String.fromCharCode(codeUnit);
        }
        return str;
      }
    }

    function stringToUTF16(str, outPtr, maxBytesToWrite) {
      assert(outPtr % 2 == 0, 'Pointer passed to stringToUTF16 must be aligned to two bytes!');
      assert(
        typeof maxBytesToWrite == 'number',
        'stringToUTF16(str, outPtr, maxBytesToWrite) is missing the third parameter that specifies the length of the output buffer!',
      );
      if (maxBytesToWrite === undefined) {
        maxBytesToWrite = 2147483647;
      }
      if (maxBytesToWrite < 2) return 0;
      maxBytesToWrite -= 2;
      var startPtr = outPtr;
      var numCharsToWrite = maxBytesToWrite < str.length * 2 ? maxBytesToWrite / 2 : str.length;
      for (var i = 0; i < numCharsToWrite; ++i) {
        var codeUnit = str.charCodeAt(i);
        SAFE_HEAP_STORE(outPtr | 0, codeUnit | 0, 2);
        outPtr += 2;
      }
      SAFE_HEAP_STORE(outPtr | 0, 0 | 0, 2);
      return outPtr - startPtr;
    }

    function lengthBytesUTF16(str) {
      return str.length * 2;
    }

    function UTF32ToString(ptr, maxBytesToRead) {
      assert(ptr % 4 == 0, 'Pointer passed to UTF32ToString must be aligned to four bytes!');
      var i = 0;
      var str = '';
      while (!(i >= maxBytesToRead / 4)) {
        var utf32 = SAFE_HEAP_LOAD((ptr + i * 4) | 0, 4, 0) | 0;
        if (utf32 == 0) break;
        ++i;
        if (utf32 >= 65536) {
          var ch = utf32 - 65536;
          str += String.fromCharCode(55296 | (ch >> 10), 56320 | (ch & 1023));
        } else {
          str += String.fromCharCode(utf32);
        }
      }
      return str;
    }

    function stringToUTF32(str, outPtr, maxBytesToWrite) {
      assert(outPtr % 4 == 0, 'Pointer passed to stringToUTF32 must be aligned to four bytes!');
      assert(
        typeof maxBytesToWrite == 'number',
        'stringToUTF32(str, outPtr, maxBytesToWrite) is missing the third parameter that specifies the length of the output buffer!',
      );
      if (maxBytesToWrite === undefined) {
        maxBytesToWrite = 2147483647;
      }
      if (maxBytesToWrite < 4) return 0;
      var startPtr = outPtr;
      var endPtr = startPtr + maxBytesToWrite - 4;
      for (var i = 0; i < str.length; ++i) {
        var codeUnit = str.charCodeAt(i);
        if (codeUnit >= 55296 && codeUnit <= 57343) {
          var trailSurrogate = str.charCodeAt(++i);
          codeUnit = (65536 + ((codeUnit & 1023) << 10)) | (trailSurrogate & 1023);
        }
        SAFE_HEAP_STORE(outPtr | 0, codeUnit | 0, 4);
        outPtr += 4;
        if (outPtr + 4 > endPtr) break;
      }
      SAFE_HEAP_STORE(outPtr | 0, 0 | 0, 4);
      return outPtr - startPtr;
    }

    function lengthBytesUTF32(str) {
      var len = 0;
      for (var i = 0; i < str.length; ++i) {
        var codeUnit = str.charCodeAt(i);
        if (codeUnit >= 55296 && codeUnit <= 57343) ++i;
        len += 4;
      }
      return len;
    }

    function allocateUTF8(str) {
      var size = lengthBytesUTF8(str) + 1;
      var ret = _malloc(size);
      if (ret) stringToUTF8Array(str, HEAP8, ret, size);
      return ret;
    }

    function allocateUTF8OnStack(str) {
      var size = lengthBytesUTF8(str) + 1;
      var ret = stackAlloc(size);
      stringToUTF8Array(str, HEAP8, ret, size);
      return ret;
    }

    function writeStringToMemory(string, buffer, dontAddNull) {
      warnOnce('writeStringToMemory is deprecated and should not be called! Use stringToUTF8() instead!');
      var lastChar, end;
      if (dontAddNull) {
        end = buffer + lengthBytesUTF8(string);
        lastChar = SAFE_HEAP_LOAD(end, 1, 0);
      }
      stringToUTF8(string, buffer, Infinity);
      if (dontAddNull) SAFE_HEAP_STORE(end, lastChar, 1);
    }

    function writeArrayToMemory(array, buffer) {
      assert(array.length >= 0, 'writeArrayToMemory array must have a length (should be an array or typed array)');
      HEAP8.set(array, buffer);
    }

    function writeAsciiToMemory(str, buffer, dontAddNull) {
      for (var i = 0; i < str.length; ++i) {
        assert(str.charCodeAt(i) === (str.charCodeAt(i) & 255));
        SAFE_HEAP_STORE(buffer++ | 0, str.charCodeAt(i) | 0, 1);
      }
      if (!dontAddNull) SAFE_HEAP_STORE(buffer | 0, 0 | 0, 1);
    }

    function alignUp(x, multiple) {
      if (x % multiple > 0) {
        x += multiple - (x % multiple);
      }
      return x;
    }

    var HEAP, buffer, HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64;

    function updateGlobalBufferAndViews(buf) {
      buffer = buf;
      Module['HEAP8'] = HEAP8 = new Int8Array(buf);
      Module['HEAP16'] = HEAP16 = new Int16Array(buf);
      Module['HEAP32'] = HEAP32 = new Int32Array(buf);
      Module['HEAPU8'] = HEAPU8 = new Uint8Array(buf);
      Module['HEAPU16'] = HEAPU16 = new Uint16Array(buf);
      Module['HEAPU32'] = HEAPU32 = new Uint32Array(buf);
      Module['HEAPF32'] = HEAPF32 = new Float32Array(buf);
      Module['HEAPF64'] = HEAPF64 = new Float64Array(buf);
    }

    var TOTAL_STACK = 32768;

    if (Module['TOTAL_STACK'])
      assert(TOTAL_STACK === Module['TOTAL_STACK'], 'the stack size can no longer be determined at runtime');

    var INITIAL_MEMORY = Module['INITIAL_MEMORY'] || 65536;

    if (!Object.getOwnPropertyDescriptor(Module, 'INITIAL_MEMORY')) {
      Object.defineProperty(Module, 'INITIAL_MEMORY', {
        configurable: true,
        get: function () {
          abort(
            'Module.INITIAL_MEMORY has been replaced with plain INITIAL_MEMORY (the initial value can be provided on Module, but after startup the value is only looked for on a local variable of that name)',
          );
        },
      });
    }

    assert(
      INITIAL_MEMORY >= TOTAL_STACK,
      'INITIAL_MEMORY should be larger than TOTAL_STACK, was ' + INITIAL_MEMORY + '! (TOTAL_STACK=' + TOTAL_STACK + ')',
    );

    assert(
      typeof Int32Array !== 'undefined' &&
        typeof Float64Array !== 'undefined' &&
        Int32Array.prototype.subarray !== undefined &&
        Int32Array.prototype.set !== undefined,
      'JS engine does not provide full typed array support',
    );

    if (Module['wasmMemory']) {
      wasmMemory = Module['wasmMemory'];
    } else {
      wasmMemory = new WebAssembly.Memory({
        initial: INITIAL_MEMORY / 65536,
        maximum: INITIAL_MEMORY / 65536,
      });
    }

    if (wasmMemory) {
      buffer = wasmMemory.buffer;
    }

    INITIAL_MEMORY = buffer.byteLength;

    assert(INITIAL_MEMORY % 65536 === 0);

    updateGlobalBufferAndViews(buffer);

    var wasmTable;

    function writeStackCookie() {
      var max = _emscripten_stack_get_end();
      assert((max & 3) == 0);
      SAFE_HEAP_STORE((max + 4) | 0, 34821223 | 0, 4);
      SAFE_HEAP_STORE((max + 8) | 0, 2310721022 | 0, 4);
    }

    function checkStackCookie() {
      if (ABORT) return;
      var max = _emscripten_stack_get_end();
      var cookie1 = SAFE_HEAP_LOAD((max + 4) | 0, 4, 1) >>> 0;
      var cookie2 = SAFE_HEAP_LOAD((max + 8) | 0, 4, 1) >>> 0;
      if (cookie1 != 34821223 || cookie2 != 2310721022) {
        abort(
          'Stack overflow! Stack cookie has been overwritten, expected hex dwords 0x89BACDFE and 0x2135467, but received 0x' +
            cookie2.toString(16) +
            ' 0x' +
            cookie1.toString(16),
        );
      }
    }

    (function () {
      var h16 = new Int16Array(1);
      var h8 = new Int8Array(h16.buffer);
      h16[0] = 25459;
      if (h8[0] !== 115 || h8[1] !== 99)
        throw 'Runtime error: expected the system to be little-endian! (Run with -s SUPPORT_BIG_ENDIAN=1 to bypass)';
    })();

    var __ATPRERUN__ = [];

    var __ATINIT__ = [];

    var __ATEXIT__ = [];

    var __ATPOSTRUN__ = [];

    var runtimeInitialized = false;

    var runtimeExited = false;

    var runtimeKeepaliveCounter = 0;

    function keepRuntimeAlive() {
      return noExitRuntime || runtimeKeepaliveCounter > 0;
    }

    function preRun() {
      if (Module['preRun']) {
        if (typeof Module['preRun'] == 'function') Module['preRun'] = [Module['preRun']];
        while (Module['preRun'].length) {
          addOnPreRun(Module['preRun'].shift());
        }
      }
      callRuntimeCallbacks(__ATPRERUN__);
    }

    function initRuntime() {
      checkStackCookie();
      assert(!runtimeInitialized);
      runtimeInitialized = true;
      callRuntimeCallbacks(__ATINIT__);
    }

    function exitRuntime() {
      checkStackCookie();
      runtimeExited = true;
    }

    function postRun() {
      checkStackCookie();
      if (Module['postRun']) {
        if (typeof Module['postRun'] == 'function') Module['postRun'] = [Module['postRun']];
        while (Module['postRun'].length) {
          addOnPostRun(Module['postRun'].shift());
        }
      }
      callRuntimeCallbacks(__ATPOSTRUN__);
    }

    function addOnPreRun(cb) {
      __ATPRERUN__.unshift(cb);
    }

    function addOnInit(cb) {
      __ATINIT__.unshift(cb);
    }

    function addOnExit(cb) {}

    function addOnPostRun(cb) {
      __ATPOSTRUN__.unshift(cb);
    }

    assert(
      Math.imul,
      'This browser does not support Math.imul(), build with LEGACY_VM_SUPPORT or POLYFILL_OLD_MATH_FUNCTIONS to add in a polyfill',
    );

    assert(
      Math.fround,
      'This browser does not support Math.fround(), build with LEGACY_VM_SUPPORT or POLYFILL_OLD_MATH_FUNCTIONS to add in a polyfill',
    );

    assert(
      Math.clz32,
      'This browser does not support Math.clz32(), build with LEGACY_VM_SUPPORT or POLYFILL_OLD_MATH_FUNCTIONS to add in a polyfill',
    );

    assert(
      Math.trunc,
      'This browser does not support Math.trunc(), build with LEGACY_VM_SUPPORT or POLYFILL_OLD_MATH_FUNCTIONS to add in a polyfill',
    );

    var runDependencies = 0;

    var runDependencyWatcher = null;

    var dependenciesFulfilled = null;

    var runDependencyTracking = {};

    function getUniqueRunDependency(id) {
      var orig = id;
      while (1) {
        if (!runDependencyTracking[id]) return id;
        id = orig + Math.random();
      }
    }

    function addRunDependency(id) {
      runDependencies++;
      if (Module['monitorRunDependencies']) {
        Module['monitorRunDependencies'](runDependencies);
      }
      if (id) {
        assert(!runDependencyTracking[id]);
        runDependencyTracking[id] = 1;
        if (runDependencyWatcher === null && typeof setInterval !== 'undefined') {
          runDependencyWatcher = setInterval(function () {
            if (ABORT) {
              clearInterval(runDependencyWatcher);
              runDependencyWatcher = null;
              return;
            }
            var shown = false;
            for (var dep in runDependencyTracking) {
              if (!shown) {
                shown = true;
                err('still waiting on run dependencies:');
              }
              err('dependency: ' + dep);
            }
            if (shown) {
              err('(end of list)');
            }
          }, 1e4);
        }
      } else {
        err('warning: run dependency added without ID');
      }
    }

    function removeRunDependency(id) {
      runDependencies--;
      if (Module['monitorRunDependencies']) {
        Module['monitorRunDependencies'](runDependencies);
      }
      if (id) {
        assert(runDependencyTracking[id]);
        delete runDependencyTracking[id];
      } else {
        err('warning: run dependency removed without ID');
      }
      if (runDependencies == 0) {
        if (runDependencyWatcher !== null) {
          clearInterval(runDependencyWatcher);
          runDependencyWatcher = null;
        }
        if (dependenciesFulfilled) {
          var callback = dependenciesFulfilled;
          dependenciesFulfilled = null;
          callback();
        }
      }
    }

    Module['preloadedImages'] = {};

    Module['preloadedAudios'] = {};

    function abort(what) {
      {
        if (Module['onAbort']) {
          Module['onAbort'](what);
        }
      }
      what = 'Aborted(' + what + ')';
      err(what);
      ABORT = true;
      EXITSTATUS = 1;
      var e = new WebAssembly.RuntimeError(what);
      readyPromiseReject(e);
      throw e;
    }

    var FS = {
      error: function () {
        abort(
          'Filesystem support (FS) was not included. The problem is that you are using files from JS, but files were not used from C/C++, so filesystem support was not auto-included. You can force-include filesystem support with  -s FORCE_FILESYSTEM=1',
        );
      },
      init: function () {
        FS.error();
      },
      createDataFile: function () {
        FS.error();
      },
      createPreloadedFile: function () {
        FS.error();
      },
      createLazyFile: function () {
        FS.error();
      },
      open: function () {
        FS.error();
      },
      mkdev: function () {
        FS.error();
      },
      registerDevice: function () {
        FS.error();
      },
      analyzePath: function () {
        FS.error();
      },
      loadFilesFromDB: function () {
        FS.error();
      },
      ErrnoError: function ErrnoError() {
        FS.error();
      },
    };

    Module['FS_createDataFile'] = FS.createDataFile;

    Module['FS_createPreloadedFile'] = FS.createPreloadedFile;

    var dataURIPrefix = 'data:application/octet-stream;base64,';

    function isDataURI(filename) {
      return filename.startsWith(dataURIPrefix);
    }

    function isFileURI(filename) {
      return filename.startsWith('file://');
    }

    function createExportWrapper(name, fixedasm) {
      return function () {
        var displayName = name;
        var asm = fixedasm;
        if (!fixedasm) {
          asm = Module['asm'];
        }
        assert(runtimeInitialized, 'native function `' + displayName + '` called before runtime initialization');
        assert(
          !runtimeExited,
          'native function `' +
            displayName +
            '` called after runtime exit (use NO_EXIT_RUNTIME to keep it alive after main() exits)',
        );
        if (!asm[name]) {
          assert(asm[name], 'exported native function `' + displayName + '` not found');
        }
        return asm[name].apply(null, arguments);
      };
    }

    var wasmBinaryFile;

    wasmBinaryFile = 'sha256.wasm';

    if (!isDataURI(wasmBinaryFile)) {
      wasmBinaryFile = locateFile(wasmBinaryFile);
    }

    function getBinary(file) {
      try {
        if (file == wasmBinaryFile && wasmBinary) {
          return new Uint8Array(wasmBinary);
        }
        var binary = tryParseAsDataURI(file);
        if (binary) {
          return binary;
        }
        if (readBinary) {
          return readBinary(file);
        } else {
          throw 'both async and sync fetching of the wasm failed';
        }
      } catch (err) {
        abort(err);
      }
    }

    function getBinaryPromise() {
      if (!wasmBinary && (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER)) {
        if (typeof fetch === 'function') {
          return fetch(wasmBinaryFile, {
            credentials: 'same-origin',
          })
            .then(function (response) {
              if (!response['ok']) {
                throw "failed to load wasm binary file at '" + wasmBinaryFile + "'";
              }
              return response['arrayBuffer']();
            })
            .catch(function () {
              return getBinary(wasmBinaryFile);
            });
        }
      }
      return Promise.resolve().then(function () {
        return getBinary(wasmBinaryFile);
      });
    }

    function createWasm() {
      var info = {
        env: asmLibraryArg,
        wasi_snapshot_preview1: asmLibraryArg,
      };
      function receiveInstance(instance, module) {
        var exports = instance.exports;
        Module['asm'] = exports;
        wasmTable = Module['asm']['__indirect_function_table'];
        assert(wasmTable, 'table not found in wasm exports');
        addOnInit(Module['asm']['__wasm_call_ctors']);
        removeRunDependency('wasm-instantiate');
      }
      addRunDependency('wasm-instantiate');
      var trueModule = Module;
      function receiveInstantiationResult(result) {
        assert(
          Module === trueModule,
          'the Module object should not be replaced during async compilation - perhaps the order of HTML elements is wrong?',
        );
        trueModule = null;
        receiveInstance(result['instance']);
      }
      function instantiateArrayBuffer(receiver) {
        return getBinaryPromise()
          .then(function (binary) {
            return WebAssembly.instantiate(binary, info);
          })
          .then(function (instance) {
            return instance;
          })
          .then(receiver, function (reason) {
            err('failed to asynchronously prepare wasm: ' + reason);
            if (isFileURI(wasmBinaryFile)) {
              err(
                'warning: Loading from a file URI (' +
                  wasmBinaryFile +
                  ') is not supported in most browsers. See https://emscripten.org/docs/getting_started/FAQ.html#how-do-i-run-a-local-webserver-for-testing-why-does-my-program-stall-in-downloading-or-preparing',
              );
            }
            abort(reason);
          });
      }
      function instantiateAsync() {
        if (
          !wasmBinary &&
          typeof WebAssembly.instantiateStreaming === 'function' &&
          !isDataURI(wasmBinaryFile) &&
          typeof fetch === 'function'
        ) {
          return fetch(wasmBinaryFile, {
            credentials: 'same-origin',
          }).then(function (response) {
            var result = WebAssembly.instantiateStreaming(response, info);
            return result.then(receiveInstantiationResult, function (reason) {
              err('wasm streaming compile failed: ' + reason);
              err('falling back to ArrayBuffer instantiation');
              return instantiateArrayBuffer(receiveInstantiationResult);
            });
          });
        } else {
          return instantiateArrayBuffer(receiveInstantiationResult);
        }
      }
      if (Module['instantiateWasm']) {
        try {
          var exports = Module['instantiateWasm'](info, receiveInstance);
          return exports;
        } catch (e) {
          err('Module.instantiateWasm callback failed with error: ' + e);
          return false;
        }
      }
      instantiateAsync().catch(readyPromiseReject);
      return {};
    }

    var tempDouble;

    var tempI64;

    var ASM_CONSTS = {};

    function callRuntimeCallbacks(callbacks) {
      while (callbacks.length > 0) {
        var callback = callbacks.shift();
        if (typeof callback == 'function') {
          callback(Module);
          continue;
        }
        var func = callback.func;
        if (typeof func === 'number') {
          if (callback.arg === undefined) {
            getWasmTableEntry(func)();
          } else {
            getWasmTableEntry(func)(callback.arg);
          }
        } else {
          func(callback.arg === undefined ? null : callback.arg);
        }
      }
    }

    function withStackSave(f) {
      var stack = stackSave();
      var ret = f();
      stackRestore(stack);
      return ret;
    }

    function demangle(func) {
      warnOnce('warning: build with  -s DEMANGLE_SUPPORT=1  to link in libcxxabi demangling');
      return func;
    }

    function demangleAll(text) {
      var regex = /\b_Z[\w\d_]+/g;
      return text.replace(regex, function (x) {
        var y = demangle(x);
        return x === y ? x : y + ' [' + x + ']';
      });
    }

    var wasmTableMirror = [];

    function getWasmTableEntry(funcPtr) {
      var func = wasmTableMirror[funcPtr];
      if (!func) {
        if (funcPtr >= wasmTableMirror.length) wasmTableMirror.length = funcPtr + 1;
        wasmTableMirror[funcPtr] = func = wasmTable.get(funcPtr);
      }
      assert(wasmTable.get(funcPtr) == func, 'JavaScript-side Wasm function table mirror is out of date!');
      return func;
    }

    function handleException(e) {
      if (e instanceof ExitStatus || e == 'unwind') {
        return EXITSTATUS;
      }
      quit_(1, e);
    }

    function jsStackTrace() {
      var error = new Error();
      if (!error.stack) {
        try {
          throw new Error();
        } catch (e) {
          error = e;
        }
        if (!error.stack) {
          return '(no stack trace available)';
        }
      }
      return error.stack.toString();
    }

    function setWasmTableEntry(idx, func) {
      wasmTable.set(idx, func);
      wasmTableMirror[idx] = func;
    }

    function stackTrace() {
      var js = jsStackTrace();
      if (Module['extraStackTrace']) js += '\n' + Module['extraStackTrace']();
      return demangleAll(js);
    }

    function unSign(value, bits) {
      if (value >= 0) {
        return value;
      }
      return bits <= 32 ? 2 * Math.abs(1 << (bits - 1)) + value : Math.pow(2, bits) + value;
    }

    function _emscripten_memcpy_big(dest, src, num) {
      HEAPU8.copyWithin(dest, src, src + num);
    }

    function abortOnCannotGrowMemory(requestedSize) {
      abort(
        'Cannot enlarge memory arrays to size ' +
          requestedSize +
          ' bytes (OOM). Either (1) compile with  -s INITIAL_MEMORY=X  with X higher than the current value ' +
          HEAP8.length +
          ', (2) compile with  -s ALLOW_MEMORY_GROWTH=1  which allows increasing the size at runtime, or (3) if you want malloc to return NULL (0) instead of this abort, compile with  -s ABORTING_MALLOC=0 ',
      );
    }

    function _emscripten_resize_heap(requestedSize) {
      var oldSize = HEAPU8.length;
      requestedSize = requestedSize >>> 0;
      abortOnCannotGrowMemory(requestedSize);
    }

    var ASSERTIONS = true;

    function intArrayFromString(stringy, dontAddNull, length) {
      var len = length > 0 ? length : lengthBytesUTF8(stringy) + 1;
      var u8array = new Array(len);
      var numBytesWritten = stringToUTF8Array(stringy, u8array, 0, u8array.length);
      if (dontAddNull) u8array.length = numBytesWritten;
      return u8array;
    }

    function intArrayToString(array) {
      var ret = [];
      for (var i = 0; i < array.length; i++) {
        var chr = array[i];
        if (chr > 255) {
          if (ASSERTIONS) {
            assert(
              false,
              'Character code ' + chr + ' (' + String.fromCharCode(chr) + ')  at offset ' + i + ' not in 0x00-0xFF.',
            );
          }
          chr &= 255;
        }
        ret.push(String.fromCharCode(chr));
      }
      return ret.join('');
    }

    var decodeBase64 =
      typeof atob === 'function'
        ? atob
        : function (input) {
            var keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
            var output = '';
            var chr1, chr2, chr3;
            var enc1, enc2, enc3, enc4;
            var i = 0;
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
            do {
              enc1 = keyStr.indexOf(input.charAt(i++));
              enc2 = keyStr.indexOf(input.charAt(i++));
              enc3 = keyStr.indexOf(input.charAt(i++));
              enc4 = keyStr.indexOf(input.charAt(i++));
              chr1 = (enc1 << 2) | (enc2 >> 4);
              chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
              chr3 = ((enc3 & 3) << 6) | enc4;
              output = output + String.fromCharCode(chr1);
              if (enc3 !== 64) {
                output = output + String.fromCharCode(chr2);
              }
              if (enc4 !== 64) {
                output = output + String.fromCharCode(chr3);
              }
            } while (i < input.length);
            return output;
          };

    function intArrayFromBase64(s) {
      try {
        var decoded = decodeBase64(s);
        var bytes = new Uint8Array(decoded.length);
        for (var i = 0; i < decoded.length; ++i) {
          bytes[i] = decoded.charCodeAt(i);
        }
        return bytes;
      } catch (_) {
        throw new Error('Converting base64 string to bytes failed.');
      }
    }

    function tryParseAsDataURI(filename) {
      if (!isDataURI(filename)) {
        return;
      }
      return intArrayFromBase64(filename.slice(dataURIPrefix.length));
    }

    var asmLibraryArg = {
      alignfault: alignfault,
      emscripten_memcpy_big: _emscripten_memcpy_big,
      emscripten_resize_heap: _emscripten_resize_heap,
      getTempRet0: getTempRet0,
      memory: wasmMemory,
      segfault: segfault,
      setTempRet0: setTempRet0,
    };

    var asm = createWasm();

    var ___wasm_call_ctors = (Module['___wasm_call_ctors'] = createExportWrapper('__wasm_call_ctors'));

    var _ComputeSHA256 = (Module['_ComputeSHA256'] = createExportWrapper('ComputeSHA256'));

    var _fflush = (Module['_fflush'] = createExportWrapper('fflush'));

    var ___errno_location = (Module['___errno_location'] = createExportWrapper('__errno_location'));

    var stackSave = (Module['stackSave'] = createExportWrapper('stackSave'));

    var stackRestore = (Module['stackRestore'] = createExportWrapper('stackRestore'));

    var stackAlloc = (Module['stackAlloc'] = createExportWrapper('stackAlloc'));

    var _emscripten_stack_init = (Module['_emscripten_stack_init'] = function () {
      return (_emscripten_stack_init = Module['_emscripten_stack_init'] = Module['asm']['emscripten_stack_init']).apply(
        null,
        arguments,
      );
    });

    var _emscripten_stack_get_free = (Module['_emscripten_stack_get_free'] = function () {
      return (_emscripten_stack_get_free = Module['_emscripten_stack_get_free'] =
        Module['asm']['emscripten_stack_get_free']).apply(null, arguments);
    });

    var _emscripten_stack_get_base = (Module['_emscripten_stack_get_base'] = function () {
      return (_emscripten_stack_get_base = Module['_emscripten_stack_get_base'] =
        Module['asm']['emscripten_stack_get_base']).apply(null, arguments);
    });

    var _emscripten_stack_get_end = (Module['_emscripten_stack_get_end'] = function () {
      return (_emscripten_stack_get_end = Module['_emscripten_stack_get_end'] =
        Module['asm']['emscripten_stack_get_end']).apply(null, arguments);
    });

    var _malloc = (Module['_malloc'] = createExportWrapper('malloc'));

    var _free = (Module['_free'] = createExportWrapper('free'));

    var _emscripten_get_sbrk_ptr = (Module['_emscripten_get_sbrk_ptr'] =
      createExportWrapper('emscripten_get_sbrk_ptr'));

    var _sbrk = (Module['_sbrk'] = createExportWrapper('sbrk'));

    if (!Object.getOwnPropertyDescriptor(Module, 'intArrayFromString'))
      Module['intArrayFromString'] = function () {
        abort("'intArrayFromString' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'intArrayToString'))
      Module['intArrayToString'] = function () {
        abort("'intArrayToString' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'ccall'))
      Module['ccall'] = function () {
        abort("'ccall' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    Module['cwrap'] = cwrap;

    if (!Object.getOwnPropertyDescriptor(Module, 'setValue'))
      Module['setValue'] = function () {
        abort("'setValue' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'getValue'))
      Module['getValue'] = function () {
        abort("'getValue' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'allocate'))
      Module['allocate'] = function () {
        abort("'allocate' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'UTF8ArrayToString'))
      Module['UTF8ArrayToString'] = function () {
        abort("'UTF8ArrayToString' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'UTF8ToString'))
      Module['UTF8ToString'] = function () {
        abort("'UTF8ToString' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'stringToUTF8Array'))
      Module['stringToUTF8Array'] = function () {
        abort("'stringToUTF8Array' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'stringToUTF8'))
      Module['stringToUTF8'] = function () {
        abort("'stringToUTF8' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'lengthBytesUTF8'))
      Module['lengthBytesUTF8'] = function () {
        abort("'lengthBytesUTF8' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'stackTrace'))
      Module['stackTrace'] = function () {
        abort("'stackTrace' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'addOnPreRun'))
      Module['addOnPreRun'] = function () {
        abort("'addOnPreRun' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'addOnInit'))
      Module['addOnInit'] = function () {
        abort("'addOnInit' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'addOnPreMain'))
      Module['addOnPreMain'] = function () {
        abort("'addOnPreMain' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'addOnExit'))
      Module['addOnExit'] = function () {
        abort("'addOnExit' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'addOnPostRun'))
      Module['addOnPostRun'] = function () {
        abort("'addOnPostRun' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'writeStringToMemory'))
      Module['writeStringToMemory'] = function () {
        abort("'writeStringToMemory' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'writeArrayToMemory'))
      Module['writeArrayToMemory'] = function () {
        abort("'writeArrayToMemory' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'writeAsciiToMemory'))
      Module['writeAsciiToMemory'] = function () {
        abort("'writeAsciiToMemory' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'addRunDependency'))
      Module['addRunDependency'] = function () {
        abort(
          "'addRunDependency' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ). Alternatively, forcing filesystem support (-s FORCE_FILESYSTEM=1) can export this for you",
        );
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'removeRunDependency'))
      Module['removeRunDependency'] = function () {
        abort(
          "'removeRunDependency' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ). Alternatively, forcing filesystem support (-s FORCE_FILESYSTEM=1) can export this for you",
        );
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'FS_createFolder'))
      Module['FS_createFolder'] = function () {
        abort("'FS_createFolder' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'FS_createPath'))
      Module['FS_createPath'] = function () {
        abort(
          "'FS_createPath' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ). Alternatively, forcing filesystem support (-s FORCE_FILESYSTEM=1) can export this for you",
        );
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'FS_createDataFile'))
      Module['FS_createDataFile'] = function () {
        abort(
          "'FS_createDataFile' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ). Alternatively, forcing filesystem support (-s FORCE_FILESYSTEM=1) can export this for you",
        );
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'FS_createPreloadedFile'))
      Module['FS_createPreloadedFile'] = function () {
        abort(
          "'FS_createPreloadedFile' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ). Alternatively, forcing filesystem support (-s FORCE_FILESYSTEM=1) can export this for you",
        );
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'FS_createLazyFile'))
      Module['FS_createLazyFile'] = function () {
        abort(
          "'FS_createLazyFile' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ). Alternatively, forcing filesystem support (-s FORCE_FILESYSTEM=1) can export this for you",
        );
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'FS_createLink'))
      Module['FS_createLink'] = function () {
        abort("'FS_createLink' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'FS_createDevice'))
      Module['FS_createDevice'] = function () {
        abort(
          "'FS_createDevice' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ). Alternatively, forcing filesystem support (-s FORCE_FILESYSTEM=1) can export this for you",
        );
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'FS_unlink'))
      Module['FS_unlink'] = function () {
        abort(
          "'FS_unlink' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ). Alternatively, forcing filesystem support (-s FORCE_FILESYSTEM=1) can export this for you",
        );
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'getLEB'))
      Module['getLEB'] = function () {
        abort("'getLEB' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'getFunctionTables'))
      Module['getFunctionTables'] = function () {
        abort("'getFunctionTables' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'alignFunctionTables'))
      Module['alignFunctionTables'] = function () {
        abort("'alignFunctionTables' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'registerFunctions'))
      Module['registerFunctions'] = function () {
        abort("'registerFunctions' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'addFunction'))
      Module['addFunction'] = function () {
        abort("'addFunction' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'removeFunction'))
      Module['removeFunction'] = function () {
        abort("'removeFunction' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'getFuncWrapper'))
      Module['getFuncWrapper'] = function () {
        abort("'getFuncWrapper' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'prettyPrint'))
      Module['prettyPrint'] = function () {
        abort("'prettyPrint' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'dynCall'))
      Module['dynCall'] = function () {
        abort("'dynCall' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'getCompilerSetting'))
      Module['getCompilerSetting'] = function () {
        abort("'getCompilerSetting' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'print'))
      Module['print'] = function () {
        abort("'print' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'printErr'))
      Module['printErr'] = function () {
        abort("'printErr' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'getTempRet0'))
      Module['getTempRet0'] = function () {
        abort("'getTempRet0' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'setTempRet0'))
      Module['setTempRet0'] = function () {
        abort("'setTempRet0' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'callMain'))
      Module['callMain'] = function () {
        abort("'callMain' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'abort'))
      Module['abort'] = function () {
        abort("'abort' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'keepRuntimeAlive'))
      Module['keepRuntimeAlive'] = function () {
        abort("'keepRuntimeAlive' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'zeroMemory'))
      Module['zeroMemory'] = function () {
        abort("'zeroMemory' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'stringToNewUTF8'))
      Module['stringToNewUTF8'] = function () {
        abort("'stringToNewUTF8' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'setFileTime'))
      Module['setFileTime'] = function () {
        abort("'setFileTime' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'abortOnCannotGrowMemory'))
      Module['abortOnCannotGrowMemory'] = function () {
        abort("'abortOnCannotGrowMemory' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'emscripten_realloc_buffer'))
      Module['emscripten_realloc_buffer'] = function () {
        abort("'emscripten_realloc_buffer' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'ENV'))
      Module['ENV'] = function () {
        abort("'ENV' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'withStackSave'))
      Module['withStackSave'] = function () {
        abort("'withStackSave' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'ERRNO_CODES'))
      Module['ERRNO_CODES'] = function () {
        abort("'ERRNO_CODES' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'ERRNO_MESSAGES'))
      Module['ERRNO_MESSAGES'] = function () {
        abort("'ERRNO_MESSAGES' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'setErrNo'))
      Module['setErrNo'] = function () {
        abort("'setErrNo' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'inetPton4'))
      Module['inetPton4'] = function () {
        abort("'inetPton4' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'inetNtop4'))
      Module['inetNtop4'] = function () {
        abort("'inetNtop4' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'inetPton6'))
      Module['inetPton6'] = function () {
        abort("'inetPton6' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'inetNtop6'))
      Module['inetNtop6'] = function () {
        abort("'inetNtop6' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'readSockaddr'))
      Module['readSockaddr'] = function () {
        abort("'readSockaddr' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'writeSockaddr'))
      Module['writeSockaddr'] = function () {
        abort("'writeSockaddr' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'DNS'))
      Module['DNS'] = function () {
        abort("'DNS' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'getHostByName'))
      Module['getHostByName'] = function () {
        abort("'getHostByName' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'GAI_ERRNO_MESSAGES'))
      Module['GAI_ERRNO_MESSAGES'] = function () {
        abort("'GAI_ERRNO_MESSAGES' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'Protocols'))
      Module['Protocols'] = function () {
        abort("'Protocols' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'Sockets'))
      Module['Sockets'] = function () {
        abort("'Sockets' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'getRandomDevice'))
      Module['getRandomDevice'] = function () {
        abort("'getRandomDevice' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'traverseStack'))
      Module['traverseStack'] = function () {
        abort("'traverseStack' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'UNWIND_CACHE'))
      Module['UNWIND_CACHE'] = function () {
        abort("'UNWIND_CACHE' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'readAsmConstArgsArray'))
      Module['readAsmConstArgsArray'] = function () {
        abort("'readAsmConstArgsArray' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'readAsmConstArgs'))
      Module['readAsmConstArgs'] = function () {
        abort("'readAsmConstArgs' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'mainThreadEM_ASM'))
      Module['mainThreadEM_ASM'] = function () {
        abort("'mainThreadEM_ASM' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'jstoi_q'))
      Module['jstoi_q'] = function () {
        abort("'jstoi_q' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'jstoi_s'))
      Module['jstoi_s'] = function () {
        abort("'jstoi_s' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'getExecutableName'))
      Module['getExecutableName'] = function () {
        abort("'getExecutableName' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'listenOnce'))
      Module['listenOnce'] = function () {
        abort("'listenOnce' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'autoResumeAudioContext'))
      Module['autoResumeAudioContext'] = function () {
        abort("'autoResumeAudioContext' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'dynCallLegacy'))
      Module['dynCallLegacy'] = function () {
        abort("'dynCallLegacy' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'getDynCaller'))
      Module['getDynCaller'] = function () {
        abort("'getDynCaller' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'dynCall'))
      Module['dynCall'] = function () {
        abort("'dynCall' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'callRuntimeCallbacks'))
      Module['callRuntimeCallbacks'] = function () {
        abort("'callRuntimeCallbacks' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'wasmTableMirror'))
      Module['wasmTableMirror'] = function () {
        abort("'wasmTableMirror' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'setWasmTableEntry'))
      Module['setWasmTableEntry'] = function () {
        abort("'setWasmTableEntry' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'getWasmTableEntry'))
      Module['getWasmTableEntry'] = function () {
        abort("'getWasmTableEntry' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'handleException'))
      Module['handleException'] = function () {
        abort("'handleException' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'runtimeKeepalivePush'))
      Module['runtimeKeepalivePush'] = function () {
        abort("'runtimeKeepalivePush' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'runtimeKeepalivePop'))
      Module['runtimeKeepalivePop'] = function () {
        abort("'runtimeKeepalivePop' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'callUserCallback'))
      Module['callUserCallback'] = function () {
        abort("'callUserCallback' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'maybeExit'))
      Module['maybeExit'] = function () {
        abort("'maybeExit' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'safeSetTimeout'))
      Module['safeSetTimeout'] = function () {
        abort("'safeSetTimeout' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'asmjsMangle'))
      Module['asmjsMangle'] = function () {
        abort("'asmjsMangle' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'asyncLoad'))
      Module['asyncLoad'] = function () {
        abort("'asyncLoad' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'alignMemory'))
      Module['alignMemory'] = function () {
        abort("'alignMemory' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'mmapAlloc'))
      Module['mmapAlloc'] = function () {
        abort("'mmapAlloc' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'reallyNegative'))
      Module['reallyNegative'] = function () {
        abort("'reallyNegative' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'unSign'))
      Module['unSign'] = function () {
        abort("'unSign' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'reSign'))
      Module['reSign'] = function () {
        abort("'reSign' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'formatString'))
      Module['formatString'] = function () {
        abort("'formatString' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'PATH'))
      Module['PATH'] = function () {
        abort("'PATH' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'PATH_FS'))
      Module['PATH_FS'] = function () {
        abort("'PATH_FS' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'SYSCALLS'))
      Module['SYSCALLS'] = function () {
        abort("'SYSCALLS' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'syscallMmap2'))
      Module['syscallMmap2'] = function () {
        abort("'syscallMmap2' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'syscallMunmap'))
      Module['syscallMunmap'] = function () {
        abort("'syscallMunmap' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'getSocketFromFD'))
      Module['getSocketFromFD'] = function () {
        abort("'getSocketFromFD' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'getSocketAddress'))
      Module['getSocketAddress'] = function () {
        abort("'getSocketAddress' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'JSEvents'))
      Module['JSEvents'] = function () {
        abort("'JSEvents' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'registerKeyEventCallback'))
      Module['registerKeyEventCallback'] = function () {
        abort("'registerKeyEventCallback' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'specialHTMLTargets'))
      Module['specialHTMLTargets'] = function () {
        abort("'specialHTMLTargets' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'maybeCStringToJsString'))
      Module['maybeCStringToJsString'] = function () {
        abort("'maybeCStringToJsString' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'findEventTarget'))
      Module['findEventTarget'] = function () {
        abort("'findEventTarget' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'findCanvasEventTarget'))
      Module['findCanvasEventTarget'] = function () {
        abort("'findCanvasEventTarget' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'getBoundingClientRect'))
      Module['getBoundingClientRect'] = function () {
        abort("'getBoundingClientRect' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'fillMouseEventData'))
      Module['fillMouseEventData'] = function () {
        abort("'fillMouseEventData' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'registerMouseEventCallback'))
      Module['registerMouseEventCallback'] = function () {
        abort("'registerMouseEventCallback' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'registerWheelEventCallback'))
      Module['registerWheelEventCallback'] = function () {
        abort("'registerWheelEventCallback' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'registerUiEventCallback'))
      Module['registerUiEventCallback'] = function () {
        abort("'registerUiEventCallback' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'registerFocusEventCallback'))
      Module['registerFocusEventCallback'] = function () {
        abort("'registerFocusEventCallback' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'fillDeviceOrientationEventData'))
      Module['fillDeviceOrientationEventData'] = function () {
        abort("'fillDeviceOrientationEventData' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'registerDeviceOrientationEventCallback'))
      Module['registerDeviceOrientationEventCallback'] = function () {
        abort(
          "'registerDeviceOrientationEventCallback' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)",
        );
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'fillDeviceMotionEventData'))
      Module['fillDeviceMotionEventData'] = function () {
        abort("'fillDeviceMotionEventData' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'registerDeviceMotionEventCallback'))
      Module['registerDeviceMotionEventCallback'] = function () {
        abort("'registerDeviceMotionEventCallback' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'screenOrientation'))
      Module['screenOrientation'] = function () {
        abort("'screenOrientation' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'fillOrientationChangeEventData'))
      Module['fillOrientationChangeEventData'] = function () {
        abort("'fillOrientationChangeEventData' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'registerOrientationChangeEventCallback'))
      Module['registerOrientationChangeEventCallback'] = function () {
        abort(
          "'registerOrientationChangeEventCallback' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)",
        );
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'fillFullscreenChangeEventData'))
      Module['fillFullscreenChangeEventData'] = function () {
        abort("'fillFullscreenChangeEventData' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'registerFullscreenChangeEventCallback'))
      Module['registerFullscreenChangeEventCallback'] = function () {
        abort(
          "'registerFullscreenChangeEventCallback' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)",
        );
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'registerRestoreOldStyle'))
      Module['registerRestoreOldStyle'] = function () {
        abort("'registerRestoreOldStyle' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'hideEverythingExceptGivenElement'))
      Module['hideEverythingExceptGivenElement'] = function () {
        abort("'hideEverythingExceptGivenElement' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'restoreHiddenElements'))
      Module['restoreHiddenElements'] = function () {
        abort("'restoreHiddenElements' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'setLetterbox'))
      Module['setLetterbox'] = function () {
        abort("'setLetterbox' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'currentFullscreenStrategy'))
      Module['currentFullscreenStrategy'] = function () {
        abort("'currentFullscreenStrategy' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'restoreOldWindowedStyle'))
      Module['restoreOldWindowedStyle'] = function () {
        abort("'restoreOldWindowedStyle' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'softFullscreenResizeWebGLRenderTarget'))
      Module['softFullscreenResizeWebGLRenderTarget'] = function () {
        abort(
          "'softFullscreenResizeWebGLRenderTarget' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)",
        );
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'doRequestFullscreen'))
      Module['doRequestFullscreen'] = function () {
        abort("'doRequestFullscreen' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'fillPointerlockChangeEventData'))
      Module['fillPointerlockChangeEventData'] = function () {
        abort("'fillPointerlockChangeEventData' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'registerPointerlockChangeEventCallback'))
      Module['registerPointerlockChangeEventCallback'] = function () {
        abort(
          "'registerPointerlockChangeEventCallback' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)",
        );
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'registerPointerlockErrorEventCallback'))
      Module['registerPointerlockErrorEventCallback'] = function () {
        abort(
          "'registerPointerlockErrorEventCallback' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)",
        );
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'requestPointerLock'))
      Module['requestPointerLock'] = function () {
        abort("'requestPointerLock' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'fillVisibilityChangeEventData'))
      Module['fillVisibilityChangeEventData'] = function () {
        abort("'fillVisibilityChangeEventData' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'registerVisibilityChangeEventCallback'))
      Module['registerVisibilityChangeEventCallback'] = function () {
        abort(
          "'registerVisibilityChangeEventCallback' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)",
        );
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'registerTouchEventCallback'))
      Module['registerTouchEventCallback'] = function () {
        abort("'registerTouchEventCallback' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'fillGamepadEventData'))
      Module['fillGamepadEventData'] = function () {
        abort("'fillGamepadEventData' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'registerGamepadEventCallback'))
      Module['registerGamepadEventCallback'] = function () {
        abort("'registerGamepadEventCallback' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'registerBeforeUnloadEventCallback'))
      Module['registerBeforeUnloadEventCallback'] = function () {
        abort("'registerBeforeUnloadEventCallback' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'fillBatteryEventData'))
      Module['fillBatteryEventData'] = function () {
        abort("'fillBatteryEventData' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'battery'))
      Module['battery'] = function () {
        abort("'battery' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'registerBatteryEventCallback'))
      Module['registerBatteryEventCallback'] = function () {
        abort("'registerBatteryEventCallback' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'setCanvasElementSize'))
      Module['setCanvasElementSize'] = function () {
        abort("'setCanvasElementSize' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'getCanvasElementSize'))
      Module['getCanvasElementSize'] = function () {
        abort("'getCanvasElementSize' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'demangle'))
      Module['demangle'] = function () {
        abort("'demangle' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'demangleAll'))
      Module['demangleAll'] = function () {
        abort("'demangleAll' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'jsStackTrace'))
      Module['jsStackTrace'] = function () {
        abort("'jsStackTrace' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'stackTrace'))
      Module['stackTrace'] = function () {
        abort("'stackTrace' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'getEnvStrings'))
      Module['getEnvStrings'] = function () {
        abort("'getEnvStrings' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'checkWasiClock'))
      Module['checkWasiClock'] = function () {
        abort("'checkWasiClock' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'flush_NO_FILESYSTEM'))
      Module['flush_NO_FILESYSTEM'] = function () {
        abort("'flush_NO_FILESYSTEM' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'writeI53ToI64'))
      Module['writeI53ToI64'] = function () {
        abort("'writeI53ToI64' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'writeI53ToI64Clamped'))
      Module['writeI53ToI64Clamped'] = function () {
        abort("'writeI53ToI64Clamped' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'writeI53ToI64Signaling'))
      Module['writeI53ToI64Signaling'] = function () {
        abort("'writeI53ToI64Signaling' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'writeI53ToU64Clamped'))
      Module['writeI53ToU64Clamped'] = function () {
        abort("'writeI53ToU64Clamped' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'writeI53ToU64Signaling'))
      Module['writeI53ToU64Signaling'] = function () {
        abort("'writeI53ToU64Signaling' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'readI53FromI64'))
      Module['readI53FromI64'] = function () {
        abort("'readI53FromI64' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'readI53FromU64'))
      Module['readI53FromU64'] = function () {
        abort("'readI53FromU64' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'convertI32PairToI53'))
      Module['convertI32PairToI53'] = function () {
        abort("'convertI32PairToI53' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'convertU32PairToI53'))
      Module['convertU32PairToI53'] = function () {
        abort("'convertU32PairToI53' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'setImmediateWrapped'))
      Module['setImmediateWrapped'] = function () {
        abort("'setImmediateWrapped' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'clearImmediateWrapped'))
      Module['clearImmediateWrapped'] = function () {
        abort("'clearImmediateWrapped' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'polyfillSetImmediate'))
      Module['polyfillSetImmediate'] = function () {
        abort("'polyfillSetImmediate' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'uncaughtExceptionCount'))
      Module['uncaughtExceptionCount'] = function () {
        abort("'uncaughtExceptionCount' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'exceptionLast'))
      Module['exceptionLast'] = function () {
        abort("'exceptionLast' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'exceptionCaught'))
      Module['exceptionCaught'] = function () {
        abort("'exceptionCaught' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'ExceptionInfo'))
      Module['ExceptionInfo'] = function () {
        abort("'ExceptionInfo' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'CatchInfo'))
      Module['CatchInfo'] = function () {
        abort("'CatchInfo' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'exception_addRef'))
      Module['exception_addRef'] = function () {
        abort("'exception_addRef' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'exception_decRef'))
      Module['exception_decRef'] = function () {
        abort("'exception_decRef' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'Browser'))
      Module['Browser'] = function () {
        abort("'Browser' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'funcWrappers'))
      Module['funcWrappers'] = function () {
        abort("'funcWrappers' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'getFuncWrapper'))
      Module['getFuncWrapper'] = function () {
        abort("'getFuncWrapper' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'setMainLoop'))
      Module['setMainLoop'] = function () {
        abort("'setMainLoop' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'wget'))
      Module['wget'] = function () {
        abort("'wget' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'FS'))
      Module['FS'] = function () {
        abort("'FS' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'MEMFS'))
      Module['MEMFS'] = function () {
        abort("'MEMFS' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'TTY'))
      Module['TTY'] = function () {
        abort("'TTY' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'PIPEFS'))
      Module['PIPEFS'] = function () {
        abort("'PIPEFS' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'SOCKFS'))
      Module['SOCKFS'] = function () {
        abort("'SOCKFS' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, '_setNetworkCallback'))
      Module['_setNetworkCallback'] = function () {
        abort("'_setNetworkCallback' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'tempFixedLengthArray'))
      Module['tempFixedLengthArray'] = function () {
        abort("'tempFixedLengthArray' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'miniTempWebGLFloatBuffers'))
      Module['miniTempWebGLFloatBuffers'] = function () {
        abort("'miniTempWebGLFloatBuffers' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'heapObjectForWebGLType'))
      Module['heapObjectForWebGLType'] = function () {
        abort("'heapObjectForWebGLType' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'heapAccessShiftForWebGLHeap'))
      Module['heapAccessShiftForWebGLHeap'] = function () {
        abort("'heapAccessShiftForWebGLHeap' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'GL'))
      Module['GL'] = function () {
        abort("'GL' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'emscriptenWebGLGet'))
      Module['emscriptenWebGLGet'] = function () {
        abort("'emscriptenWebGLGet' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'computeUnpackAlignedImageSize'))
      Module['computeUnpackAlignedImageSize'] = function () {
        abort("'computeUnpackAlignedImageSize' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'emscriptenWebGLGetTexPixelData'))
      Module['emscriptenWebGLGetTexPixelData'] = function () {
        abort("'emscriptenWebGLGetTexPixelData' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'emscriptenWebGLGetUniform'))
      Module['emscriptenWebGLGetUniform'] = function () {
        abort("'emscriptenWebGLGetUniform' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'webglGetUniformLocation'))
      Module['webglGetUniformLocation'] = function () {
        abort("'webglGetUniformLocation' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'webglPrepareUniformLocationsBeforeFirstUse'))
      Module['webglPrepareUniformLocationsBeforeFirstUse'] = function () {
        abort(
          "'webglPrepareUniformLocationsBeforeFirstUse' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)",
        );
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'webglGetLeftBracePos'))
      Module['webglGetLeftBracePos'] = function () {
        abort("'webglGetLeftBracePos' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'emscriptenWebGLGetVertexAttrib'))
      Module['emscriptenWebGLGetVertexAttrib'] = function () {
        abort("'emscriptenWebGLGetVertexAttrib' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'writeGLArray'))
      Module['writeGLArray'] = function () {
        abort("'writeGLArray' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'AL'))
      Module['AL'] = function () {
        abort("'AL' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'SDL_unicode'))
      Module['SDL_unicode'] = function () {
        abort("'SDL_unicode' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'SDL_ttfContext'))
      Module['SDL_ttfContext'] = function () {
        abort("'SDL_ttfContext' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'SDL_audio'))
      Module['SDL_audio'] = function () {
        abort("'SDL_audio' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'SDL'))
      Module['SDL'] = function () {
        abort("'SDL' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'SDL_gfx'))
      Module['SDL_gfx'] = function () {
        abort("'SDL_gfx' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'GLUT'))
      Module['GLUT'] = function () {
        abort("'GLUT' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'EGL'))
      Module['EGL'] = function () {
        abort("'EGL' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'GLFW_Window'))
      Module['GLFW_Window'] = function () {
        abort("'GLFW_Window' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'GLFW'))
      Module['GLFW'] = function () {
        abort("'GLFW' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'GLEW'))
      Module['GLEW'] = function () {
        abort("'GLEW' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'IDBStore'))
      Module['IDBStore'] = function () {
        abort("'IDBStore' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'runAndAbortIfError'))
      Module['runAndAbortIfError'] = function () {
        abort("'runAndAbortIfError' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'warnOnce'))
      Module['warnOnce'] = function () {
        abort("'warnOnce' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'stackSave'))
      Module['stackSave'] = function () {
        abort("'stackSave' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'stackRestore'))
      Module['stackRestore'] = function () {
        abort("'stackRestore' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'stackAlloc'))
      Module['stackAlloc'] = function () {
        abort("'stackAlloc' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'AsciiToString'))
      Module['AsciiToString'] = function () {
        abort("'AsciiToString' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'stringToAscii'))
      Module['stringToAscii'] = function () {
        abort("'stringToAscii' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'UTF16ToString'))
      Module['UTF16ToString'] = function () {
        abort("'UTF16ToString' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'stringToUTF16'))
      Module['stringToUTF16'] = function () {
        abort("'stringToUTF16' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'lengthBytesUTF16'))
      Module['lengthBytesUTF16'] = function () {
        abort("'lengthBytesUTF16' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'UTF32ToString'))
      Module['UTF32ToString'] = function () {
        abort("'UTF32ToString' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'stringToUTF32'))
      Module['stringToUTF32'] = function () {
        abort("'stringToUTF32' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'lengthBytesUTF32'))
      Module['lengthBytesUTF32'] = function () {
        abort("'lengthBytesUTF32' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'allocateUTF8'))
      Module['allocateUTF8'] = function () {
        abort("'allocateUTF8' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'allocateUTF8OnStack'))
      Module['allocateUTF8OnStack'] = function () {
        abort("'allocateUTF8OnStack' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    Module['writeStackCookie'] = writeStackCookie;

    Module['checkStackCookie'] = checkStackCookie;

    if (!Object.getOwnPropertyDescriptor(Module, 'intArrayFromBase64'))
      Module['intArrayFromBase64'] = function () {
        abort("'intArrayFromBase64' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'tryParseAsDataURI'))
      Module['tryParseAsDataURI'] = function () {
        abort("'tryParseAsDataURI' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
      };

    if (!Object.getOwnPropertyDescriptor(Module, 'ALLOC_NORMAL'))
      Object.defineProperty(Module, 'ALLOC_NORMAL', {
        configurable: true,
        get: function () {
          abort("'ALLOC_NORMAL' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
        },
      });

    if (!Object.getOwnPropertyDescriptor(Module, 'ALLOC_STACK'))
      Object.defineProperty(Module, 'ALLOC_STACK', {
        configurable: true,
        get: function () {
          abort("'ALLOC_STACK' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the FAQ)");
        },
      });

    var calledRun;

    function ExitStatus(status) {
      this.name = 'ExitStatus';
      this.message = 'Program terminated with exit(' + status + ')';
      this.status = status;
    }

    var calledMain = false;

    dependenciesFulfilled = function runCaller() {
      if (!calledRun) run();
      if (!calledRun) dependenciesFulfilled = runCaller;
    };

    function stackCheckInit() {
      _emscripten_stack_init();
      writeStackCookie();
    }

    function run(args) {
      args = args || arguments_;
      if (runDependencies > 0) {
        return;
      }
      stackCheckInit();
      preRun();
      if (runDependencies > 0) {
        return;
      }
      function doRun() {
        if (calledRun) return;
        calledRun = true;
        Module['calledRun'] = true;
        if (ABORT) return;
        initRuntime();
        readyPromiseResolve(Module);
        if (Module['onRuntimeInitialized']) Module['onRuntimeInitialized']();
        assert(
          !Module['_main'],
          'compiled without a main, but one is present. if you added it from JS, use Module["onRuntimeInitialized"]',
        );
        postRun();
      }
      if (Module['setStatus']) {
        Module['setStatus']('Running...');
        setTimeout(function () {
          setTimeout(function () {
            Module['setStatus']('');
          }, 1);
          doRun();
        }, 1);
      } else {
        doRun();
      }
      checkStackCookie();
    }

    Module['run'] = run;

    function checkUnflushedContent() {
      var oldOut = out;
      var oldErr = err;
      var has = false;
      out = err = function (x) {
        has = true;
      };
      try {
        var flush = null;
        if (flush) flush();
      } catch (e) {}
      out = oldOut;
      err = oldErr;
      if (has) {
        warnOnce(
          'stdio streams had content in them that was not flushed. you should set EXIT_RUNTIME to 1 (see the FAQ), or make sure to emit a newline when you printf etc.',
        );
        warnOnce(
          '(this may also be due to not including full filesystem support - try building with -s FORCE_FILESYSTEM=1)',
        );
      }
    }

    function exit(status, implicit) {
      EXITSTATUS = status;
      checkUnflushedContent();
      if (keepRuntimeAlive()) {
        if (!implicit) {
          var msg =
            'program exited (with status: ' +
            status +
            '), but EXIT_RUNTIME is not set, so halting execution but not exiting the runtime or preventing further async execution (build with EXIT_RUNTIME=1, if you want a true shutdown)';
          readyPromiseReject(msg);
          err(msg);
        }
      } else {
        exitRuntime();
      }
      procExit(status);
    }

    function procExit(code) {
      EXITSTATUS = code;
      if (!keepRuntimeAlive()) {
        if (Module['onExit']) Module['onExit'](code);
        ABORT = true;
      }
      quit_(code, new ExitStatus(code));
    }

    if (Module['preInit']) {
      if (typeof Module['preInit'] == 'function') Module['preInit'] = [Module['preInit']];
      while (Module['preInit'].length > 0) {
        Module['preInit'].pop()();
      }
    }

    run();

    return createModuleSha256.ready;
  };
})();
if (typeof exports === 'object' && typeof module === 'object') module.exports = createModuleSha256;
else if (typeof define === 'function' && define['amd'])
  define([], function () {
    return createModuleSha256;
  });
else if (typeof exports === 'object') exports['createModuleSha256'] = createModuleSha256;
